{
	"F-is-a-wildcard-for-any-character": "'F' is a wildcard for \"any character\".",
	"REMOTE_READ_ONLY": "Read",
	"REMOTE_READ_WRITE": "Read & Write",
	"_box": "box",
	"_boxes": "boxes",
	"_generic": "generic",
	"_generic-plural": "genericPlural",
	"_hub": "hub",
	"_hubs": "hubs",
	"about-commands": "About Commands",
	"about-events": "About Events",
	"about-routing-table": "About routing tables",
	"access-point-name": "Access Point Name (APN)",
	"access-the-schedule": "Access the schedule",
	"access-token": "Access token",
	"access-type": "Access Type",
	"access-type-error": "Incorrect access type",
	"access-type-is-remote": "Remote access to the property and its values",
	"access-type-is-remote-help": "Select yes for the property values to be sent to the cloud or to be able to write from the cloud the value of the property. The values are always available in read and write inside the device (local)",
	"access-type-is-remote-hub": "Remote access to the property and its values when the reception is enabled",
	"acknowledge-alert": "Acknowledge the alert",
	"acknowledged": "Acknowledged",
	"acted-as": "acted as",
	"action-time": "Action Time",
	"actions": "Actions",
	"activate": "Activate",
	"activate-account": "Activate your account here",
	"activate-box-hub": "Activate {box}",
	"activate-bulk-actions": "Select items in the table to enable \nbulk actions",
	"activate-reception-property-data-60-minutes": "Enable reception property values for 60 minutes",
	"activate-reception-property-data-eth.active.1": "@.capitalize:box connected to console.",
	"activate-reception-property-data-sim": "Activate communication via the SIM card to connect the @.lower:box to the console and receive property values (Limited to 30 activations over 7 days in a row)",
	"activate-reception-property-data-sim.active.1": "@.capitalize:box connected to console via the SIM card.",
	"activate-reception-property-data-sim.duration": "Connection time: 60 minutes",
	"activate-reception-property-data.active.2": "Property data is received.",
	"activate-reception-property-data.error.rate-limit.1": "Data can no longer be received.",
	"activate-reception-property-data.error.rate-limit.2": "You have reached the limit of data reception activations (30 times over 7 calendar days).",
	"activation-method": "Activation Method",
	"activation-method-tooltip": "Method to use to activate the device (provided by manufacturer), usually OTAA",
	"active": "Active",
	"add": "Add",
	"add-a-box": "Add a @.clientname:_box",
	"add-a-condition": "Add a condition",
	"add-a-connector": "Add a connector",
	"add-a-property": "Add property",
	"add-a-recipient": "Add recipient",
	"add-a-route": "Add a route",
	"add-a-slot": "Add a slot",
	"add-a-trigger": "Add a trigger",
	"add-alarm": "Add an alarm",
	"add-an-action": "Add an action",
	"add-another-device": "Add another device",
	"add-another-equipment": "Add another equipment",
	"add-another-licence": "Add another license",
	"add-archive-recurring-request": "Request recurring archive",
	"add-archive-request": "Request archive",
	"add-bacnet-server-property": "Redirect a schedule stored in a controller",
	"add-boxes": "Add @.capitalize:boxes",
	"add-boxes-to-the-trigger": "Add the @.capitalize:boxes to the trigger",
	"add-config-link": "Add a link to redirect to the configuration",
	"add-custom-slug": "Add Custom Slug",
	"add-dashboard": "Add dashboard",
	"add-device": "Add Device",
	"add-equipment": "Add equipment",
	"add-equipment-to-network": "add equipment to network",
	"add-equipment.advanced-description": "Add an equipment by specifying all its details manually.",
	"add-equipment.bulk-creation": "Bulk creation",
	"add-equipment.bulk-creation.bacnet": "Import EDE BACnet file",
	"add-equipment.bulk-creation.bacnet-description": "Use the result of a previous BACnet scan in EDE format.",
	"add-equipment.bulk-creation.knx": "ETS (KNX) project",
	"add-equipment.bulk-creation.knx-description": "Export a list of group address from ETS and upload the XML file.",
	"add-equipment.bulk-creation.lorawan": "LoRaWAN bulk creation",
	"add-equipment.bulk-creation.lorawan-description": "Upload a CSV file with the details of the equipment.",
	"add-equipment.preconfigured-description": "The equipment properties will be available straight away. Available with these protocols: LoRaWAN, LPB (RVL), KNX (Synco) and ModBus (both RTU and TCP/IP).",
	"add-equipment.preconfigured-list": "Decoded equipment library",
	"add-equipment.preconfigured-pick": "Pick a decoded equipment",
	"add-equipment.scan": "Scan",
	"add-equipment.scan.bacnet": "Scan a BACnet network",
	"add-equipment.scan.bacnet-description": "Trigger a scan on the BACnet network. The equipment and their properties will be listed.",
	"add-equipment.scan.mbus": "Scan a M-Bus network",
	"add-equipment.scan.mbus-description": "Trigger a scan on the M-Bus network. The equipment and their properties will be listed.",
	"add-event": "Add event",
	"add-graph": "Add graph",
	"add-history-link": "Add a link to redirect to the latest values",
	"add-licence": "Add License",
	"add-network": "Add network",
	"add-network-to-equipment": "Add network to equipment",
	"add-new-box-privileges": "Add box",
	"add-new-dashboard": "Dashboard",
	"add-new-tag": "Add new Tag",
	"add-properties": "Add Properties",
	"add-property": "Add Property",
	"add-property-bulk": "Bulk create {type} properties",
	"add-property-bulk.instructions.decimals": "Use point (0.01) as separator for decimal numbers",
	"add-property-bulk.instructions.template": "{template} complete it with the properties you need.",
	"add-property-bulk.instructions.value-list": "Authorized values:",
	"add-property-from-list": "Add Property from the list",
	"add-property-to-graph": "Add property to graph",
	"add-recipient": "Add another recipient",
	"add-tag": "Add Tag",
	"add-to-graph": "Add to graph",
	"add-user": "Add user",
	"add-user-to-organization": "Add user to organization",
	"add-widget": "Add widget",
	"added": "added",
	"addons": "Addons",
	"address": "Address",
	"address-mbus-range-1-to-250": "Address of M-Bus equipment in a range from 1 to 250",
	"admin-account-details-for-new-organization": "Admin account details for the new organization",
	"advanced": "Advanced",
	"advanced-mode": "Advanced Mode",
	"advanced-settings": "Advanced settings",
	"aggregation-picker-tooltip-with-interval": "Please disable the delta to apply an aggregation",
	"alarm": "Alarm",
	"alarm-SMS-notification-frequency-error-msg": "Must be minimum 24 hours",
	"alarm-boolean-constraint-OFF-tooltip": "The alarm will be triggered when the value is False",
	"alarm-boolean-constraint-ON-tooltip": "The alarm will be triggered when the value is True",
	"alarm-box_connection_status-OFF": "@.capitalize:box disconnected",
	"alarm-condition-help-text": "The alarm triggers when...",
	"alarm-deleted": "Alarm deleted",
	"alarm-equipment-down-scenario": "Down",
	"alarm-equipment-status-notification-frequency-error-msg": "Must be minimum 6 hours",
	"alarm-event-updated": "Alarm event updated",
	"alarm-history-status-ACKNOWLEDGED": "Acknowledged",
	"alarm-history-status-ARCHIVED": "Archived",
	"alarm-history-status-CLOSED": "Closed",
	"alarm-history-status-DISABLED": "Disabled",
	"alarm-history-status-OPEN": "Open",
	"alarm-map-banner-msg": "One or more alarms have been triggered. Go to \"{clickhere}\" to identify them",
	"alarm-maximum-more-than-minimum": "The higher bound for this range should be higher than the lower bound",
	"alarm-minimum-more-than-previous-maximum": "The lower bound for this range should be higher than the higher bound of the former range",
	"alarm-multirange-help-msg": "If the higher bound of the previous range equals to the lower bound of the next range then the next range is > (stricly more than) lower bound<br />Otherwise it is >= (more than or equal) lower bound<br />The range is always <= (less than or equal) higher bound",
	"alarm-notification-frequency-help-msg": "The first notification is sent as soon as the alarm is triggered. A notification can then be sent every {frequency} at most",
	"alarm-notification-user-no-phonenumber": "To enable SMS notification, this user must add his phone number to his profile from the console.",
	"alarm-occurrence-time-interval": "Within",
	"alarm-occurrence-time-interval-tooltip": "The occurrences must occur during this interval. Please have in mind that the default interval between two values is 10 minutes.<br />The counter of occurrences is reset if the conditions have been met during the time period. In order to be triggered again, the conditions must happen during a new time period.",
	"alarm-priority-updated": "Alarm priority updated",
	"alarm-property-measurement-boolean-constraint": "The value is <b>True/False</b> or <b>1/0</b>",
	"alarm-property-measurement-boolean-constraint-summary": "True / False",
	"alarm-property-measurement-notification-frequency-error-msg": "Must be minimum 10 minutes",
	"alarm-property-measurement-range-constraint-inrange": "The value is <b>in a range</b>",
	"alarm-property-measurement-range-constraint-inrange-summary": "In a range",
	"alarm-property-measurement-range-constraint-outrange": "The value is <b>outside a range</b>",
	"alarm-property-measurement-range-constraint-outrange-summary": "Outside a range",
	"alarm-property-measurement-set-constraint": "The value received is <b>in a set of unauthorized values</b>",
	"alarm-property-measurement-set-constraint-summary": "Non authorized values",
	"alarm-range-maximum-required": "Please provide a maximum value for the range",
	"alarm-range-minimum-required": "Please provide a minimum value for the range",
	"alarm-ranges": "Ranges",
	"alarm-required-occurrences": "Number of occurrences to trigger an alert",
	"alarm-required-occurrences-tooltip": "The number of occurrence required for the alarm to be triggered",
	"alarm-set-constraints-values": "Set of values",
	"alarm-set-constraints-values-placeholder": "Add a value",
	"alarm-sortby-name": "Name of the alarm (A-Z)",
	"alarm-sortby-triggered-at": "Date of last alert (A-Z)",
	"alarm-type-box_connection_status": "@.capitalize:box connection status",
	"alarm-type-equipment-status-condition": "For an equipment that connects to the @.capitalize:box in <strong>LoRaWAN</strong>, the connection will be considered as lost if no values have been received from the device in the last 12 hours. <br />For an equipment that connects to the @.capitalize:box through a <strong>wired protocol</strong> (BACnet, ModBus…), the connection will be considered as lost if there are less values received than expected in the last hour for a given equipment. The number of expected values being calculated automatically.",
	"alarm-type-equipment_status": "Status of an equipment",
	"alarm-type-property_measurement": "Property measurement",
	"alarm-valueset-duplicate-priorities": "Severities of multiple constraints must be different",
	"alarm-valueset-duplicate-values": "Some values inside the sets are duplicated",
	"alarm-zone": "Alarm zone",
	"alarm.add-range": "Add alarm range",
	"alarm.depend-on-schedule.label": "Associate the alarm to a schedule",
	"alarm.depend-on-schedule.msg": "The alarm depends on a schedule",
	"alarm.schedules.and-value-is": "And the value is:",
	"alarm.schedules.and-value-is-equal-to": "And the value is equal to:",
	"alarm.schedules.and-value-is-inrange": "And the value in inside the range:",
	"alarm.schedules.and-value-is-outrange": "And the value is outside the range:",
	"alarm.schedules.if-state-is": "When the schedules says:",
	"alarm.schedules.then-priority-is": "Set the severity to:",
	"alarm.slider-visualization-if-state": "Preview of the ranges when \"{state}\"",
	"alarms": "Alarms",
	"alarms-route": "Alarms route",
	"alarms-url": "Alarms url",
	"alarms.automation.close": "Automatically close the alert",
	"alarms.automation.close-auto": "<strong>Automatically close the alert</strong> when the conditions are not met",
	"alarms.automation.close-auto.comment": "The alarm has returned to normal. As a result, the last alerts raised by the alarm have been automatically closed.",
	"alarms.go-to-create-schedule": "Create your first schedule",
	"alarms.go-to-push-config": "Send the configuration to your @.lower:box before selecting a planning here",
	"alarms.go-to-schedules": "Go to schedules",
	"alarms.history.behaviour.boolean.desc": "if value equals <b>{value}</b> then severity <b>{severity}</b>",
	"alarms.history.behaviour.boolean.desc.minimal": "equals {value}",
	"alarms.history.behaviour.inrange.desc": "if value is <b>>{min} and <{max}</b> then severity <b>{severity}</b>",
	"alarms.history.behaviour.inrange.desc.minimal": ">{min} and <{max}",
	"alarms.history.behaviour.outrange.desc": "if value is <b><{min} or >{max}</b> then severity <b>{severity}</b>",
	"alarms.history.behaviour.outrange.desc.minimal": "<{min} or >{max}",
	"alarms.history.behaviour.schedule-boolean.desc": "if schedule specifies <b>{state}</b> and value equals <b>{value}</b> then severity <b>{severity}</b>",
	"alarms.history.behaviour.schedule-inrange.desc": "if schedule specifies <b>{state}</b> and value <b>>{min} and <{max}</b> then severity <b>{severity}</b>",
	"alarms.history.behaviour.schedule-outrange.desc": "if schedule specifies <b>{state}</b> and value <b><{min} or >{max}</b> then severity <b>{severity}</b>",
	"alarms.history.behaviour.schedule-set.desc": "if schedule specifies <b>{state}</b> and value in set <b>{set}</b> then severity <b>{severity}</b>",
	"alarms.history.behaviour.set.desc": "if value is in set {set} then severity <b>{severity}</b>",
	"alarms.history.behaviour.set.desc.minimal": "in set {set}",
	"alarms.history.tooltip.boolean.desc": "value equals {value}",
	"alarms.history.tooltip.inrange.desc": "value >{min} and <{max}",
	"alarms.history.tooltip.outrange.desc": "value <{min} or >{max}",
	"alarms.history.tooltip.set.desc": "value in set {set}",
	"alert-raw-bytes-not-supported-bacnet-gateway": "All properties that have data format as {raw_bytes} are hidden because they are still not supported on BACnet Gateway.",
	"alerts-history": "Alerts history",
	"all": "All",
	"all-configured": "All configured!",
	"all-day": "All day",
	"all-equipment": "All equipment",
	"all-properties": "All Properties",
	"all-year": "All year",
	"amplitude": "Range (Max - Min)",
	"an-optional-password-in-the-authentication": "An optional password in the authentication",
	"and": "and",
	"any": "Any",
	"api-device-id": "API Device Id",
	"api-documentation": "API Documentation",
	"api-error.equipment.4": "Some properties are already associated to this equipment. Please delete the properties in the configuration before editing the \"{codecFieldName}\" field.",
	"api-error.scheduler.9": "The property {propertyName} is already controlled by the schedule {previousScheduleName} for the {previousStart} - {previousEnd} application period. For a property to be controlled by different schedules, the application periods must not overlap. | The properties {propertyNames} are already controlled by the schedule {previousScheduleName} for the {previousStart} - {previousEnd} application period. For a property to be controlled by different schedules, the application periods must not overlap.",
	"api-error.scheduler.9-current-schedule": "The property {propertyName} is used multiple times for the same application period. For a property to receive different instructions, the application periods must not overlap. Please modify the application periods or delete the duplicate property.",
	"api-error.user.3": "The chosen password is in a list of generic passwords used in cyber attacks. Please choose a more specific password.",
	"api-keys": "API Keys",
	"app-eui": "App EUI",
	"app-version": "APP version",
	"apparently-havent-configured-box-go-to-configuration": "Apparently you haven't configured your @.lower:box yet. Go to Configuration to set it up!",
	"appeui": "AppEUI",
	"appkey": "AppKey",
	"application-extended-universal-identifier": "Application Extended Universal Identifier",
	"application-extended-universal-identifier-provided-by-manufactor": "Application Identifier provided by manufacturer",
	"application-key": "Application Key",
	"apply": "Apply",
	"apply-all": "Apply to all",
	"apply-all.bacnet-properties": "Apply Object type to all properties ({n})",
	"apply-all.modbus-properties": "Apply Register type, Data format and Raw registers to all selected properties ({n})",
	"apply-changes": "Apply changes",
	"apply-severity-to-alarm": "Apply the new severity to the alarm",
	"apply-status-to-alarm": "Apply the new status to the alarm",
	"applying-configuration-to-the-box": "Applying configuration to the @.lower:box",
	"archive-applied-operation-on-data": "Applied operation on data",
	"archive-apply-operation-on-data": "Transform the data",
	"archive-downloaded": "Archive downloaded",
	"archive-file-format": "Archive file format",
	"archive-no-transformation": "No transformation",
	"archive-request": "Data archive Request",
	"archive-status-ENDED": "Ended",
	"archive-status-FAILED": "Failed",
	"archive-status-NEW": "New",
	"archive-status-STARTED": "Started",
	"archive-transformation-diff-month": "Monthly difference (last value of the month - last value of the previous month)",
	"archive-transformation-diff-week": "Weekly difference (last value of the week - last value of the previous week)",
	"archive.alert.delete.body": "The recurring archive {name} will be deleted and will no longer be generated.",
	"archive.alert.delete.success": "The recurring archive has been deleted",
	"archive.alert.delete.title": "Delete the recurring archive",
	"archive.recurring.name": "Recurring archive | Recurring archives",
	"archive.request.actions.duplicate-it": "Duplicate archive request",
	"archive.request.actions.see-it": "See archive request",
	"archive.request.actions.update-it": "Update archive request",
	"archive.request.day-of-week": "Day of the week",
	"archive.request.end.date.error": "The end date must be later than the next execution date",
	"archive.request.frequency": "Frequency",
	"archive.request.frequency.daily": "Daily",
	"archive.request.frequency.monthly": "Monthly",
	"archive.request.frequency.monthly.help": "Data will be sent on the 1st of the following month",
	"archive.request.frequency.weekly": "Weekly",
	"archive.request.frequency.weekly.help": "Example: By selecting Monday, data will be exported for the period from Monday of the previous week to Sunday.",
	"archive.request.not-available": "Recurring archive is no longer available",
	"archive.request.type": "Type of request",
	"archive.request.type.recurring": "Recurring",
	"archive.request.type.single": "One-off",
	"archives": "Archives",
	"are-you-creating-organization-internal-siemens-or-end-user": "The organization is for",
	"area": "Area",
	"array-length-error": "Array must have exactly {length} items",
	"as-soon-as-it-occurs": "As soon as it happens",
	"assistance": {
		"access": "Support access",
		"authorize-access": {
			"desc": "Allow our team to access your account and devices to assist you with configuration and resolve technical issues.",
			"title": "Grant Support Access"
		},
		"delegated-connections": {
			"title": "Delegated connections"
		},
		"end-of-access": "Access expires on",
		"remaining-time": "Time remaining : {endDate}",
		"revoke-access": "Revoke access",
		"status": {
			"active": "Active",
			"inactive": "Inactive"
		},
		"title": "Support",
		"unlimitted-access": {
			"msg": "Enable unlimited access (until manually revoked)",
			"unlimited": "unlimited"
		}
	},
	"at-least-one-property-is-redirect-confirm-rename": "At least one property of this equipment is redirected to a BACnet IP or a MQTT gateway. Such gateways can use the name of the equipment to name the properties. Do you want to reflect the new name of the equipment in the gateways?",
	"attention": "Warning",
	"auth0.security.button.disabled": "Disable",
	"auth0.security.button.enabled": "Enable two-factor authentication",
	"auth0.security.delete.description": "After disabling two-factor authentication, you will be able to log in with your email and password.",
	"auth0.security.delete.title": "Disable two-factor authentication",
	"auth0.security.description": "After entering your password, confirm your identity with a second authentication method.",
	"auth0.security.disabled": "Two-step verification is disabled",
	"auth0.security.enabled": "Two-step verification is enabled",
	"auth0.security.is-app": "Authentication codes are available on the authentication app installed on your phone.",
	"auth0.security.is-disabled": "Two-step verification is disabled for your account.",
	"auth0.security.is-sms": "Authentication codes are sent by text message to your phone.",
	"auth0.security.title": "Two-factor authentication",
	"authentication": "Authentication",
	"author": "Author",
	"authorization-url": "Authorization URL",
	"auto-update-disabled-description": "Your device will no longer receive automatic security updates. Check regularly for available updates to keep your installation secure.",
	"auto-update-disabled-title": "Disabling automatic updates",
	"auto-update-firmware-description": "Updates are applied automatically",
	"auto-update-firmware-title": "Automatic firmware updates",
	"auto-update-help": "Contact the technical support to install it.",
	"auto-update-history": "Check the version history to verify the current status. If an update is available,",
	"auto-update-toast-message": "Automatic updates enabled",
	"autodiscovery.scan-didnt-find-results-after-x-minutes-review-config": "The scan has been running for {minutes} minutes and no device has been detected on {protocol} network. Would you like to review the configuration and run a new scan?",
	"autodiscovery.see-the-former-scan-and-let-running-in-background": "See former scan results & let the new scan run in the background",
	"autodiscovery.stop-scan-and-go-to-network-configuration": "Stop the scan & check the network configuration",
	"automation": "Automation",
	"automation-rtn-setpoint-help-message-with-schedule": {
		"li1": "Schedule: the values for the active slot at the time of return to normal will apply. Ensure that the properties have setpoint values for each slot.{cta}",
		"li2": "Custom value: do not add the unit. Use {dot} for decimal numbers.",
		"title": "Apply the values from the {scheduleName} schedule or specify a custom value."
	},
	"automation.action.alarm.level": "Alert severity : {level}",
	"automation.action.helper-text-setpoint-input": "To write a different value per property, create multiple actions.",
	"automation.action.property-not-selectable-controlled-by-schedule": "This property cannot be selected because it is already controlled by a schedule that was not included in the conditions.",
	"automation.action.schedule-title-description": "The scenario takes over until the start of the next scheduled slot.",
	"automation.action.schedule.to-state-x": "To {name}",
	"automation.action.setpoint.set-value-to-property": "{value} to:",
	"automation.action.type-of-action": "What do you want to do?",
	"automation.action.type.alarm": "Trigger an alarm",
	"automation.action.type.no-schedule.tooltip": "A schedule must be used in the conditions to be used in an action",
	"automation.action.type.schedule": "Change the schedule",
	"automation.action.type.schedule.desc": "Apply a different slot type",
	"automation.action.type.send": "Send",
	"automation.action.type.send-value": "Send value",
	"automation.action.type.send-value.desc": "Modify the value of a property",
	"automation.add-return-to-normal": "Add a return to normal",
	"automation.back-to-original-schedule-slot": "Come back to the original scheduled slot: {slot}",
	"automation.change-schedule": "Change schedule",
	"automation.cod.as-soon-as-it-occurs": "Don't wait, continue as soon as the condition is met",
	"automation.cod.occurrence.x-during-time": "{occurence} times for {time}",
	"automation.cod.occurrence.x-during-unlimited": "{occurence} times",
	"automation.condition.operator-AND": "All the conditions below are met (\"and\")",
	"automation.condition.operator-OR": "At least one condition below is met (\"or\")",
	"automation.condition.property.the-value-of-x-prop": "The value of {name}",
	"automation.condition.schedule.has-not-state-x": "Indicate that the slot type is not {name}",
	"automation.condition.schedule.has-state-x": "Indicate that the slot type is {name}",
	"automation.condition.schedule.the-schedule-x": "The schedule {name}",
	"automation.condition.type-of-condition": "What will trigger the automation and what are the condition(s) to move on?",
	"automation.condition.type.property": "Property",
	"automation.condition.type.property.desc": "The value of a property",
	"automation.condition.type.schedule": "Schedule",
	"automation.condition.type.schedule.desc": "The slot specified by a schedule",
	"automation.condition.type.schedule.disabled-tooltip": "Schedules can't be used in an alarm scenario yet.",
	"automation.condition.type.select-a-schedule": "Select a schedule",
	"automation.condition.type.select-schedule": "Select schedule",
	"automation.condition.value.type.formula": "Formula",
	"automation.condition.value.type.value": "Value",
	"automation.condition.value.type.value.help-message": "Enter text or a number. Do not add the unit. Use {point} for decimal numbers.",
	"automation.create-scenario": "Create a scenario",
	"automation.define-return-to-normal.title": "Return to normal",
	"automation.empty-state.desc": "Control your equipment based on ...",
	"automation.empty-state.title": "Control your equipment",
	"automation.history.conditions-fulfilled": "The conditions are met. The actions were executed",
	"automation.history.conditions-fulfilled-rtn": "The return-to-normal conditions are met. The actions set for the return-to-normal were executed",
	"automation.history.conditions-fulfilled-rtn-simulation": "The return-to-normal conditions are met. The actions set for the return-to-normal will be executed",
	"automation.history.conditions-fulfilled-simulation": "The conditions are met. The actions will be executed",
	"automation.history.conditions-not-fulfilled": "The conditions are not met. The actions did not go through",
	"automation.history.conditions-not-fulfilled-rtn": "The return-to-normal conditions are not met. The actions set for the return-to-normal did not go through",
	"automation.history.conditions-not-fulfilled-rtn-simulation": "The return-to-normal conditions are not met. The actions set for the return-to-normal will not go through",
	"automation.history.conditions-not-fulfilled-simulation": "The conditions are not met. The actions will not go through",
	"automation.history.evaliation-of-conditions": "Conditions check",
	"automation.history.evaluated-at": "{date} run",
	"automation.history.event": "Event",
	"automation.history.false": "False",
	"automation.history.history": "History",
	"automation.history.initial": "Scenario",
	"automation.history.it-received-a-value": "New value for {type} {type-name}.",
	"automation.history.modify-conditions": "Change conditions",
	"automation.history.not-executed": "Filtered",
	"automation.history.occurences-counter": "Occurences counter",
	"automation.history.return-to-normal": "Return to normal",
	"automation.history.scenario-status": "Run result",
	"automation.history.table-conditions.property": "Property",
	"automation.history.table-conditions.schedule": "Schedule",
	"automation.history.table-history.expected": "Expected",
	"automation.history.table-history.read": "Read",
	"automation.history.table-not": "is not",
	"automation.history.table.operators": "Operators",
	"automation.history.the-property": "property",
	"automation.history.the-schedule": "schedule",
	"automation.history.true": "True",
	"automation.history.view-scenario": "See Scenario",
	"automation.incomplete-scenario": "Automation is not valid",
	"automation.incomplete-scenario.define-cod": "Define a temporization",
	"automation.incomplete-scenario.error-lorawan-flooding": "At least one selected property uses the LoRaWAN protocol. The current definition of the scenario may result in multiple writes to this property without them being sent. If you wish to keep the scenario, please add a delay of at least 30 minutes.",
	"automation.incomplete-scenario.min-1-action": "Add one action",
	"automation.incomplete-scenario.min-1-condition": "add at least one condition",
	"automation.incomplete-scenario.steps-to-make-complete": "To save the automation, please",
	"automation.insert-property": "Insert property",
	"automation.no-rtn-with-schedule.msg": "Without defining a return to normal, the instruction will persist until the start of the new slot. The start of the new slot will write the instruction indicated in the schedule.",
	"automation.no-rtn.msg": "If no return to normal is specified, when the conditions are no longer met, the last action applies until further notice.",
	"automation.no-rtn.msg-alarms": "If the conditions are no longer met, the alarm will remain active. Add a return to normal condition to automatically close the alarm.",
	"automation.no-unit.rtn.help-message": "Enter a value for each property. Do not add the unit. Use {dot} for decimal numbers.",
	"automation.required-occurrences": "Wait for the condition to repeat",
	"automation.return-to-current-schedule-state": "Come back to the scheduled time slot",
	"automation.rtn-apply-custom-value": "Custom value",
	"automation.rtn-apply-schedule-value": "Apply schedule values",
	"automation.rtn-property-scheduleStateId.msg": "Schedule {name} to {scheduleState}",
	"automation.rtn-property-setpoint.msg": "Send value {setpoint} to {name}",
	"automation.rtn-release-to-schedule.msg": "Send {setpoint} {name}",
	"automation.rtn-release-to-schedule.schedule-value": "schedule value",
	"automation.rtn-title": "If conditions are no longer met",
	"automation.rtn.disabled-select-message-during": "This value can't be edited. It is set by default based on the temporization.",
	"automation.rtn.disabled-select-message-if": "This value can't be edited. It is set by default based on the conditions.",
	"automation.scenario.empty-state.btn-chose-condition-to-start": "Choose a condition to start with",
	"automation.scenario.empty-state.desc": "Automatically adjust values or schedules based on what happens in the building. Add a condition to start",
	"automation.scenario.empty-state.title": "Welcome to the Automation editor",
	"automation.schedule-action.return-to-normal.help-msg": "Without returning to normal, you will have to wait until the start of the next slot for the schedule to resume.",
	"automation.schedule-action.return-to-normal.label": "If the conditions are no longer met",
	"automation.schedule-action.return-to-normal.msg": "Return to the initial slot (return to normal)",
	"automation.schedule-cod.as-soon-as-it-occurs.msg": "No temporization, run the actions as soon as the conditions are met",
	"automation.set-name-scenario": "Give a name to the scenario",
	"automation.setpoint-action.return-to-normal.help-msg": "Without returning to normal, if the scenario has run at least once but the conditions are no longer met:<br />* If the property does not depend on a schedule, the instruction will persist<br />* If the property depends on a schedule, the start of a new slot will write a new instruction<br />When returning to normal, the instruction will return to its original value:<br />* If the property does not depend on a schedule, you set this original value<br />* If the property depends on a schedule, the original value will be the one set in the schedule (avoids waiting for the next slot)",
	"automation.setpoint-action.return-to-normal.label": "If the conditions are no longer met",
	"automation.setpoint-action.return-to-normal.msg": "Return to normal",
	"automation.simulation.chose-period-simulate-scenario": "Choose a period to simulate the scenario evaluation.",
	"automation.simulation.test-automation": "Test the automation",
	"automation.slot-types": "Slot types",
	"automation.tab-title": "Program",
	"automation.test": "Test",
	"automation.test-btn": "Test",
	"automation.value": "Value",
	"automations": "Automations",
	"automations.add-automation": "Add scenario",
	"automations.edit-automation": "Edit automation",
	"automations.failed-deleting-scenario": "Failed deleting scenario",
	"automations.history.view-history": "View history",
	"available-until": "Available until",
	"average": "Average",
	"awaiting-next-reading": "Waiting for the next reading",
	"axis-left": "Left",
	"axis-right": "Right",
	"back": "Back",
	"bacnet-devices-not-complete": "Some BACnet devices are not complete yet.",
	"bacnet-extra-days-help-msg": "32 for Last day of month <br />33 for Odd day of month <br />34 for Even day of month",
	"bacnet-flag-FAULT": "Fault",
	"bacnet-flag-IN_ALARM": "In Alarm",
	"bacnet-flag-OK": "Working fine",
	"bacnet-flag-OUT_OF_SERVICE": "Out of service",
	"bacnet-flag-OVERRIDEN": "Overridden",
	"bacnet-import.instructions.1": "Instructions for adding equipment in bulk",
	"bacnet-import.instructions.2": "The import file must be in EDE format (version 2.3).",
	"bacnet-import.instructions.3": "Download an example.",
	"bacnet-import.instructions.4": "Only the following columns are imported: device-object-instance, object-name, object-type, object-instance, description, present value, unit-code.",
	"bacnet-import.instructions.5": "Each BACnet property is an object whose present value represents the real-time value. In the box configuration, the notion of object disappears. The property will keep a name ({object-name}), a description ({description}), a unit ({unit-code}) and a value ({present-value}). It has a network address ({object-instance}), a type ({object-type}) and is attached to a device ({device-object-instance}).",
	"bacnet-import.instructions.title": "Importing BACnet properties into the box",
	"bacnet-import.no-data": "File format error, properties table not found",
	"bacnet-import.title": "BACnet bulk creation",
	"bacnet-import.toast.end": "Import file completed",
	"bacnet-ip-gateway-property": "BACnet IP Gateway Property",
	"bacnet-network-number": "The BACnet network number",
	"bacnet-object-name": "BACnet Object Name",
	"bacnet-property": "BACnet property",
	"bacnet-redirect.modal.allow-wattsense": "I authorize Wattsense to modify the configuration of my box",
	"bacnet-redirect.modal.confirm": "Our team will email you within 48 business hours with an update on your request.",
	"bacnet-redirect.modal.description": "The controller schedule will be redirected to a BACnet Schedule object (currently only compatible with Siemens Synco controller schedules).",
	"bacnet-redirect.modal.equipment": "Equipment and circuit",
	"bacnet-redirect.modal.gtb": "BMS Brand {optional}",
	"bacnet-redirect.modal.instance": "Schedule object instance {optional}",
	"bacnet-redirect.modal.note": "Note: You can manage technical support access permissions for your box in your profile.",
	"bacnet-redirect.modal.placeholder": "ex. RMH760B - HEATING CIRCUIT 1 - School radiators",
	"bacnet-redirect.modal.title": "Redirect a schedule stored in a controller",
	"bacnet-schedule.data-type.help-msg": "If the properties targeted by the schedule are binary, you must select the ENUMERATED data type",
	"bacnet.max-value": "Maximum Value",
	"bacnet.max-value.help": "Maximum value expected",
	"bacnet.min-value": "Minimum Value",
	"bacnet.min-value.help": "Minimum value expected",
	"bacnet.object-instance": "BACnet Object instance",
	"bacnet.object-instance.help": "The BACnet object instance id [0 .. 4194303]",
	"bacnet.object-type": "BACnet Object Type",
	"bacnet.polarity": "Polarity",
	"bacnet.resolution": "Resolution",
	"bacnet.resolution.help": "Resolution size between value changes",
	"bacnet.rules.uniq": "You can have only one BACnet interface at the same time on the box (BACnet network or BACnet gateway)",
	"bacnet.update-interval": "Update interval",
	"bacnet.update-interval.help": "Indicate how often the remote variable will update this one in seconds",
	"bacnetscan.properties": "Properties:",
	"banner.alarm.linked-schedule.unused-state": "The \"{state}\" slot type is no longer used by the schedule \"{schedule}\". Please edit the alarm to change the slot type.",
	"banner.autodiscovery-wait-for-scan": "Please wait while the scan is running.",
	"banner.bulk-import-properties.title": "Instructions for adding properties in bulk",
	"banner.bulk-import.title": "Instructions for adding equipment in bulk",
	"banner.cache-refresher.body": "A new version is available and will be loaded when browsing a new screen.",
	"banner.cache-refresher.click-to-refresh": "Click here to load it immediately.",
	"banner.duplicate-equipment-no-network.body": "No network of type {protocol} are available in the box “{boxName}”. Please create such a network before duplicating the equipment.",
	"banner.duplicate-equipment-no-network.footer": "Create the network",
	"banner.duplicate-equipment-no-network.restart-network-detection": "Refresh the list of networks",
	"banner.duplicate-equipment-no-network.title": "No network available",
	"banner.equipment-bulk-creation-advanced-config": "Equipment below require advanced configuration:",
	"banner.hub-live-data-activate.body": "To see the values of the different equipment in the console, please activate the switch next to your @.capitalize:client-name-hub name. Once activated and after the next reading, the value will be available for 60 minutes. Locally the values are always received and redirected accordingly.",
	"banner.hub-live-data-activate.title": "Activate the reception of the property values",
	"banner.satellite-licence": "You have selected a Satellite license. It can only be activated if it is used in conjunction with another box on the same site with an M or L license.",
	"banner.scaling-to-gateway.bacnet-mqtt.body.pending.1": "Scaling is now applied to the values redirected to the gateways. This information has been added to your configuration. To activate the feature, send the configuration to your box.",
	"banner.scaling-to-gateway.bacnet-mqtt.body.pending.2": "First, and to avoid a potential double application of scaling, remove it from the equipment or software that receives the redirected values.",
	"banner.scaling-to-gateway.bacnet-mqtt.body.pending.3": "You can {downloadBtn} to review the changes that will be applied.",
	"banner.scaling-to-gateway.bacnet-mqtt.body.pending.4": "If you do not wish to apply scaling, remove it from the redirect properties.",
	"banner.scaling-to-gateway.bacnet-mqtt.download-properties-btn": "download the list of scaled properties",
	"banner.scaling-to-gateway.bacnet-mqtt.send-configuration-btn": "Update configuration",
	"banner.scaling-to-gateway.body": "Scaling is now applied to values redirected to gateways. To activate this feature, go to the following boxes to update them: {devices}.",
	"banner.scaling-to-gateway.modbus.body.pending.1": "Scaling is now applied to values redirected to gateways.",
	"banner.scaling-to-gateway.modbus.body.pending.2": "To activate this feature, start update process. This will update the configuration and modify the parameters of the properties redirected to your Modbus gateway. You can check the proposed changes and edit them. If necessary, {downloadBtn}.",
	"banner.scaling-to-gateway.modbus.body.pending.3": "To activate the redirection of scaled values, you need to send a new configuration with the changes to your box.",
	"banner.scaling-to-gateway.modbus.body.pending.4": "To avoid double application of the scaling, remove it from the Modbus device receiving the redirected values.",
	"banner.scaling-to-gateway.modbus.body.pending.5": "If you do not wish to apply scaling, remove it from the redirect properties.",
	"banner.scaling-to-gateway.modbus.body.queued.1": "Check the changes made to your configuration ({downloadBtn}). If there are any changes in the communication table, transfer them to the Modbus device receiving the redirected values.",
	"banner.scaling-to-gateway.modbus.body.queued.2": "To activate the redirection of scaled values, send the new configuration with the changes to your box.",
	"banner.scaling-to-gateway.modbus.download-properties-btn": "download the scaled property list",
	"banner.scaling-to-gateway.modbus.queued-download-properties-btn": "download here",
	"banner.scaling-to-gateway.modbus.revert-migration-btn": "Revert migration",
	"banner.scaling-to-gateway.modbus.send-configuration-btn": "Send new configuration",
	"banner.scaling-to-gateway.modbus.start-migration-btn": "Start update process",
	"banner.scaling-to-gateway.title.pending": "Action required",
	"banner.scaling-to-gateway.title.queued": "Configuration updated",
	"banner.schedules.box-timezone-different-than-browser.body": "Based on your browser, you do not share the same timezone as your box. Your timezone is “{browserTimezone}”.{br}If it is a configuration issue, change your box's timezone above.{br}The schedule will run in the box's local time.",
	"banner.schedules.box-timezone-different-than-browser.title": "Your timezone and the box's timezone are different.",
	"banner.schedules.lorawan-class-a.part1": "Equipment {equipments}c ommunicate via LoRaWAN and is Class A. | Equipment {equipments} communicate via LoRaWAN and are Class A.",
	"banner.schedules.lorawan-class-a.part2": "Values will be sent to devices when they transmit their next uplink. The value will be written after the time slot start time, depending on the equipment transmission period. | Values will be sent to devices when they transmit their next uplink. The value will be written after the time slot start time, depending on the equipment transmission periods.",
	"banner.schedules.lorawan-class-a.part3": "Each equipment can only have one pending value at a time: if multiple values are sent, only the last one will be transmitted.",
	"banner.schedules.lorawan-class-a.part4": "Ensure time slot duration is longer than equipment transmission period.",
	"banner.schedules.lorawan-class-a.title": "LoRaWAN Class A devices",
	"banner.schedules.select-exceptions.body": "The list of your exceptions is shared across all the schedules of your box.",
	"banner.schedules.selected-exceptions.body": "If two exceptions overlap, the one ordered first will have the priority. Use the button on the right of a row to order the exceptions.",
	"banner.schedules.selected-exceptions.title": "Priorities between exceptions",
	"banner.schedules.set-property-value": "This property is controlled by the schedule {schedules}. If you edit its value here, it will be taken into account till the schedule writes a new value. | This property is controlled by the schedules: {schedules}. If you edit its value here, it will be taken into account till a schedule writes a new value.",
	"banner.schedules.try-control-siemens.body": "Meet the Control range. Discover new features dedicated to building automation, starting with scheduling. Read more about the announcement on our {blogLink}.",
	"banner.schedules.try-control.body": "Meet the Wattsense Control range. Discover a range of new features dedicated to building automation, starting with scheduling. Activate your free trial for your boxes under {goToLink}. Read more about the announcement on our {blogLink}.",
	"banner.unpaired-devices.body": "You have a license awaiting to be attached to a box. If you received your box, go to {goToLink} to pair it",
	"bars": "Bars",
	"base-url": "Base URL",
	"baudrate": "Baudrate",
	"bbmd-details": "BBMD Details",
	"bbmd-ip-address": "BBMD IP address",
	"bbmd-scenario-bbmd-config": "BACNet Broadcast Management Device",
	"bbmd-scenario-disabled": "Not enabled",
	"bbmd-scenario-foreign-device": "Foreign Device Registration",
	"bbmd-section-name": "BBMD, FD",
	"bbmd-table-box-ip-msg": "The row below is prefilled with the IP address of the device based on the interface selected. This information is required for the BBMD to work",
	"bbmd-table-help-msg": "For the BBMD to work, make sure the table is the same in every BBMD devices",
	"bbmd-table-no-box-ip-msg": "The IP address of your device can't be guessed based on the interface selected. Please fill it manually",
	"bbmd-time-to-live": "Time To Live",
	"bbmd-time-to-live-tooltip": "Length of time, in seconds, before the device sends a hello message to the BACnet host",
	"below-line-graph-with-latests-values-from-property": "Below a line graph with latest values collected from {property}",
	"between-an-address-range": "Between an address range",
	"billing-contact": "Billing Contact",
	"bit-offset-and-scaling-conflict": "Single bit reading cannot be used with scaling. Please remove the scaling.",
	"bit-offset-and-write-conflict": "Single bit reading only supports read only operation. Please change the access type accordingly.",
	"bits-per-second": "bits per seconds",
	"block-type": "Chart type",
	"blog": "blog",
	"box": "@.clientname:_generic",
	"box-activated": "@.capitalize:box activated",
	"box-connect": "@.capitalize:box connected",
	"box-didnt-receive-configuration": "@.capitalize:box did not receive the new configuration.",
	"box-disconnect": "@.capitalize:box disconnected",
	"box-info.end-date": "End date",
	"box-info.hub-end-date": "SIM card end date",
	"box-local-time": "@.capitalize:box local time",
	"box-name-in-network": "@.capitalize:box name in the network",
	"box-not-connected-to-console": "@.capitalize:box not connected to console",
	"box-or-hub": "@.capitalize:client-name-box or @.capitalize:client-name-hub",
	"box-status.never-connected": "Never connected",
	"box-status.never-connected-to-the-platform": "Never connected to the platform",
	"box-status.offline": "Offline",
	"box-status.offline-connected-once": "Offline (connected at least once)",
	"box-status.online": "Online",
	"box-status.online-but-data-inactive": "@.capitalize:box connected to the console",
	"box-status.online-but-data-inactive-activate-communication": "Activate communication to receive property values",
	"box-status.under-maintenance": "Under maintenance",
	"box-timezone": "@.clientname:_generic timezone",
	"box.views.command.error_not_received-status": "The command was not received by the @.lower:box",
	"box.views.logs.error_already_in_progress-status": "The command is already in progress",
	"box.views.logs.error_invalid_value-status": "The command has invalid values",
	"box.views.logs.error_not_received-status": "The command was not received by the @.lower:box even after multiple retries",
	"box.views.logs.error_not_sent-status": "The command was not sent by the @.lower:box even after multiple retries",
	"box.views.logs.error_rate_limit-status": "The command was not sent due to rate limit",
	"box.views.logs.error_timeout-status": "The command was timed out by the @.lower:box",
	"box.views.logs.new-status": "Command is valid and stored on the cloud platform",
	"box.views.logs.received-status": "The command was received by the @.lower:box",
	"box.views.logs.retry_send-status": "The command was not received yet by the @.lower:{'box'}, we'll retry soon",
	"box.views.logs.sent-status": "The command was sent to the @.lower:{'box'}, we did not receive a confirmation from the @.lower:box yet",
	"boxes": "@.clientname:_generic-plural",
	"broadcast": "Broadcast",
	"broadcast-distribution-table": "Broadcast Distribution Table",
	"broker": "Broker",
	"broker-port-number": "Broker port number",
	"broker-type": "Broker type",
	"broker-url": "Broker URL",
	"bsp": "BSP",
	"bulk-creation": "Bulk creation",
	"bulk-downlink": {
		"live-data": {
			"banner-body": "Send the same value to multiple LoRaWAN equipment of the same model via \"Configuration > Equipment > Actions\".{cta}",
			"banner-title": "Send value in bulk available"
		},
		"step1": {
			"breadcrumb": "Equipment references",
			"no-product-reference": "Unknown reference",
			"title": "Select one equipment reference. Only one reference can be configured at a time."
		},
		"step2": {
			"breadcrumb": "Equipment",
			"title": "Select the {name} equipment to configure."
		},
		"step3": {
			"apply-value": "Value to apply",
			"breadcrumb": "Properties",
			"error": {
				"invalid-payload": "Payload must be valid hexadecimal (0-9, A-F).",
				"invalid-port": "Port must be an integer.",
				"no-codec-selected": "Select a property",
				"no-enabled-properties": "There is no enabled property for the selected equipment. Please enable at least one property to send the commands."
			},
			"info-msg": {
				"body": "To enable properties in bulk, use {link}.",
				"bulk-link": "Equipment > Actions > Bulk edit configuration",
				"title": "Commands will only be sent to enabled properties"
			},
			"title": "Enter the value to send to the {number} {name}.",
			"title-plural": "Select the property to configure then specify the value to send to the {number} {name}"
		},
		"step4": {
			"breadcrumb": "Summary",
			"campaign-name": "Campaign name",
			"campaign-name-error": "This field is required.",
			"campaign-name-placeholder": "E.g. Interval - 30 min.",
			"class-a-msg": {
				"body1": "Values will be sent to equipment upon their next uplink.",
				"body2": "Each equipment can only have one pending value at a time: if multiple values are sent, only the last one will be transmitted.",
				"title": "LoRaWAN Class A equipment"
			},
			"class-c-msg": {
				"body": "Values will be sent progressively. Estimated time for complete update: {time}",
				"title": "LoRaWAN Class C equipment"
			},
			"description-placeholder": "E.g. Set transmission interval to 30 minutes",
			"model-name": "Equipment reference",
			"property": "Property",
			"see-list": "See the list",
			"selected-equipments": "Selected equipment",
			"sent-value": "Sent value",
			"title": "Name the campaign and review information before sending."
		},
		"success-dialog": {
			"body": "Track <b>{campaignName}</b> campaign progress in Logs > Campaigns.",
			"confirmBtn": "View Campaign",
			"title": "Commands sent"
		},
		"title": "Send LoRaWAN commands in bulk",
		"version-dialog": {
			"body": "This feature requires a newer firmware version. Enable automatic updates in @.lower:box settings (Organization > {deviceName} > Settings).",
			"title": "Update required"
		}
	},
	"bulk-edit": "Bulk edit",
	"bulk-edit-error-address": "The following properties' register addresses are conflicting. Please check their register addresses. {properties}",
	"bulk-import-file-error-msg": "The dropped file is not in the correct format or its content is not accessible. Please check the file format and try again.",
	"bulk-import.advanced-configuration-codec-name": "Advanced configuration {name}",
	"by-sending-config-from-da-config-will-overwrite-current-config-do-you-confirm": "By sending the configuration from the Desktop Application to the @.lower:{'hub'}, the configuration will overwrite the current configuration and the changes won't be reflected in the console. Do you confirm?",
	"ca-certificate": "CA Certificate",
	"calculated": "Calculated",
	"calculated.no": "Not calculated",
	"calculation": "Calculation",
	"cancel": "Cancel",
	"cancel-changes": "Cancel changes",
	"cant-activate-box-without-subscription-plan": "You can't activate this @.lower:box because it doesn't have a subscription. Contact support, please.",
	"certificate": "Certificate",
	"certificate-authentication": "Certificate authentication",
	"certificate-authentication-required": "Certificate authentication is required",
	"certificate-deleted": "Certificate deleted",
	"certificate-store-id": "Certificate store",
	"certificate-updated": "Certificate updated",
	"certificates": "Certificates",
	"change": "Change",
	"change-alarm-settings": "Change the alarm settings",
	"change-alert-status": "Change the status of the alert",
	"change-box-hub-name": "Change @.lower:box name",
	"change-data-format-to-f32": "Please change the data format to use a f32 data format instead (f32_dcba instead of float_abcd, f32_cdab instead of float_badc, f32_abcd instead of float_dcba and f32_badc instead of float_cdab)",
	"change-severity-of-alert": "Change the severity of the alert",
	"change-value-fields-restrict-scan-equipment-identification-number-matching-pattern": "Change the value of the fields to restrict the scan to the equipment identification number matching the pattern.",
	"chat": "Chat",
	"check-hub-configuration": "Check @.lower:box configuration",
	"check-request-scan": "Checking if @.lower:box received the request to run the Scan",
	"choose-a-file": "Choose a file",
	"choose-date": "Choose Date",
	"choose-dates": "Choose Dates",
	"choose-end-date": "Set an end date",
	"choose-equipment-or-run-scan-bacnet": "Select an equipment from the equipment database or run a scan on a compatible network (BACnet or M-Bus)",
	"class-type": "Class type",
	"clear": "Clear",
	"clear-selection": "Clear selection",
	"click-here": "Click here",
	"click-here-touse-equipment-default-configuration": "Click here to use equipment default configuration",
	"click-to-add-change-scaling": "Click to add/change the scaling",
	"click-to-add-change-unit": "Click to add/change the unit",
	"click-to-copy": "Click to copy",
	"click-to-copy-table-to-clipboard": "Click here to copy the table to the clipboard",
	"clicking-here": "clicking here",
	"client-authentication-method": "Client authentication method",
	"client-authentification": "Client authentification",
	"client-authentification-method": "Client authentification method",
	"client-certificate": "Client Certificate",
	"client-id": "Client ID",
	"client-name-box": "@.clientname:_box",
	"client-name-boxes": "@.clientname:_boxes",
	"client-name-generic": "@.clientname:_generic",
	"client-name-generic-plural": "@.clientname:_generic-plural",
	"client-name-hub": "@.clientname:_hub",
	"client-name-hubs": "@.clientname:_hubs",
	"client-secret": "Client secret",
	"close": "Close",
	"close-alert": "Close the alert",
	"close-or-acknowledge-previous-alerts-from-this-alarm": "Close or acknowledge the previous alerts associated with this alarm",
	"closed": "Closed",
	"code": "Code",
	"codec-id": "Codec ID",
	"collapse-button-equipment-tooltip": "Collapse all equipment",
	"collapse-button-groups-tooltip": "Collapse all groups",
	"collapse-button-organization-tooltip": "Close all organizations",
	"colon-symbol": ":",
	"combination-of-baseurl-and-this-route-is-not-valid": "The combination of Base URL and this route is not valid: {url}",
	"combination-of-brokerurl-and-this-route-is-not-valid": "The combination of Broker URL and this route is not valid: {url}",
	"comfort-reached-at": "Comfort reached at",
	"command": "Command",
	"command-of-configuration": "Configuration's command",
	"command-scan-not-received-by-box": "The command to scan was not received by the @.lower:box",
	"command-status-ERROR_NOT_RECEIVED": "ERROR_NOT_RECEIVED",
	"command-status-NEW": "NEW",
	"command-status-RECEIVED": "RECEIVED",
	"command-status-RETRY_SEND": "RETRY_SEND",
	"command-status-SENT": "SENT",
	"command-status-tooltip": "New<br />Command is valid and is waiting to be sent to the device<br /><br />Error_not_received<br />The command was not received by the device even after multiple retries<br /><br />Sent<br />The command was sent to the device. Waiting for the device to confirm its reception<br /><br />Received<br />The command was received by the device<br /><br />Retry_send<br />The command has not been received by the device. A new attempt will be performed",
	"command-to-send-to-device-to-read-write": "Command to send to the device to read/write",
	"command-type-DISCOVER": "DISCOVER",
	"command-type-READ_REQUEST": "READ_REQUEST",
	"command-type-RESTART": "RESTART",
	"command-type-SEND_CONFIG": "SEND_CONFIG",
	"command-type-SET_PROPERTY": "SET_PROPERTY",
	"command-type-WS_CONFIG": "WS_CONFIG",
	"comment": "Comment",
	"communication": "Communication",
	"communication-mode": "Communication mode",
	"communication-mode-to-use": "The communication mode to use",
	"comparison-operator.eq.label": "Is equal to",
	"comparison-operator.ge.label": "Is greater or equal to",
	"comparison-operator.gt.label": "Is greater than",
	"comparison-operator.le.label": "Is less or equal to",
	"comparison-operator.lt.label": "Is less than",
	"comparison-operator.ne.label": "Is not equal to",
	"components.buttons-expand-collapse.collapse": "Collapse all",
	"components.buttons-expand-collapse.expand": "Expand all",
	"components.demo-account.account": "Demo Account",
	"components.layouts.app.components.global-search.boxes-result.no-result": "0 @.lower:boxes found with the search criteria",
	"components.layouts.app.components.global-search.equipment-result.no-result": "0 equipment found with the search criteria",
	"components.layouts.app.components.global-search.modal-globlal-search.failed-getting-boxes": "Failed getting list of @.lower:boxes",
	"components.layouts.app.search.search-for-box": "Search for a @.lower:box",
	"components.paginator.next": "Next page",
	"components.paginator.previous": "Previous page",
	"condition": "Condition",
	"configuration": "Configuration",
	"configuration-changed-but-not-applied-send-to-box": "The configuration has been edited but the changes haven't been synchronized with the @.lower:{'box'}. Send the configuration to the @.lower:box to apply them.",
	"configuration-get-network-id-to-scan-msg": "Getting network to run the Scan",
	"configuration-imported": "Configuration imported",
	"configuration-imported-with-success": "Configuration imported with success",
	"configuration-in-the-box": "Configuration in the @.lower:box",
	"configuration-recreating-draft-msg": "Recreating draft configuration",
	"configuration-saving-msg": "Saving configuration in the @.lower:box",
	"configuration-verify-exist-scan-msg": "Verifying if a Scan exists",
	"configuration-waiting-to-apply": "Waiting for @.lower:box to apply configuration",
	"configuration-was-successfully-applied-to-hub": "The configuration was successfully applied to your @.lower:{'hub'}!",
	"configuration-wizard": "Configuration Wizard",
	"configuration.bulk-downlink": "Send LoRaWAN commands in bulk",
	"configuration.bulk-downlink-no-lorawan-tooltip": "No LoRaWAN equipment available",
	"configuration.bulk.export.cell.error": "Please select a value from the list",
	"configuration.bulk.readme.equipment.a2": "This file contains important data for all your equipment, allowing you to modify some of them in order to import changes in bulk. Below is a guide to help you understand the different columns in this file and how to use the information effectively.",
	"configuration.bulk.readme.equipment.a3": "Some columns are read-only, meaning that there are in the export for information only and if you change the value in the file, it will not be considered during the import. Others columns can be modified in order to change your configuration.",
	"configuration.bulk.readme.equipment.a4": "To see the export and change data, go to the next tab \"Equipment\". Do not try to modify other tabs. ",
	"configuration.bulk.readme.equipment.a5": "To delete equipment in bulk, please go back to the console, select several equipment and choose the \"Delete\" option under \"Actions\".",
	"configuration.bulk.readme.equipment.column.a.10": "Equipment Name",
	"configuration.bulk.readme.equipment.column.a.11": "Equipment Description",
	"configuration.bulk.readme.equipment.column.a.12": "Equipment Protocol",
	"configuration.bulk.readme.equipment.column.a.13": "Equipment Synchronized",
	"configuration.bulk.readme.equipment.column.a.14": "Equipment Group",
	"configuration.bulk.readme.equipment.column.a.15": "DevEUI",
	"configuration.bulk.readme.equipment.column.a.16": "AppEUI",
	"configuration.bulk.readme.equipment.column.a.17": "Application Key",
	"configuration.bulk.readme.equipment.column.a.9": "Equipment ID",
	"configuration.bulk.readme.equipment.column.b.10": "Name of the  equipment",
	"configuration.bulk.readme.equipment.column.b.11": "Description of the equipment",
	"configuration.bulk.readme.equipment.column.b.12": "Protocol used by the equipment",
	"configuration.bulk.readme.equipment.column.b.13": "Indicates if the equipment is synchronized with the box.",
	"configuration.bulk.readme.equipment.column.b.14": "Name of group to which the piece of equipment belongs. If it does not exist, a new group will be created.",
	"configuration.bulk.readme.equipment.column.b.15": "Device ID. For LoRaWAN equipment only.",
	"configuration.bulk.readme.equipment.column.b.16": "Application ID. For LoRaWAN equipment only.",
	"configuration.bulk.readme.equipment.column.b.17": "Root key for the device. For LoRaWAN equipment only.",
	"configuration.bulk.readme.equipment.column.b.9": "Unique identifier of the equipment in database.",
	"configuration.bulk.readme.name": "Readme",
	"configuration.bulk.readme.properties.a2": "This file contains important data for all your equipment properties, allowing you to modify some of them in order to import changes in bulk. Below is a guide to help you understand the different columns in this file and how to use the information effectively.",
	"configuration.bulk.readme.properties.a3": "Some columns are read-only, meaning that there are in the export for information only and if you change the value in the file, it will not be considered during the import. Others columns can be modified in order to change your configuration.",
	"configuration.bulk.readme.properties.a4": "To see the export and change data, go to the next tab \"Properties\". Do not try to modify other tabs. ",
	"configuration.bulk.readme.properties.column.a.10": "Property Name",
	"configuration.bulk.readme.properties.column.a.11": "Property Description",
	"configuration.bulk.readme.properties.column.a.12": "Property Slug",
	"configuration.bulk.readme.properties.column.a.13": "Property Access Type",
	"configuration.bulk.readme.properties.column.a.14": "Property Interval",
	"configuration.bulk.readme.properties.column.a.15": "Property Unit",
	"configuration.bulk.readme.properties.column.a.16": "Property Scaling A",
	"configuration.bulk.readme.properties.column.a.17": "Property Scaling B",
	"configuration.bulk.readme.properties.column.a.18": "Redirect To",
	"configuration.bulk.readme.properties.column.a.19": "Property Synchronized",
	"configuration.bulk.readme.properties.column.a.20": "Property Activation Status",
	"configuration.bulk.readme.properties.column.a.8": "Property ID",
	"configuration.bulk.readme.properties.column.a.9": "Property Equipment",
	"configuration.bulk.readme.properties.column.b.10": "Name of the property",
	"configuration.bulk.readme.properties.column.b.11": "Description of the property",
	"configuration.bulk.readme.properties.column.b.12": "Unique identifier in your system (and per box) to reference the property",
	"configuration.bulk.readme.properties.column.b.13.1": "Indicates if the property values are available through the cloud console and the APIs (remote). With read and/or write access. Or if it is local (not sent to the cloud) and by default with read and/or write access locally.",
	"configuration.bulk.readme.properties.column.b.13.2": "You can choose the appropriate value using the drop-down list in the cell.",
	"configuration.bulk.readme.properties.column.b.14.1": "The number of seconds between two polls of data.",
	"configuration.bulk.readme.properties.column.b.14.2": "This is used by the box when reading data from the equipment.",
	"configuration.bulk.readme.properties.column.b.14.3": "Minimum is 600 for REMOTE properties and 60 for LOCAL.",
	"configuration.bulk.readme.properties.column.b.15.1": "The engineering unit of the property.",
	"configuration.bulk.readme.properties.column.b.16.1": "If scaling is apply for this property,",
	"configuration.bulk.readme.properties.column.b.16.2": "value of the formula : a*x + b",
	"configuration.bulk.readme.properties.column.b.17.1": "If scaling is apply for this property,",
	"configuration.bulk.readme.properties.column.b.17.2": "value of the formula : a*x + b",
	"configuration.bulk.readme.properties.column.b.18": "If the property redirects to a gateway, name of the redirected property",
	"configuration.bulk.readme.properties.column.b.19": "Indicates if the property is synchronized with the box.",
	"configuration.bulk.readme.properties.column.b.20.1": "Indicates if the property is activated or not.",
	"configuration.bulk.readme.properties.column.b.20.3": "Use this field to disable multiple properties at once from your configuration.",
	"configuration.bulk.readme.properties.column.b.8": "Unique identifier of the property in database.",
	"configuration.bulk.readme.properties.column.b.9": "Name of equipment to which the property belongs",
	"configuration.bulk.readme.redirected-properties.a2": "This file contains important data for all your equipment redirected properties, allowing you to modify some of them in order to import changes in bulk. Below is a guide to help you understand the different columns in this file and how to use the information effectively.",
	"configuration.bulk.readme.redirected-properties.a3": "Some columns are read-only, meaning that there are in the export for information only and if you change the value in the file, it will not be considered during the import. Others columns can be modified in order to change your configuration.",
	"configuration.bulk.readme.redirected-properties.a4": "To see the export and change data, go to the next tab \"Redirected properties\". Do not try to modify other tabs. ",
	"configuration.bulk.readme.redirected-properties.column.a.10": "Redirected Property Name",
	"configuration.bulk.readme.redirected-properties.column.a.11": "Redirected Property Description",
	"configuration.bulk.readme.redirected-properties.column.a.12": "Redirected Property Slug",
	"configuration.bulk.readme.redirected-properties.column.a.13": "Redirected Property Access Type",
	"configuration.bulk.readme.redirected-properties.column.a.14": "Redirected Property From",
	"configuration.bulk.readme.redirected-properties.column.a.15": "Redirected Property To",
	"configuration.bulk.readme.redirected-properties.column.a.16": "Redirected Property Unit",
	"configuration.bulk.readme.redirected-properties.column.a.17": "Redirected Property Synchronized",
	"configuration.bulk.readme.redirected-properties.column.a.18": "Redirected Property Register Address",
	"configuration.bulk.readme.redirected-properties.column.a.19": "Redirected Property Register Type",
	"configuration.bulk.readme.redirected-properties.column.a.20": "Redirected Property Data Format",
	"configuration.bulk.readme.redirected-properties.column.a.21": "Redirected Property Raw Register",
	"configuration.bulk.readme.redirected-properties.column.a.22": "Redirected Property Object Type",
	"configuration.bulk.readme.redirected-properties.column.a.23": "Redirected Property Object Instance",
	"configuration.bulk.readme.redirected-properties.column.a.24": "Redirected Property MQTT Slug",
	"configuration.bulk.readme.redirected-properties.column.a.8": "Redirected Property ID",
	"configuration.bulk.readme.redirected-properties.column.a.9": "Redirected Property Gateway",
	"configuration.bulk.readme.redirected-properties.column.b.10": "Name of the redirected property",
	"configuration.bulk.readme.redirected-properties.column.b.11": "Description of the redirected property",
	"configuration.bulk.readme.redirected-properties.column.b.12.1": "Unique identifier in your system (and per box) to reference the property.",
	"configuration.bulk.readme.redirected-properties.column.b.12.2": "Different than the MQTT slug, see below.",
	"configuration.bulk.readme.redirected-properties.column.b.13.1": "Indicates if the property values are available through the cloud console and the APIs (remote). With read and/or write access. Or if it is local (not sent to the cloud) and by default with read and/or write access locally.",
	"configuration.bulk.readme.redirected-properties.column.b.13.2": "You can choose the appropriate value using the drop-down list in the cell.",
	"configuration.bulk.readme.redirected-properties.column.b.14": "Name of the property from which it is redirected",
	"configuration.bulk.readme.redirected-properties.column.b.15": "Name of the property to which it is redirected",
	"configuration.bulk.readme.redirected-properties.column.b.16.1": "The engineering unit of the property.",
	"configuration.bulk.readme.redirected-properties.column.b.17": "Indicates if the property is synchronized with the box.",
	"configuration.bulk.readme.redirected-properties.column.b.18.1": "Register address of the property. For",
	"configuration.bulk.readme.redirected-properties.column.b.19.1": "Type of register to use. For",
	"configuration.bulk.readme.redirected-properties.column.b.20.1": "Format of the data. For",
	"configuration.bulk.readme.redirected-properties.column.b.21.1": "Raw register to use. For",
	"configuration.bulk.readme.redirected-properties.column.b.22.1": "Type of the object. For",
	"configuration.bulk.readme.redirected-properties.column.b.23.1": "The object instance ID. For",
	"configuration.bulk.readme.redirected-properties.column.b.24.1": "Slug used as identifier of the property value on MQTT. For",
	"configuration.bulk.readme.redirected-properties.column.b.8": "Unique identifier of the redirected property in database.",
	"configuration.bulk.readme.redirected-properties.column.b.9": "Name of gateway to which property belongs",
	"configuration.bulk.readme.redirected-properties.column.b.gateways-only": "gateways only.",
	"configuration.bulk.readme.table.choose-correct-value": "Choose the correct value using the drop-down list in the cell.",
	"configuration.bulk.readme.table.column.value.128hex": "128-bit value in hexadecimal",
	"configuration.bulk.readme.table.column.value.64hex": "64-bit value in hexadecimal",
	"configuration.bulk.readme.table.column.value.coil": "- COIL",
	"configuration.bulk.readme.table.column.value.current": "- CURRENT if the equipment is synchronized with the box,",
	"configuration.bulk.readme.table.column.value.decimal": "decimal",
	"configuration.bulk.readme.table.column.value.disable": "- DISABLE",
	"configuration.bulk.readme.table.column.value.draft": "- DRAFT otherwise.",
	"configuration.bulk.readme.table.column.value.dropdown": "drop-down list",
	"configuration.bulk.readme.table.column.value.enable": "- ENABLE",
	"configuration.bulk.readme.table.column.value.holding-register": "- HOLDING_REGISTER",
	"configuration.bulk.readme.table.column.value.input-discrete": "- INPUT_DISCRETE",
	"configuration.bulk.readme.table.column.value.input-register": "- INPUT_REGISTER",
	"configuration.bulk.readme.table.column.value.integer": "integer",
	"configuration.bulk.readme.table.column.value.local": "- LOCAL",
	"configuration.bulk.readme.table.column.value.numeric": "Alphanumeric ID",
	"configuration.bulk.readme.table.column.value.read": "- REMOTE_READ_ONLY",
	"configuration.bulk.readme.table.column.value.read-write": "- REMOTE_READ_WRITE",
	"configuration.bulk.readme.table.column.value.text": "text",
	"configuration.bulk.readme.table.column.value.write": "- REMOTE_WRITE_ONLY",
	"configuration.bulk.readme.table.header.a": "Column name",
	"configuration.bulk.readme.table.header.b": "Description",
	"configuration.bulk.readme.table.header.c": "Value type",
	"configuration.bulk.readme.table.header.d": "Editable value",
	"configuration.bulk.readme.table.header.e": "Example",
	"configuration.bulk.readme.table.no-change-value": "Do not change this value.",
	"configuration.bulk.readme.table.title": "Columns definition",
	"configuration.bulk.readme.title": "Introduction",
	"configuration.bulk.update": "Bulk edit configuration",
	"configuration.bulk.update.action": "Update configuration",
	"configuration.bulk.update.confirm.equipments.gateways.body": "At least one property of the updated equipment is redirected to a BACnet IP or MQTT gateway. Such gateways can use the equipment name in their redirection. Do you want to reflect the new name of the equipment in the gateways?",
	"configuration.bulk.update.confirm.equipments.gateways.title": "Use the new equipment name in BACnet IP or MQTT redirected property names",
	"configuration.bulk.update.confirm.equipments.topics.body": "At least one property is redirected to a MQTT gateway. Such gateway can use the equipment name in the uplink topic format. If this is the case, all the redirected property topics of this gateway will be updated accordingly.",
	"configuration.bulk.update.confirm.equipments.topics.title": "Use the new equipment name in MQTT gateway topic",
	"configuration.bulk.update.confirm.properties.gateways.body": "At least one property is redirected to a BACnet IP or MQTT gateway. These gateways may need to be updated to reflect your property changes. Would you like to apply the changes to the gateways?",
	"configuration.bulk.update.confirm.properties.gateways.title": "Apply the property changes to the gateways",
	"configuration.bulk.update.confirm.properties.topics.body": "At least one property is redirected to a MQTT gateway. Such gateway can use the property name property name in the uplink topic format. If this is the case, all the redirected property topics of this gateway will be updated accordingly.",
	"configuration.bulk.update.confirm.properties.topics.title": "Use the new property name in MQTT gateway topic",
	"configuration.bulk.update.confirmation": "Yes, apply the change to the gateways",
	"configuration.bulk.update.error": "Error when updating configuration. Download the source file with the error messages.",
	"configuration.bulk.update.export": "Select the content to update",
	"configuration.bulk.update.export.error": "An error occurred while exporting your data. Please try again.",
	"configuration.bulk.update.file-to-import": "Upload the updated file ",
	"configuration.bulk.update.file-to-update": "Update the file",
	"configuration.bulk.update.import.error": "Make sure you've selected the right type of content to update in the previous step.",
	"configure-connector": "Configure connector",
	"configure-ethernet-connector": "Configure Ethernet connector",
	"configure-gateway": "Configure the gateway",
	"configure-heating-optimiser": "Configure Heating Optimiser",
	"configure-how-to-run-the-mbus-scan": "Configure how to run the MBUS scan",
	"configure-individual-and-internal-address-box": "Configure Individual and Internal Address of the @.lower:{'box'}.",
	"configure-knx-network": "Configure KNX network",
	"configure-lon-ip852-network": "Configure LON IP852 network",
	"configure-lorawan-network": "Configure LoRaWAN network",
	"configure-mbus-protocol": "Configure MBUS protocol",
	"configure-network-RVL-equipment": "Configure Network for RVL Equipment",
	"configure-network-lon-ip852": "Configure LON IP852 addresses in the @.lower:box",
	"configure-new-gateway": "Configure a new gateway",
	"configure-new-routing": "Add a new route",
	"configure-properly-property": "Configure properly the property",
	"configure-routing": "Configure the route",
	"configuring-bacnet-msg": "Configuring @.lower:{'box'}. This might take a while. Hold on, please.",
	"configuring-connector": "Configuring connector",
	"configuring-network": "Configuring network",
	"confirm": "Confirm",
	"congratulations": "Congratulations!",
	"connection": "Connection",
	"connection-inactive": "Connection inactive",
	"connection-ko": "Connection KO",
	"connection-ok": "Connection OK",
	"connectivity": "Connectivity",
	"connector": "Connector",
	"connector-and-triggers-duplicated": "Connector and triggers duplicated",
	"connector-canot-get-ip-address": "Connector {connector} can't get an IP Address",
	"connector-configuration-different-from-equipment-default-configuration": "The connector configuration is different from equipment default configuration (ignore this warning if you have changed the configuration from the equipment).",
	"connector-ko-because-cant-get-ip": "The connector is KO because it can't get an IP address",
	"connector-name-triggers": "Connector \"{name}\" triggers",
	"connector-saved": "Connector saved",
	"connectors": "Connectors",
	"connectors-for": "Connectors for \"{name}\"",
	"control": "Control",
	"copied-to-clipboard": "Copied to clipboard",
	"copy": "copy",
	"copy-all-info": "Copy all info",
	"copy-gateway": "Copy to the gateway:",
	"copy-of": "Copy of",
	"copy-to-clipboard": "Copy to clipboard",
	"copypaste-copied": "Copied",
	"copypaste-copy": "Copy",
	"copypaste-paste": "Paste",
	"count": "Count",
	"create-a-lorawan-network": "Create a LoRaWAN network",
	"create-a-new-network": "Create a new network",
	"create-archive-request": "Create Data Archive Request",
	"create-equipment": "Create equipment",
	"create-equipments": "Create equipment",
	"create-licence-for-this-organization": "Create a license for this organization",
	"create-lorawan-network": "Create LoRaWAN network",
	"create-new-equipment": "Create new equipment",
	"create-new-gateway": "Create new gateway",
	"create-new-notification": "Create new notification",
	"create-new-organization": "Create organization",
	"create-new-properties": "Create new properties",
	"create-properties": "Create properties",
	"create-the-trigger": "Create the trigger",
	"create-your-first-connector": "Create your first connector",
	"create-your-first-trigger": "Create your first trigger",
	"created-at": "Created at",
	"created-by": "Created by",
	"creating-all-equipment": "Creating all equipment",
	"creation-date": "Creation date",
	"critical": "Critical",
	"csv-file-format": "Allowed format: .CSV with UTF-8 encoding and comma delimiter",
	"csv-xlsx-file-format": "Allowed format: .xlsx, .csv with UTF-8 encoding (comma or semicolon delimiter)",
	"current": "Current",
	"current-configuration": "Current configuration",
	"current-rate-plan": "License paired today",
	"current-status": "Current status",
	"current-value": "Current value",
	"curve": "Curve",
	"custom": "Custom",
	"custom-mqtt-slug": "Custom MQTT slug",
	"custom-routing-table": "Custom routing table",
	"daily": "Daily",
	"daily-schedule-help-msg-1": "Because the equipment is of type RVL, you can define up to 6 slots during a day. The NORMAL mode will apply at the beginning of the slot. It will end either at the beginning of the next slot or either at the end of the day according to your settings. The REDUCED mode will apply in between and outside the slots.",
	"daily-schedule-help-msg-1-knx": "Please be mindful of the equipment local time as the schedule will be stored in the equipment and it will be executed by the equipment.",
	"daily-schedule-help-msg-2-knx": "Because the equipment is of type Synco, you can define up to 6 slots. The DEFAULT mode will apply till the beginning of the first slot.",
	"daily-schedule-invalid-consecutive-time": "Start time is not coherent with the previous slot start time",
	"daily-schedule.copy-day-btn": "Apply this schedule to",
	"dashboard": "Dashboard",
	"dashboard-exit-full-screen": "Exit full screen",
	"dashboard-go-full-screen": "Full screen",
	"dashboard-name": "Dashboard name",
	"dashboard-properties-table-tooltip": "Select the properties you would like to see in the cells of the table",
	"dashboard-properties-tile-tooltip": "There will be as many \"Single value\" charts added to the Dashboard as there are properties selected",
	"dashboard.card.hover": "Drag and drop your image in PNG or JPEG format",
	"dashboard.dropzone.invalid": "Only images in jpeg and png formats below 5MB are supported. Please edit the image and upload it again",
	"dashboard.no-schedule-yet": "You haven't created a schedule yet.",
	"dashboard.option-of-schedule": "Schedule display",
	"dashboard.schedule-day-of-the-week": "Day of the week",
	"dashboard.schedule-option.5days": "5 days sliding",
	"dashboard.schedule-option.day": "Single day",
	"dashboard.schedule-option.week": "Week without week-end",
	"dashboard.schedule-type": "Schedule",
	"dashboard.schedule-type-plural": "Schedules",
	"dashboard.schedule.in-console": "Schedule created in the console",
	"dashboard.schedule.in-regulator": "Controller schedule",
	"dashboard.type-of-schedule": "Type of schedule",
	"dashboard.want-to-create-one": "Do you want to create one?",
	"dashboards": "Dashboards",
	"data-bits": "Data bits",
	"data-format": "Data Format",
	"data-point-type": "Data point type",
	"data-points-expected-got": "Last check {since} ago <span class=\"has-text-grey-400\">({date})</span>. <br> Between {start} and {end}: <ul><li>Minimum expected values: {expected}</li><li>Received values: {got}</li></ul><p class=\"has-text-grey-400 mt-2 is-italic\">Next check at {next}</p>",
	"data-streams": "Data Streams",
	"data-streams-available-only-boxes-because-data-have-be-present-in-console": "Data streams are only available for @.clientname:_boxes because the data have to be present in the console",
	"data-type": "Data Type",
	"datapoint.tooltip": "DP (Datapoint): number of points included in the license",
	"datastream-connector-error.cause-label": "Cause:",
	"datastream-connector-error.error-label": "Error:",
	"datastream-connector-error.last-error-received": "Below is the latest error received:",
	"datastream-connector-error.mqtt-custom.authentication": "CUSTOM broker type must have at least one type of authentication: either basic authentication or certificate authentication",
	"datastream-connector-error.tooltip": "Data stream error. <br/>Click to see the details.",
	"datastreams.connector-config-kb.msg": "Define your {type} connector settings. {link}",
	"datastreams.connector-error.notifications": "Error notification",
	"datastreams.connector-error.notifications.help-msg": "Add people to notify in case of connector failure",
	"date": "Date",
	"date-range": "Date Range",
	"date-time-is-out-of-service-msg": "This exception is disabled. Edit the property to enable it.",
	"datepicker-last-x-days": "Last {days} days",
	"datepicker-last-year": "Last Year",
	"dates-and-time": "Dates & Time",
	"day": "Day",
	"days": "Days",
	"default": "default",
	"default-class-a": "Default (class A)",
	"default-format-used-for-slug-properties": "Default format used for the properties slug. The value can be personalized for each property.",
	"default-routing-table": "Default routing table",
	"default-severity": "Default severity",
	"default-value": "Default value",
	"define-temporization": "Define temporization",
	"defines-end-of-event": "Defines the time event ends.",
	"defines-how-data-is-interpreted-and-encoded-equipment": "Defines how the data is to be interpreted and encoded on the equipment",
	"defines-start-of-event": "Defines the start of the event and when it will happen.",
	"delete": "Delete",
	"delete-certificate": "Delete certificate",
	"delete-connector": "Delete connector",
	"delete-dashboard-block": "Delete chart",
	"delete-equipment": "Delete equipment",
	"delete-gateway-properties-linked-to-this-equipment": "Delete gateway properties linked to this equipment?",
	"delete-properties": "Delete property | Delete properties",
	"delete-schedule-linked-to-items": {
		"linked-to-alarm-body": "This schedule is used in one or more alarms ({alarms}).{br}Edit these alarms first before deleting the schedule.",
		"linked-to-automation-body": "This schedule is used in one or more scenarios ({scenarios}).{br}Edit these scenarios first before deleting the schedule.",
		"title": "The schedule can't be deleted"
	},
	"delete-schedule-property-linked-to-rtn": {
		"body": "The property \"{propertyName}\" is used in one or more scenarios ({scenarios}) with a return-to-normal value set in the schedule.{br}Edit these scenarios first before removing the property from the schedule.",
		"title": "The property can't be removed from the schedule"
	},
	"delete-this-field": "Delete field",
	"delete-trigger-triggername": "Delete trigger \"{trigger}\"?",
	"delete-widget": "Delete the widget",
	"delete-x-properties": "Delete 1 property | Delete {x} properties",
	"delta": "Delta (Last - First)",
	"description": "Description",
	"description-use-mask-identification-number": "Only the equipment whose identification number inside their secondary address matches the mask will be retrieved.",
	"deselect": "Deselect",
	"destination": "Destination",
	"details": "Details",
	"dev-eui": "Dev EUI",
	"deveui": "DevEUI",
	"device": "Device",
	"device-as-box": "Device",
	"device-created-with-success": "Device created with success",
	"device-extended-universal-identifier": "Device Extended Universal Identifier",
	"device-instance": "Device Instance",
	"device-instance-for-network-this-device-instance-unique-on-box": "A device instance for the @.lower:{'box'}'s network. This device instance has to be unique on the @.lower:{'box'}.",
	"device-name": "Device Name",
	"device-number": "Device number",
	"device-number-description": "The device number of the LPB equipment",
	"device-type": "Device Type",
	"device.header.connected": "@.capitalize:box connected to the console",
	"device.header.connexion.eth": "@.capitalize:box connected to the console",
	"device.header.connexion.gsm": "Cellular network signal strength",
	"devices": "Devices",
	"devices-found": "Found devices",
	"devices.configuration": "Settings",
	"dialog-active-box.box-name-tooltip": "Give a name to the {box} (you can change it later)",
	"dialog.archive-sent.body": "Your request is under process. Once your archive is ready, you will be notified by email.",
	"dialog.archive-sent.body.schedule": "Your request is scheduled to auto-export. You will receive it at the frequency you have specified.",
	"dialog.archive-sent.title": "Request sent",
	"dialog.archive-sent.title.schedule": "Request saved",
	"dialog.autodiscovery-refresh-scan.body": "All the selected properties will be unselected if you refresh the scan.",
	"dialog.autodiscovery-refresh-scan.title": "Refresh scan",
	"dialog.config-wizard-request-equipment.body": "We are processing your request. Our team will reach out to you by email to let you know about the progress.",
	"dialog.config-wizard-request-equipment.title": "Request sent",
	"dialog.confirm-timer-below-60.body": "You set an interval below 60 seconds. If there are several units on the network, it may negatively impact the communication between the box and the devices. If you do not have any specific requirements, please set it back to 60 seconds minimum.",
	"dialog.confirm-timer-below-60.title": "Confirm timer",
	"dialog.datastream-connector-error.confirm": "Edit",
	"dialog.datastream-connector-error.message": "The data stream connector has been in error since {dateTime} after 15 errors in a row.{br}Once the problem has been fixed, please restart the connection.",
	"dialog.datastream-connector-error.relaunch": "Relaunch",
	"dialog.datastream-connector-error.title": "Data stream error",
	"dialog.datastreams.disable.body": "This will stop data transmission.",
	"dialog.datastreams.disable.title": "Disable the connector",
	"dialog.delete-alarm.body": "This will delete the alarm \"{name}\" and all the alerts associated with the alarm.",
	"dialog.delete-alarm.title": "Delete alarm",
	"dialog.delete-api-key.body": "This will delete the API Key \"{name}\". It can't be undone.",
	"dialog.delete-api-key.title": "Delete API Key",
	"dialog.delete-automation-scenario.body": "This will delete automation scenario \"{name}\" and all of its instances.",
	"dialog.delete-automation-scenario.title": "Delete automation scenario",
	"dialog.delete-config.body": "This will delete all the changes made to the configuration since your last save.",
	"dialog.delete-config.confirm": "Revert changes",
	"dialog.delete-config.title": "Revert changes",
	"dialog.delete-dashboard-block.title": "Delete chart",
	"dialog.delete-dashboard.title": "Delete dashboard",
	"dialog.delete-equipment.alarms": "Alarms based on equipment properties will stop working",
	"dialog.delete-equipment.archives.1": "Recurring archives containing only equipment properties",
	"dialog.delete-equipment.archives.2": "Recurring archives containing other properties",
	"dialog.delete-equipment.body": "This will delete the equipment \"{equipment}\" and all its properties ({properties}).",
	"dialog.delete-equipment.body.bridge": "This will permanently delete the equipment “{equipment}” and its {properties}. | This will permanently delete {equipments} and their {properties}.",
	"dialog.delete-equipment.body.tower": "This will permanently delete the equipment “{equipment}” and its {properties}. | This will permanently delete {equipments} and their {properties}.",
	"dialog.delete-equipment.calendar": "Setpoints based on a schedule (schedule retained)",
	"dialog.delete-equipment.checkbox": "Delete the gateway properties linked to this equipment. if not checked, the redirected properties will be retained.",
	"dialog.delete-equipment.dashboard": "Dashboard widgets containing other properties",
	"dialog.delete-equipment.graphs": "Charts",
	"dialog.delete-equipment.historic": "History of recorded values",
	"dialog.delete-equipment.redirected-properties": "Redirects from or to equipment properties",
	"dialog.delete-equipment.schedules": "Scenarios where equipment properties are used",
	"dialog.delete-equipment.streams": "Datastreams",
	"dialog.delete-equipment.this": "Equipment properties will be removed from:",
	"dialog.delete-equipment.title": "Delete equipment",
	"dialog.delete-equipment.virtual-properties": "Virtual properties based on equipment properties",
	"dialog.delete-equipment.widgets": "Dashboard widgets based solely on equipment properties",
	"dialog.delete-event.title": "Delete event",
	"dialog.delete-gateway.body": "This will delete \"{gateway}\" and all its properties ({properties}).",
	"dialog.delete-gateway.title": "Delete gateway",
	"dialog.delete-graph.body": "This will delete this graph",
	"dialog.delete-graph.title": "Delete graph",
	"dialog.delete-network.body": "This will delete network \"{network}\". It will not delete the equipment or the gateways already configured on this network.",
	"dialog.delete-network.title": "Delete network",
	"dialog.delete-notifications.title": "Delete event notification",
	"dialog.delete-property.alarms": "Alarms based on this property will stop working | Alarms based on these properties will stop working",
	"dialog.delete-property.archives.1": "Recurring archives containing only this property | Recurring archives containing only these properties",
	"dialog.delete-property.archives.2": "Recurring archives containing other properties",
	"dialog.delete-property.body": "This will permanently delete the property “{property}”. | This will permanently delete the {properties}.",
	"dialog.delete-property.body.bridge": "This will permanently delete the property “{property}”. | This will permanently delete the {properties}.",
	"dialog.delete-property.calendar": "Setpoints based on a schedule (schedule retained)",
	"dialog.delete-property.dashboard": "Dashboard widgets containing other properties",
	"dialog.delete-property.graphs": "Charts",
	"dialog.delete-property.historic": "History of recorded values",
	"dialog.delete-property.redirected-properties": "Redirects from or to this property | Redirects from or to these properties",
	"dialog.delete-property.schedules": "Scenarios where the property is used | Scenarios where the properties are used",
	"dialog.delete-property.streams": "Datastreams",
	"dialog.delete-property.this": "This property will be removed from: | These properties will be removed from:",
	"dialog.delete-property.virtual-properties": "Virtual properties based on this property | Virtual properties based on these properties",
	"dialog.delete-property.widgets": "Dashboard widgets based solely on this property | Dashboard widgets based solely on these properties",
	"dialog.delete-routing.body": "This will delete the routing \"{name}\".",
	"dialog.delete-routing.title": "Delete routing",
	"dialog.delete-schedule-state-linked-to-alarm.body": "One or several alarms ({alarms}) still use the slot type in their configuration. Please edit the alarms first to stop linking them to the slot type.",
	"dialog.delete-schedule-state-linked-to-alarm.title": "Impossible to delete the slot type \"{name}\"",
	"dialog.delete-schedule.body": "This will delete the schedule \"{name}\".",
	"dialog.delete-schedule.title": "Delete schedule",
	"dialog.end-impersonation-session.body": "You are about to end your impersonation session",
	"dialog.end-impersonation-session.title": "End Impersonation Session",
	"dialog.graph-archive-sent.body": "Your request is under process. You will receive it by email as soon as it's ready.",
	"dialog.graph-archive-sent.title": "Request sent",
	"dialog.graph-unsaved-changes-save.body": "You have unsaved changes. Leaving this page will delete changes made to the graph",
	"dialog.graph-unsaved-changes.title": "Leave page with unsaved changes?",
	"dialog.lorawan-equipment-duplication.body": "Please do a rejoin between the equipment and \"{boxDestinationName}\".",
	"dialog.lorawan-equipment-duplication.cancel": "Close",
	"dialog.lorawan-equipment-duplication.confirm": "Go to the duplicated equipement",
	"dialog.lorawan-equipment-duplication.title": "Equipment duplicated. What do you want to do now?",
	"dialog.lpb-equipment-device-number-1.body": "You set the device number to 1 which means that the equipment {equipmentName} will be the master on the segment {segmentNumber}. Do you confirm?",
	"dialog.lpb-equipment-device-number-1.title": "LPB equipment",
	"dialog.lpb-equipment-segment-number.body": "You set the segment number to {segmentNumber}. The LPB network registered on the @.lower:box uses the segment number {boxSegmentNumber}. Having different segment numbers means that the device won't be able to communicate with the new equipment. Do you confirm?",
	"dialog.lpb-equipment-segment-number.title": "LPB equipment",
	"dialog.mqtt-slug-change.body": "By changing the format of the slug, all the properties defined in the gateway that don't have a custom slug, will follow the new format. Do you confirm the changes?",
	"dialog.mqtt-slug-change.title": "Modify the slug?",
	"dialog.mqtt-uplink-change.body": "By changing the format of the uplink topic, all the topics of the properties defined in the gateway will follow the new format. Do you confirm the changes?",
	"dialog.mqtt-uplink-change.title": "Modify the MQTT uplink topic format?",
	"dialog.request-new-scan.body": "This action will delete the current scan. It is irreversible. Depending on the network, the new scan might take some time.",
	"dialog.request-new-scan.title": "Request new scan",
	"dialog.rvl-even-slots.body": "The number of slots edited is odd. To comply with the behaviour of the RVL a last slot will be added with the mode (\"REDUCED\").",
	"dialog.rvl-even-slots.confirm": "Add slot",
	"dialog.rvl-even-slots.title": "Add slot automatically?",
	"dialog.schedules.change-timezone.body": "Only one timezone can be set in a box at a time. If you edit the timezone for this schedule, the new timezone will be used in the other schedules.",
	"dialog.schedules.change-timezone.title": "Do you confirm the timezone change?",
	"dialog.schedules.change-used-states-info.body": "The types of slots are shared across all the schedules of a box. The changes will be visible in the other schedules.",
	"dialog.schedules.change-used-states-info.title": "Change the types of slots?",
	"dialog.schedules.request-trial.body": "The <b>“Control” range</b> offers new capabilities to control your building. Starting with the <b>schedule feature</b>, you can set setpoint values based on a weekly schedule. <br /><b>Upgrade your subscription for free</b> for 30 days. <b>Once the 30-day trial ends</b> and you don't renew your Control product, your box will return to its original subscription or licence.<br />The free trial activation is not immediate. The new features will be available within two working days and visible under the Configuration tab.",
	"dialog.schedules.request-trial.btn": "Try Control",
	"dialog.schedules.request-trial.cta": "Start the free trial",
	"dialog.schedules.request-trial.success": "We received your request and will activate Control for your box soon.",
	"dialog.schedules.request-trial.title": "Activate your “Control” free trial",
	"dialog.service-account.delete-service-account-body": "This will delete permanently the service account \"{name}\".",
	"dialog.service-account.delete-service-account-title": "Delete service account",
	"dialog.temp-warning-max-property-count.body": "The number of properties and virtual properties, {current}, is above the total number of properties included in your subscription, {max}. In an upcoming change to your subscription, this configuration won’t be possible, and the total number of properties will have to be less or equal than your subscription limit. You can send the configuration as it is, but after the upcoming change, it will no longer be possible.",
	"dialog.temp-warning-max-property-count.title": "Upcoming change in your subscription",
	"dialog.unsaved-changed.body": "Changes will be lost if you leave without saving.",
	"dialog.unsaved-changed.title": "Unsaved changes",
	"dialog.virtual-properties.delete-property-body": "This will delete permanently the virtual property \"{name}\".",
	"dialog.virtual-properties.delete-property-body.1": "History of recorded values",
	"dialog.virtual-properties.delete-property-body.10": "Alarms based on this property will stop working",
	"dialog.virtual-properties.delete-property-body.2": "Dashboard widgets based solely on this property",
	"dialog.virtual-properties.delete-property-body.3": "Virtual properties based on this property",
	"dialog.virtual-properties.delete-property-body.4": "Recurring archives containing only this property",
	"dialog.virtual-properties.delete-property-body.5": "This property will be removed from:",
	"dialog.virtual-properties.delete-property-body.6": "Dashboard widgets containing other properties",
	"dialog.virtual-properties.delete-property-body.7": "Charts",
	"dialog.virtual-properties.delete-property-body.8": "Datastreams",
	"dialog.virtual-properties.delete-property-body.9": "Recurring archives containing other properties",
	"dialog.virtual-properties.delete-property-title": "Delete virtual property",
	"dialog.wizard-gateway-exit.body": "Leaving this page will delete changes made to the property selection.",
	"dialog.wizard-gateway-exit.title": "Leave page?",
	"different-lpb-related-data-formats": "The different LPB related data formats supported by the latest version of the device",
	"disable": "Disable",
	"disable-schedule-linked-to-items": {
		"linked-to-alarm-body": "This schedule is used in one or more alarms ({alarms}).{br}Edit these alarms first before disabling the schedule.",
		"linked-to-automation-body": "This schedule is used in one or more scenarios ({scenarios}).{br}Edit these scenarios first before disabling the schedule.",
		"title": "The schedule can't be disabled"
	},
	"disable-x-properties": "Disable 1 property | Disable {x} properties",
	"disabled": "Disabled",
	"disabled-lorawan-tti-tooltip": "You can't redirect those properties because your LoRaWAN server is not in the @.lower:box",
	"discontinued-in": "discontinued in {date}",
	"display-name-in-console": "Display name",
	"do-not-update-equipment": "Only the equipment",
	"do-not-update-property": "Only the property",
	"do-you-want-to-delete-connector": "Do you want to delete connector {connector}?",
	"documentation": "documentation",
	"does-it-end": "Does it end?",
	"doesnt-work-lorawan-because-lorawan-sensors-autonomous-decides-its-own-when-sends-data": "It can't be used with LoRaWAN sensor because it's autonomous and decides on its own when it sends data",
	"domain": "Domain",
	"domain-box-on-lon-ip-network": "The domain of the @.lower:box on the LON IP network",
	"dont-have-permission-to": "You don't have permission to {action}",
	"dot-not-update-no-confidence": "If you are unsure, we recommend not applying the changes to the gateways.",
	"down": "KO",
	"downlink-topic": "Downlink topic",
	"download": "Download",
	"download-configuration": "Download configuration",
	"download-desktop-app": "Download Desktop App",
	"download-license": "Download license",
	"download-link": "Download Link",
	"download-the-error-report": "Download the error report.",
	"download-the-error-report-and-restart": "Download the error report and restart",
	"download-this-template": "Download this template",
	"downloading-archive": "Downloading archive",
	"draft": "Draft",
	"draft-configuration": "Draft configuration",
	"drag-drop-csv": "Drag and drop your CSV file ",
	"drag-drop-file-or-click": "Drag and drop your file or click on the button",
	"drag-drop-file-or-click-button": "Drag and drop your file or click on the button",
	"drag-drop-here": "Drag and drop your file",
	"drag-file-here": "Drag file here",
	"drag-image-here": "Drag and drop or choose a file to upload your image. All .png, .jpeg and .jpg file types are supported.",
	"duplicate": "Duplicate",
	"duplicate-another-equipment": "Duplicate another equipment",
	"duplicate-connector": "Duplicate connector",
	"duplicate-equipment": "Duplicate equipment",
	"duplicate-lorawan-equipment": "Duplicate LoRaWAN equipment",
	"duplicate-trigger": "Duplicate trigger",
	"duplicate.equipment.redirected-properties": "Duplicate redirected properties",
	"duplicate.equipment.redirected-properties.tooltip": "Equipment properties are copied by default. This option allows you to copy properties redirected to a gateway.",
	"duplicated": "Duplicated!",
	"duplicated-f": "Duplicated!",
	"duration": "Duration",
	"during": "During",
	"ede.export.content.1": "The file is available in your browser's “Downloads” folder.",
	"ede.export.content.2": "To select the properties to be added to the configuration from the file:",
	"ede.export.content.3": "Indicate in the “<strong>Selected</strong>” column:",
	"ede.export.content.4": "Mark with a cross: the properties to be added",
	"ede.export.content.5": "Leave blank for properties to be ignored",
	"ede.export.content.6": "Save changes",
	"ede.export.content.7": "Import the file",
	"ede.export.note": "Note: modify only the “Selected” column; other changes are ignored. Once added to the configuration, BACnet properties can be bulk edited at a later stage.",
	"ede.export.properties.successfull": "Scan result",
	"ede.export.scanned.properties": "Export scanned properties",
	"ede.export.waiting.scan": "Please wait for the scan to be completed before exporting properties",
	"edit": "Edit",
	"edit-box": "Edit @.lower:_box",
	"edit-configuration": "Edit the configuration",
	"edit-connector": "Edit connector",
	"edit-equipment-new-tab": "Open equipment properties in a new tab",
	"edit-event": "Edit event",
	"edit-indicator": "Edit Indicator",
	"edit-properties": "Update properties",
	"edit-property": "Edit Property",
	"edit-trigger": "Edit trigger",
	"edit-value": "Edit the value",
	"edit-widget": "Edit the widget",
	"effective-period": "Effective Period",
	"effective-period-invalid-range": "The start and end days must be coherent",
	"element-affected": "Affected item: | Affected items:",
	"element-deleted": "Deleted item: | Deleted items:",
	"email": "E-mail",
	"email-to": "E-mail to",
	"empty-state": {
		"alarms": {
			"action": "Create alarm",
			"description": "Be alerted by email or text messages  if unexpected behavior occurs, thanks to remote alarms. Link them to a schedule for optimum management.",
			"title": "Keep control of your building"
		},
		"archives": {
			"action": "Request archive",
			"description": "Request an archive to receive the data collected by your box and carry out a customized analysis of your building's operation.",
			"title": "Export equipment data"
		},
		"automation": {
			"action": "Create scenario",
			"description": "Automatically send new setpoints to equipment or modify a schedule slot according to the property values received.",
			"title": "Automate your building's operations"
		},
		"dashboards": {
			"action": "Create dashboard",
			"description": "Visualize equipment property values in real time on a schematic. Build dashboards with your key indicators and equipment schedules.",
			"new-dashboard": {
				"description": "Build your dashboard with widgets to visualize the status of your building in real time.",
				"title": "Create dashboard"
			},
			"schematic": {
				"description": "Drag and drop a plan or technical drawing in PNG or JPEG format to position your properties.",
				"title": "Create schematic"
			},
			"title": "Monitor your building"
		},
		"graphs": {
			"action": "Create graph",
			"action-temp": "Select property ↓",
			"description": "Track and analyze the value of one or more properties over time.",
			"title": "Keep track of your building"
		},
		"schedules": {
			"control": {
				"action": "Create schedule",
				"description": "Enter the building's occupancy in a schedule. Use this schedule to automatically write values to properties.",
				"title": "Control your equipment with time programming"
			},
			"no-control": {
				"action": "Create schedule",
				"description": "Enter the building's occupancy in the schedule and then use it to modulate your alarms.",
				"title": "Declare the building's occupancy"
			}
		},
		"settings": {
			"equipments": {
				"action": "Add equipment",
				"description": "Declare your first equipment and send the configuration to the box to add it permanently.",
				"title": "Welcome to your box configuration"
			},
			"gateways": {
				"action": "Create gateway",
				"description": "Configure a gateway, then select properties for using the box as a BACnet server or Modbus server, and for sending data to an MQTT broker.",
				"title": "Transfer received data"
			},
			"networks": {
				"action": "Add network",
				"description": "Add your BACnet, KNX, LoRaWAN, M-Bus or Modbus network. The box will communicate as a client on BACnet or Modbus networks. To configure the box as a server, go to \"Gateways\".",
				"title": "It all starts with a network"
			},
			"virtual-properties": {
				"action": "Create virtual property",
				"description": "Calculate consumption or perform  calculations based on existing properties.",
				"title": "Create properties from existing ones"
			}
		}
	},
	"enable": "Enable",
	"enable-edition-of-network-configuration": "Enable edition of network configuration",
	"enable-plural": "enabled",
	"enable-temporization-msg": "Automatically close the alarm when the condition returns to normal",
	"enable-temporization-tooltip": "If the condition is no longer observed with a number of occurrences equivalent to that required to trigger the alarm and during the same interval, then the alarm is closed and its history.",
	"enable-x-properties": "Enable 1 property | Enable {x} properties",
	"enabled": "Enabled",
	"encryption": "Encryption",
	"end": "End",
	"end-date": "End date",
	"end-time": "End time",
	"ending": "ending",
	"english": "English",
	"enter-brand-model-or-select-from-list": "Enter Brand or Model or select in the list",
	"enter-code-list-codes-or-enter-asterisks-to-any-code": "Enter a code {url}. Or enter '*' to be notified for any code.",
	"equipment": "Equipment",
	"equipment-bulk-create-import-csv-msg1": "Adding devices in bulk is only available for devices that use <strong>LoRaWAN</strong> and that are included in our <strong>decoded equipment library</strong>.",
	"equipment-bulk-create-import-csv-msg2": "The list of equipment must respect a precise format. {template} and complete it with the desired equipment.",
	"equipment-bulk-create-network-existing-msg": "A LoRaWAN network already exists. If you change its configuration, it will change the equipment attached to it too. If you want to change the network configuration, click in the button below.",
	"equipment-bulk-create-network-msg": "You haven't created a LoRaWAN network yet. Please create one before proceeding to create the equipment. The new equipment will use this network",
	"equipment-creation": "Creation of equipment",
	"equipment-creation-mapping-msg": "Please associate each model from your file with the corresponding reference",
	"equipment-deleted": "Equipment deleted",
	"equipment-discriminator": "Equipment Discriminator",
	"equipment-discriminator-description": "Information identifying the equipment: DevEUI for LoRaWAN, Device Instance for BACnet, etc",
	"equipment-duplicated-successfully": "Equipment duplicated successfully",
	"equipment-id": "Equipment ID",
	"equipment-name": "Equipment name",
	"equipment-plural": "Equipment | Equipment",
	"equipment-properties": "Equipment properties",
	"equipment-required": "Equipment is required",
	"equipment-status-indicator-info-tooltip-txt": "KO: no data received in the last hour (24 hours for LoRaWAN equipment)<br />- : no connection status available for this equipment",
	"equipment-with-mbus-protocol": "Equipment with MBUS protocol",
	"equipment-with-modbus-serial-protocol": "Equipment with Modbus RTU protocol",
	"equipment-with-percentage-scan-refresh-to-update": "Equipment with {percentage}% scan concluded. Refresh scan to update.",
	"equipment-x-saved": "{n} saved equipment",
	"equipments": "Equipment",
	"equipments-properties": "Equipment properties",
	"equipments-status-to-be-checked-and-alarm-raised": "Connection lost with the equipment",
	"equipments.bms": "BMS",
	"equipments.meters": "Meters",
	"equipments.others": "Others",
	"error-communicating-with-hub-reception-properties-values-not-available": "Error while communicating with the @.lower:{'hub'}. The reception of the properties values is not available.",
	"error-field-hexadecimal-length": "{field} should be {characters} UPPERCASE hexadecimal characters",
	"error-occured": "An error has occurred. Please try again.",
	"error-occured-status-equipment": "Error retrieving equipment status. Please try again later.",
	"error.min-1-character": "The field should have at least 1 character.",
	"errors": "Errors",
	"even-months": "Even Months",
	"event": "Event",
	"event-code-0-999": "Generic",
	"event-code-0-999-range": "Generic (0 to 999)",
	"event-code-1000-1999": "Configuration",
	"event-code-1000-1999-range": "Configuration (1000 to 1999)",
	"event-code-2000-2999": "Network",
	"event-code-2000-2999-range": "Network (2000 to 2999)",
	"event-code-3000-3999": "Equipment",
	"event-code-3000-3999-range": "Equipment (3000 to 3999)",
	"event-code-4000-4999": "Property",
	"event-code-4000-4999-range": "Properties (4000 to 4999)",
	"event-code-5000-5999": "Equipment",
	"event-code-5000-5999-range": "Equipment (5000 to 5999)",
	"events-route": "Events route",
	"events-url": "Events url",
	"every-time-alarm-history-item-is-created": "Every time an alarm history item is created",
	"every-time-event-matching-code-received-on-console": "Every time an event matching the code is received on the console",
	"every-time-value-property-received-on-console": "Every time the value of a property is received on the console",
	"exception": "Exception",
	"existant-graph": "Existing graph",
	"expand-button-equipment-tooltip": "Expand all equipment",
	"expand-button-groups-tooltip": "Expand all groups",
	"expand-button-organization-tooltip": "Expand all organizations",
	"expand-collapse": "Expand/Collapse",
	"expected": "Expected",
	"expected-value": "Expected value",
	"expiration-date": "Expiration date",
	"expired": "Expired",
	"expires-on": "Expires on",
	"export": "Export",
	"export-configuration": "Export configuration",
	"export-ede-csv": "Export EDE (csv)",
	"export-ede-xlsx": "Export EDE (xlsx)",
	"export-file": "Export the file",
	"export-properties": "Export properties",
	"extended-time-max-format": "\"24:00\" is the last authorized value",
	"extended-time-seconds-max-format": "\"24:00:00\" is the last authorized value",
	"external": "External",
	"external-id": "External ID",
	"external-recipient": "The recipient does not have or will not have access to the console",
	"fail": "Fail",
	"fail-copying-to-clipboard": "Failed copying to clipboard",
	"failed": "Failed",
	"failed-activating-box": "Failed activating @.lower:box",
	"failed-adding-privileges-to-user": "Failed adding privileges to user",
	"failed-adding-property": "Failed adding property: {property}",
	"failed-bacnet-scan-autodiscovery": "Failed getting BACnet Scan. Please check your configuration.",
	"failed-creating-draft-refresh-page": "Failed creating Draft. Refresh the page, please.",
	"failed-creating-equipment": "Error when creating the equipment. Download the source file with the error messages. Then use it in step 1 to keep the correspondance of each equipment with its reference.",
	"failed-creating-gateway-properties": "Failed creating Gateway Properties",
	"failed-creating-new": "Failed creating new {thing}",
	"failed-creating-organization": "Failed creating new organization",
	"failed-creating-params-to-save-network": "Failed creating parameters to save network",
	"failed-creating-properties": "Error when creating properties. Download the source file with the error messages.",
	"failed-deleting-certificate": "Failed deleting certificate",
	"failed-deleting-connector": "Failed deleting connector",
	"failed-deleting-equipment": "Failed deleting equipment",
	"failed-deleting-rate-plan": "Failed deleting rate plan",
	"failed-downloading-archive-request-it-again": "Failed downloading archive, please request a new one.",
	"failed-downloading-desktop-app": "Failed download Desktop App",
	"failed-downloading-equipment-list": "Failed downloading equipment list",
	"failed-downloading-license": "Failed downloading license",
	"failed-duplicating-equipment": "Failed duplicating equipment",
	"failed-duplicating-trigger": "Failed duplicating trigger {name}",
	"failed-exporting-hub-configuration": "Failed exporting @.lower:hub configuration",
	"failed-get-draft-config": "Failed getting draft configuration",
	"failed-get-graph": "Failed getting graphs",
	"failed-get-networks-from-connectors": "Failed to get networks from connectors",
	"failed-getting-alarms": "Failed getting alarms",
	"failed-getting-alarms-history": "Failed getting alarms history",
	"failed-getting-archives": "Failed getting data archives",
	"failed-getting-available-bacnet-data-types": "Failed getting available BACnet Data Types",
	"failed-getting-available-networks": "Failed getting available networks",
	"failed-getting-connectors-configuration": "Failed getting connectors configuration",
	"failed-getting-current-configuration": "Failed getting current configuration",
	"failed-getting-encoders-configuration": "Failed getting encoders configuration",
	"failed-getting-equipment-info": "Failed getting equipment info",
	"failed-getting-equipment-list": "Failed getting equipment list",
	"failed-getting-equipment-protocol-config": "Failed getting equipment protocol configuration",
	"failed-getting-list-of-available-files": "Failed getting list of available files",
	"failed-getting-list-of-lorawan-codecs": "Failed getting list of LoRaWAN codecs",
	"failed-getting-lon-types": "Failed getting LON SNVT Types from API",
	"failed-getting-notifications": "Failed getting notifications",
	"failed-getting-orgaizations": "Failed getting organizations",
	"failed-getting-organization": "Failed getting organization",
	"failed-getting-properties": "Failed getting properties",
	"failed-getting-property-last-value": "Failed getting property last set value",
	"failed-getting-your-profile": "Failed getting your profile",
	"failed-importing-configuration": "Failed importing configuration",
	"failed-inspecting-command-wait-please": "Failed inspecting command received by @.lower:box . Wait, please",
	"failed-loading-scan": "Failed loading scan",
	"failed-refreshing-scan": "Failed refreshing the Scan",
	"failed-request-scan": "Failed requesting the scan to the @.lower:box",
	"failed-reverting-sent-changes": "Failed reverting sent changes",
	"failed-saving-connector": "Failed saving connector",
	"failed-saving-gateway": "Failed saving gateway",
	"failed-saving-new-name": "Failed saving new name",
	"failed-saving-property": "Failed saving property",
	"failed-saving-route": "Failed saving route",
	"failed-saving-trigger": "Failed saving trigger",
	"failed-sending-license": "Failed sending license",
	"failed-setting-value": "Failed setting new value",
	"failed-updating-alarm-event": "Failed updating alarm event",
	"failed-updating-alarm-priority": "Failed updating alarm priority",
	"failed-updating-alarm-status": "Failed updating alarm status",
	"failed-updating-file": "Failed updating file",
	"failed-updating-organization": "Failed updating organization",
	"failed-updating-permission-not-authorized": "Failed updating permissions. You're not allowed to do that.",
	"failed-updating-properties-with-gateway-redirection": "Failed updating properties with gateway properties redirection",
	"failed-updating-user-password": "Failed updating password",
	"failed-updating-user-profile": "Failed updating user profile",
	"failed-uploading-file": "Failed uploading file",
	"failed-validating-equipment": "Failed validating equipment: {message}",
	"failed-validating-network": "Failed validating network: {message}",
	"field": "Field",
	"field-is-required": "Field {field} is required",
	"field-must-be-a-decimal": "Field {field} must be a decimal",
	"field-must-be-format": "Field must be in format: {format}",
	"field-must-have-x-digits": "Field must have at most {digit} decimal places",
	"field-should-be-between-values": "Field {field} should be between {min} and {max}",
	"field-should-be-number-or-null": "Field {field} should be a number or empty",
	"field.required": "This field is required",
	"fields-are-required": "Not all fields are filled",
	"file": "File",
	"file-format": "File format",
	"file-input-description": "Accepted format: .json",
	"file-saved": "File saved",
	"file-too-big": "File too large",
	"file-too-big-size": "File too large, it must not exceed {sizeMB} MB",
	"file-type": "File type",
	"file-visibility": "File visibility",
	"filter": "Filter",
	"filter-group-or-equipment": "Search group or equipment",
	"filters": "Filters",
	"final-url": "Final URL",
	"find-equipment-want-to-connect-to-box": "Find the equipment you want to connect to the @.lower:box",
	"finished": "Finished",
	"finished-at": "Finished at",
	"firewall-disabled-allow-usb-connection": "The firewall is disabled to allow the USB connection",
	"first-visit": "First visit ?",
	"fix-setpoint": "Fix setpoints",
	"for-each-character-of-the-identification-number-enter-a-digit-between-0-and-9-or-the-letter-F-for-any-digit": "For each character of the identification number, enter a digit between 0 and 9, or the letter 'F' for 'any digit'.",
	"forgot-password": "Forgot Password?",
	"format": "Format",
	"formula-editor": {
		"help-message": "Allowed operators: {operatorList}. Use {point} for decimal numbers. Type {mention} to reference a property.",
		"invalid-message": "Invalid formula. Use {'@'}properties, operators and numbers. "
	},
	"found": "Found",
	"free-form-date-label": "Start date or end date of the holiday",
	"free-form-date-optional-month-help": "If the month is not set, the holiday will repeat every month on that day",
	"free-form-date-optional-year-help": "If the year is not set, the holiday will repeat every year on that day",
	"free-form-date-time-help-msg-lpb": "The protection mode or the holiday mode will apply during the holiday.",
	"free-form-time-help": "If the minute or/and the second are not set the default value is 0",
	"free-form-time-label": "Start time or end time of the holiday on that day",
	"french": "French",
	"frequency": "Frequency",
	"friday": "Friday",
	"from": "From",
	"from-bacnet-scan": "From BACnet Scan",
	"full-name": "Full name",
	"full-scan-in-the-network": "Full scan of the network",
	"function": "Function",
	"function-secondary": "Secondary Function",
	"gateway": "Gateway",
	"gateway-id": "Gateway ID",
	"gateway-ip-address": "Gateway IP address",
	"gateway-name": "Gateway name",
	"gateway-properties": "Gateway properties",
	"gateway-properties-saved": "Gateway properties saved",
	"gateway-saved": "Gateway saved",
	"general-settings": "General Settings",
	"generic.no-unit.help-message": "Enter text or numbers. Do not add the unit. Use {dot} for decimal numbers.",
	"german": "German",
	"go-to-box": "Go to the @.capitalize:client-name-box",
	"go-to-history": "History",
	"go-to-hub": "Go to the @.capitalize:client-name-hub",
	"go-to-properties-list": "Go to the properties configuration screen",
	"good": "Good",
	"graph-name": "Graph Name",
	"graph.chart-type": "Chart type",
	"graph.export.data": "Export data",
	"graph.export.graph-image": "Export image",
	"graph.export.selected-data": "Selected Data",
	"graphs.apply-to-properties": "Apply to properties",
	"graphs.axe-y": "Axe Y",
	"graphs.convert-to-virtual-property": "Convert to virtual property",
	"graphs.marker": "Marker",
	"graphs.remove-property": "Remove property",
	"graphs.select-interval": "Select interval",
	"graphs.turns-into-interval-consommation": "Turn into interval",
	"group": "Group",
	"group-address": "Group address",
	"group-already-exists": "Group already exists.",
	"group-data-by": "Generate a file by",
	"group-equipment": "Group equipments",
	"groups": "Groups",
	"hang-in-there-we-are-loading-properties-and-can-take-some-minutes": "Hang in there, please! We are loading all properties and this can take some minutes!",
	"hardware": "Hardware",
	"hardware-id": "Hardware ID",
	"heating-optimiser": "Heating Optimiser",
	"height-this-height-px": "height: {0}px;",
	"help-accordion.property-scaling-applied.body": "An \"ax + b\" type scaling (a={scalingA}; b={scalingB}) is applied in the property configuration.",
	"hide-side-panel": "Hide side panel",
	"higher-bound": "Higher bound",
	"history": "History",
	"hour": "Hour",
	"hour-plural": "Hour | Hours",
	"hourly": "Hourly",
	"hours": "Hours",
	"how-to-address-equipment": "How to address the equipment",
	"how-to-find-hardware-id": "How to find your hardware id?",
	"how-to-run-the-scan": "How to run the scan?",
	"hub": "@.clientname:_generic",
	"hub-configuration": "@.capitalize:hub configuration",
	"hub-doesnt-have-current-configuration": "@.capitalize:hub doesn't have a current configuration",
	"hub-offline": "@.capitalize:hub offline",
	"hub-online": "@.capitalize:hub online",
	"hub-status-checker": "@.capitalize:client-name-hub Status Checker",
	"hub-successfully-connected": "@.capitalize:client-name-hub successfully connected",
	"hubs": "@.clientname:_generic-plural",
	"id": "ID",
	"id-number": "ID number",
	"identification-number": "Identification number",
	"if": "If",
	"if-alert-notify-24-hours": "Even if the alarm triggers several times, space the notifications 24 hours apart",
	"if-alert-notify-X": "Even if the alarm triggers several times, space the notifications {X} apart",
	"if-alert-notify-once": "Only when the alarm is triggered for the first time",
	"if-alert-notify-weekly": "Even if the alarm triggers multiple times, receive one notification per week",
	"if-box-located-europe": "If @.lower:box is located in <strong>Europe</strong>",
	"if-box-located-north-america": "If @.lower:box is located in <strong>North America</strong>",
	"if-cant-find-equipment-request-it-click": "If you can't find the equipment, request it to us by clicking here!",
	"if-priotity-any-notify": "Whatever the severity",
	"if-priotity-critical-notify": "Critical only",
	"if-priotity-standard-notify": "Standard only",
	"if-there-are": "If there are any",
	"if-use-for-temporization": "Returns to normal inc.",
	"import": "Import",
	"import-again": "Please upload it again",
	"import-configuration": "Import configuration",
	"import-errors.properties": "Error when adding the properties. Download the source file with the error messages.",
	"import-load-success": "The file has been loaded",
	"import-properties": "Import selected properties",
	"import-success": "Your file has been successfully uploaded",
	"import.properties.title": "Import the properties to be selected",
	"import.title": "Import",
	"in": "in",
	"in-the-box": "Synchronized with the @.lower:box",
	"inactive": "Inactive",
	"inactive-hub": "Inactive @.lower:hub",
	"indicate-a-digit-between-0-9-or-F-for-any-digit": "Indicate a digit between 0 and 9 or 'F' for \"any digit\".",
	"indicate-period-in-days": "Indicate period in days",
	"indicator-name": "Label",
	"individual-address": "Individual address",
	"individual-address-knx-lte-tooltip": "Individual address of KNX device to read. It has the following format #x.#y.#z where #x, #y and #z are positive numbers.",
	"individual-address-should-be-xyz": "Individual Address has the following format #x.#y.#z where #x, #y and #z are positive numbers",
	"inform-valid-email": "Inform a valid e-mail address",
	"insert-property": "Insert property",
	"insert-valid-name": "Insert a valid name",
	"instance": "Instance",
	"inter-frame-delay": "Inter Frame Delay",
	"inter-frame-delay-tooltip": "The delay in microseconds to wait after a frame is sent",
	"interface": "Interface",
	"internal": "Internal",
	"internal-address": "Internal Address",
	"internal-error-request-new-scan": "Ops! Our servers returned an internal error! Maybe request a new scan!",
	"internal-recipient": "The recipient already has access to the console",
	"internal-to-siemens": "Internal to Siemens",
	"interval": "Interval",
	"interval-s": "Interval (s)",
	"interval-seconds": "Interval (seconds)",
	"interval-seconds-tooltip": "The number of seconds between two polls of data. This is used by the @.lower:box when reading data from the equipment.",
	"intervals-disabled-when-aggregation-enabled": "Please disable the aggregation to apply a delta",
	"invalid-ip-address": "Invalid IP Address",
	"invalid-phone-format": "Invalid phone number format",
	"invalid-value-type": "Invalid type of value",
	"iot": "IoT",
	"ip-address": "IP Address",
	"ip-address-of-gateway-non-mandatory": "The IP address of the gateway, non-mandatory",
	"ip-address-on-cird-notation": "The IP address on CIDR notation (XXX.XXX.XXX.XXX). The address given must be valid inside of your network. This field is required if the method is manual.",
	"ipv4-address": "IP Address",
	"ipv4-method": "IPv4 Method",
	"issued-on": "Issued on",
	"it should-be-one-of-those-options": "It should be one of those options: {options}",
	"it-is-not-possible-specify-first-character": "The first character cannot be changed.",
	"it-will-be-deleted-when-configuration-sent-to-box": "It will be deleted when configuration is sent to the @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-connector": "The connector will be deleted when configuration is sent to the @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-equipment": "The equipment will be deleted when configuration is sent to the @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-gateway": "The gateway will be deleted when configuration is sent to the @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-network": "The network will be deleted when configuration is sent to the @.lower:box",
	"it-will-be-deleted-when-configuration-sent-to-box-property": "The property will be deleted when configuration is sent to the @.lower:box",
	"keep-the-old-scan": "Keep the old scan",
	"key": "Key",
	"key-name": "Key name",
	"key-sent-with-data-check-integrity-message": "Key sent with the data to check the integrity of the message",
	"key-type": "Key type",
	"key-value": "Key value",
	"known": "Known",
	"knx-60001-mode-0": "LegioProtect",
	"knx-60001-mode-1": "Normal",
	"knx-60001-mode-2": "Reduced",
	"knx-60001-mode-3": "Off/FrostProtect",
	"knx-60002-mode-0": "Off",
	"knx-60002-mode-1": "On",
	"knx-default-mode": "Default",
	"knx-other-mode-0": "Comfort",
	"knx-other-mode-1": "Standby",
	"knx-other-mode-2": "Eco",
	"knx-other-mode-3": "Protection",
	"language": "Language",
	"language-english": "English",
	"language-french": "French",
	"language-german": "German",
	"last-7-days": "Last 7 days",
	"last-activation-event": "Last value received on",
	"last-alert-at": "Last alert at",
	"last-digits-after--": "Last digits after -",
	"last-edited-at": "Last edit: {date}",
	"last-read-value-data": "Last value read: {value} {unit}{asterisk}",
	"last-read-value-time": "Last value read {time}",
	"last-token": "Last token",
	"last-value": "Last value",
	"last-value-receive": "Last value received",
	"last-value-receive.at-date": "Last check {since} ago <span class=\"has-text-grey-400\">({date})</span>",
	"last-value.applied-scaling": "Scaling (ax+b): a={scalingA}; b={scalingB}",
	"last-values": "Last values",
	"last-written-value-data": "Last value written: {value} {unit}{asterisk}",
	"last-written-value.scaling-not-applied": "the scaling is not applied when writing a value",
	"latest-configuration-from-console-advice-download-and-upload-here": "We noticed that the last configuration stored in your device has been generated from the web console. Before making changes from this interface, we advise you to download the configuration from the web console and upload it",
	"latest-configuration-from-da-advice-download-and-upload-here": "We noticed that the last configuration stored in your device has been generated from the Desktop Application. Before making changes from this interface, we advise you to download the configuration from the Desktop Application and upload it. Activating the data reception won't work otherwise",
	"latest-scan-dates-from-timestamp": "The latest scan dates from {timestamp}.",
	"launch-the-scan": "Launch the scan",
	"learn-more": "Learn more",
	"leave": "Leave",
	"leave-page": "Leave page",
	"left": "Left",
	"left-ethernet-port": "Left Eth port",
	"license": "License",
	"license-sent-successfully": "License sent successfully",
	"license.expired": "Expired license",
	"license.expiring.soon": "Expiring license",
	"license.paired": "License paired",
	"license.suspended": "Suspended license",
	"license.unpair": "Unpair the license from this box",
	"license.unpair.modal-content": "This action unpairs license from box \"{device}\". The following changes will occur:",
	"license.unpair.modal-content.activate": "If the box is activated:",
	"license.unpair.modal-content.immediate": "Changes take effect immediately.",
	"license.unpair.modal-content.list.1": "The box and license become available for a new association.",
	"license.unpair.modal-content.list.2": "License start and end dates are deleted",
	"license.unpair.modal-content.list.3": "Device status changes to INACTIVE if currently activated",
	"license.unpair.modal-content.list.4": "Device configuration is preserved",
	"license.unpaired": "License and box unpaired",
	"licenses": "Licenses",
	"lift": "Lift",
	"line": "Straight lines",
	"line-type": "Line type",
	"linked-schedule": "Linked schedule",
	"list-boxes-in-scope-of-trigger": "List of the @.lower:boxes in the scope of the trigger",
	"list-of-addresses-1-to-255": "List of addresses (1 to 255)",
	"list-of-alarms": "List of alarms",
	"list-of-codes": "list of codes",
	"list-of-equipment": "List of equipment",
	"list-of-mask-addresses": "List of mask addresses",
	"list.devices": "list of devices",
	"live-data": "Live data",
	"live-data-open-chart": "Open graph with latest values",
	"loading": "Loading",
	"loading-logs": "Loading logs",
	"loading-scan": "Loading scan",
	"loading-scan-can-take-up-to-x-minutes": "Loading scan. This can take up to {minutes} minutes",
	"location": "Location",
	"logical-operator": "Logical operator",
	"login": "Login",
	"logout": "Logout",
	"logs": "Logs",
	"logs-events-msg": "Events are real time information sent by the device outside the sending of the property values. They can help you getting a closer eye if you notice something unexpected. <a href=\"/list-events-code\" target=\"_blank\">See the list of event codes and their meaning</a><br />Example of events:<br />- 4004: the property of the LoRaWAN equipment set to receive the downlink acknowledged its reception<br />- 5001: LoRaWAN payload decoding error<br />- 5004: LoRaWAN downlink request delivered<br />- 5005: LoRaWAN downlink request lost",
	"logs-section": {
		"campaign-progress-status": {
			"FAILED": "failed",
			"PROCESSING": "processing",
			"RECEIVED_BY_EQUIPMENT": "received",
			"UNKNOWN": "no response"
		},
		"campaign-progress-status-desc": {
			"FAILED": "{count} command failed | {count} commands failed",
			"PROCESSING": "{count} command processing | {count} commands processing",
			"RECEIVED_BY_EQUIPMENT": "{count} command received by equipment | {count} commands received by equipment",
			"UNKNOWN": "{count} command no response | {count} commands no response"
		},
		"campaign-status": {
			"COMPLETED": "Completed",
			"IN_PROGRESS": "In Progress"
		},
		"campaign-status-desc": {
			"COMPLETED": "Completed campaign",
			"IN_PROGRESS": "In progress campaign"
		},
		"campaigns": {
			"campaign-details": {
				"created-by": "Created by:",
				"description": "Description:",
				"model-name": "Reference:",
				"on-datetime": "on {datetime}",
				"title": "List of commands for {campaignName}"
			},
			"column-commands": "# commands",
			"column-progress": "Progress",
			"column-progress-tooltip": "Track the progress of your LoRaWAN command campaigns",
			"column-reference": "Reference",
			"commands": "Commands",
			"create": "Create campaign",
			"empty-state": {
				"description": "Launch a bulk LoRaWAN commands campaign to track progress here.",
				"title": "Track your LoRaWAN commands campaigns"
			}
		},
		"command-associated-description": "Associated description",
		"command-failed-reason": {
			"CORE_COMMAND_EXPIRED": "The command has expired: the equipment did not receive the command or the @.lower:box did not receive the response.",
			"CORE_QUEUE_OVERRUN": "The network is overloaded. Reduce the number of commands.",
			"INTERNAL_ERROR": "A technical error occurred. Please try again.",
			"INVALID_PAYLOAD": "The entered value is not valid.",
			"LORA_CODEC_ERROR": "The equipment is not technically supported or the entered value is not valid.",
			"LORA_QUEUE_FLUSHED": "The command was replaced by a new command before being sent.",
			"NETWORK_ERROR": "A network error occurred when sending the command.",
			"NETWORK_TIMED_OUT": "The equipment did not respond in time.",
			"SCALING_ERROR": "The entered value is not valid."
		},
		"command-history": "Command history",
		"command-status": {
			"DELIVERED": "Delivered",
			"ERROR_ALREADY_IN_PROGRESS": "Failed",
			"ERROR_NOT_RECEIVED": "Failed",
			"ERROR_NOT_SENT": "Failed",
			"ERROR_RATE_LIMIT": "Failed",
			"ERROR_TIMEOUT": "Failed",
			"FAILED": "Failed",
			"PROCESSING": "Processing",
			"RECEIVED": "Received by @.lower:box",
			"RECEIVED_SET_PROPERTY": "Received",
			"SENT": "Sent to @.lower:box",
			"SENT_TO_EQUIPMENT": "Sent",
			"UNKNOWN": "Unknown",
			"WAITING_FOR_HARDWARE_CONNECTION": "Pending"
		},
		"command-status-desc": {
			"DELIVERED": "Command received by equipment",
			"ERROR_ALREADY_IN_PROGRESS": "Identical command already in progress",
			"ERROR_NOT_RECEIVED": "Command not received by @.lower:box",
			"ERROR_NOT_SENT": "Command could not be sent to @.lower:box",
			"ERROR_RATE_LIMIT": "Maximum of 30 connection requests reached over 7 consecutive days",
			"ERROR_TIMEOUT": "@.capitalize:box did not respond within time limit",
			"FAILED": "Command not delivered to equipment",
			"PROCESSING": "Command processing on @.lower:box",
			"RECEIVED": "Command received by @.lower:box",
			"RECEIVED_SET_PROPERTY": "Command received by equipment",
			"SENT": "Command sent to @.lower:box",
			"SENT_TO_EQUIPMENT": "Command sent to equipment",
			"UNKNOWN": "@.capitalize:box restart or no response from equipment",
			"WAITING_FOR_HARDWARE_CONNECTION": "Waiting for @.lower:box connection"
		},
		"command-type": {
			"DATA_UPLINK_START": "Start communication",
			"DATA_UPLINK_START_NO_LIMIT": "Start unlimited communication",
			"DATA_UPLINK_STOP": "Stop communication",
			"DEBUG": "Debug",
			"DISCOVER": "Scan",
			"METRICS": "Metrics",
			"POLL_HAWKBIT": "Check for updates",
			"READ_REQUEST": "Read request",
			"REQUEST_CONFIG": "Configuration request",
			"RESTART": "Restart",
			"SEND_CONFIG": "Send configuration",
			"SET_PROPERTY": "Write request"
		},
		"command-type-desc": {
			"DATA_UPLINK_START": "Enabling data transmission from the @.lower:box to the console",
			"DATA_UPLINK_START_NO_LIMIT": "Enabling unrestricted data transmission from the @.lower:box to the console",
			"DATA_UPLINK_STOP": "Stopping data transmission from the @.lower:box to the console",
			"DEBUG": "Sending debug commands to the @.lower:box",
			"DISCOVER": "Network scan command",
			"METRICS": "Writing metrics",
			"POLL_HAWKBIT": "Checking for available updates (APPS/BSP)",
			"READ_REQUEST": "Reading equipment property",
			"REQUEST_CONFIG": "Requesting the @.lower:{'box'}'s current configuration",
			"RESTART": "Restarting the @.lower:box",
			"SEND_CONFIG": "Sending new configuration to the @.lower:box",
			"SET_PROPERTY": "Modifying equipment property (setpoint, mode, etc.)"
		},
		"commands-link-msg": "Read more",
		"commands-msg": "Check status of commands sent from console to your @.lower:{'box'}.{eventLink}",
		"event-details": {
			"4004": {
				"failure": "Command not received by equipment",
				"success": "Command received by equipment"
			},
			"601": {
				"RECEIVED": "Command received by @.lower:box",
				"SENT": "Command sent to @.lower:box"
			}
		},
		"event-origin-tooltip": "<b>Command ID</b>: commands from Console or API.<br /><b>Other</b>: external or local commands (BMS, schedules, automations, etc.).",
		"events-link-msg": "View the list of codes",
		"events-msg": "Events are information sent by the @.lower:box in real time. They help diagnose malfunctions.{eventLink}",
		"hub-msg": {
			"body": "Some events are not visible. Enable data reception using the button to the right of your @.capitalize:client-name-hub name. Events received during the next 60 minutes will be visible.",
			"title": "Enable event reception"
		},
		"refresh-tooltip": "Refresh list",
		"status": "Status"
	},
	"looks-dont-have-heating-optimiser-configured": "Looks like you don't have the Heating Optimiser configured.",
	"lorawan-easydownlink": "The 'Easy Downlink' property allows you to send a setpoint by entering its value directly. This is automatically converted to a downlink.",
	"lorawan-property.interval-seconds.help-msg": "For LoRaWAN properties, this value is only used to compute the total number of values received in an hour as part of your plan. Please fill the interval with the same transmission period as configured in your device",
	"lorawan-quality-good": "Good signal",
	"lorawan-quality-graph.example": "E.g.: If a sensor receives a signal with an RSSI of -117 dBm and an SNR of -2 dB, the signal quality will be considered poor in SF7. The sensor may switch to SF8 to improve the signal if it considers the communication to be poor.",
	"lorawan-quality-graph.intro": "{lorawan} signal quality is based on the RSSI, SF and SNR.",
	"lorawan-quality-graph.rssi": "{rssi} (Received Signal Strength Indicator)",
	"lorawan-quality-graph.rssi.detail": "Received signal strength. The higher the value, the stronger the signal.",
	"lorawan-quality-graph.sf": "{sf} (Spreading Factor)",
	"lorawan-quality-graph.sf.detail": "The higher the SF, the higher the device power consumption is when it communicates. The sensor automatically adjusts the SF according to RSSI and SNR to ensure optimum communication and battery life.",
	"lorawan-quality-graph.snr": "{snr} (Signal-to-Noise Ratio)",
	"lorawan-quality-graph.snr.detail": "Ratio between signal and noise. A high SNR means that the signal is clear and easy to distinguish from noise.",
	"lorawan-quality-helper": "Signal quality cannot be calculated because some of the required properties have not been added to the configuration: SNR, RSSI and SF properties are used to calculate the signal quality of your LoRaWAN equipment. They are not charged to your subscription.",
	"lorawan-quality-medium": "Medium signal",
	"lorawan-quality-poor": "Poor signal",
	"lorawan-use-same-keys-msg": "Use the same keys. It will imply transferring the equipment to the new device",
	"lorawan-version.help-msg": "LoRaWAN versions 1.0.0 to 1.0.3",
	"lower-bound": "Lower bound",
	"lpb-network-device-number-1-error": "Setting the device number to 1 means that the @.lower:box will be the device master on the segment which is not what the @.lower:box is intended for.",
	"lpb-subkey": "Subkey",
	"maintenance-1h-at-X": "A maintenance operation is planned on the console on {date} for 1h. The service may be interrupted during this period.",
	"maintenance-3h-at-X": "A maintenance operation is planned on the console on {date} for 3h. The service may be interrupted during this period.",
	"make-sure-usb-cable-is-connected": "Make sure the USB cable is connected",
	"managed-by": "Managed by",
	"manufacturer": "Manufacturer",
	"manufacturer-and-product-reference": "Manufacturer and product reference",
	"marker": "Marker",
	"marker-circle": "Circle",
	"marker-cross": "Cross",
	"marker-none": "None",
	"marker-square": "Square",
	"marker-triangle": "Triangle",
	"mask": "Mask",
	"mask-address": "Mask address",
	"max": "Max",
	"max-acceptable-value-is": "Max acceptable value is {value}",
	"max-cpu-usage": "Max CPU usage (%)",
	"max-data-points-reached": "Maximum number of data points reached",
	"max-data-points-reached-hourly-computation-msg": "We estimate that you will send {current} values in an hour whereas your current plan authorizes {max}. Before sending the configuration to your device, please change either the time interval of some data points, or either deactivate some data points. Also, feel free to contact your sales representative to increase your total number of data points.",
	"max-data-points-reached-msg": "In relation to your current rate plan, you are using {current} out of {max} data points. Before sending the configuration to your device, please deactivate some data points or ask your sales representative to increase your total number of data points.",
	"max-ram-usage": "Max RAM usage (MB)",
	"max-ram-usage-megabytes": "The max RAM usage in MegaBytes",
	"maximum": "Maximum",
	"maximum-timer-redirect-to-mqtt-property-is-600-seconds": "The minimum interval for a property that is redirected to a MQTT gateway is 600 seconds",
	"maximum-value": "Maximum value",
	"mbus-scan": "M-Bus Scan",
	"measured-value": "Measured value",
	"medium": "Medium",
	"message": "Message",
	"method": "Method",
	"metric": "Metric",
	"min": "Min",
	"minimum": "Minimum",
	"minimum-acceptable-value-is": "Minimum acceptable value is {value}",
	"minimum-value": "Minimum value",
	"minute": "Minute",
	"minute-plural": "Minute | Minutes",
	"minutes": "Minutes",
	"missing": "WARNING",
	"missing-column-in-file": "Missing column(s) in the file: {column}",
	"missing-data-lorawan-txt": "Less data received than expected in the last 24 hours",
	"missing-sheet-in-file": "No sheet matching the selected content type was found.",
	"missing-values": "Missings values in columns: {values}",
	"modal-activate.banner.1": "Enter the information below to activate the box.",
	"modal-activate.banner.2": "Find out more by consulting {link}",
	"modal-activate.banner.guide": "the installation guide.",
	"modal-command-details": {
		"revision-id": "Revision ID",
		"title": "Command details"
	},
	"modal.add-graph.title": "New or existing graph",
	"modal.schedules.edit-period.title": "Edit the application period",
	"modal.schedules.edit-setpoints-values.help-text": "Enter a value for each slot. Do not add the unit and use {dot} for decimal numbers.",
	"modal.schedules.edit-setpoints-values.title": "Edit setpoint values",
	"modal.schedules.manage-slot-types.msg": "During the “Properties & setpoints” step, you will associate a setpoint with each type of slot.",
	"modal.schedules.manage-slot-types.title": "Edit the types of slots",
	"modal.schedules.manage-states.unique-colors-error-msg": "At least one color is shared across multiple slot types. Please assign a different color to each slot type.",
	"modal.schedules.select-properties.title": "Select the properties",
	"modal.schedules.shared-slot-types.msg": "The list of slots is the same for all the schedules in your box.",
	"modbus-data-format-tooltip-explanation-endianness": "Floats and long integers do not fit in a single 16-bit register so consecutive registers are then used.<br/><br/>Because different manufacturers handle the endianness (order of the bytes) differently, you need to specify the byte order matching your ModBus equipment.",
	"modbus-ip-gateway-property": "Modbus TCP/IP Gateway property",
	"modbus-register-address-must-be-unique-msg": "The property {propertyName} can't use the address {address} and the function {functionName} as they are used by another property",
	"mode": "Mode",
	"model": "Model",
	"modify-schedule": "Modify schedule",
	"monday": "Monday",
	"month": "Month",
	"monthly": "Monthly",
	"months": "Months",
	"more-infos": "More info",
	"more-options": "More options",
	"mqtt-client-id-tooltip": "The clientId used to connect to MQTT",
	"mqtt-gateway-property": "MQTT Gateway Property",
	"mqtt-gateway.add-block.tooltip": "Add field",
	"mqtt-gateway.add-string-block": "Add string",
	"mqtt-gateway.add-variables-block": "Add variable",
	"mqtt-gateway.downlink-topic.hashtag-error": "The multi-level wildcard must be placed as the last character in the topic, preceded by a forward slash.",
	"mqtt-gateway.downlink-topic.help-msg": "Multi-level wildcard '#' is supported. Subscribing with a multi-level wildcard alone is not authorized",
	"mqtt-gateway.downlink-topic.same-uplink-downlink-error-msg": "Please set different topics for uplink and downlink.",
	"mqtt-gateway.downlink-topic.special-characters-error": "'+' and '$' wildcards are not supported",
	"mqtt-gateway.downlink-topic.wildcard-error-msg": "Subscribing with a multi-level wildcard alone is not authorized. Please edit the downlink topic.",
	"mqtt-gateway.empty-template.help-msg": "Start to write to see an example of property topic",
	"mqtt-gateway.empty-template.space": "Spaces in variable names will be replaced by '-'.",
	"mqtt-gateway.string-placeholder": "Add string",
	"mqtt-gateway.uplink-topic-structure": "Uplink topic format",
	"mqtt-gateway.uplink-topic-structure.tooltip": "Default format used for the MQTT uplink topics. Values will be generated based on the defined format.",
	"mqtt-gateway.uplink-topic.special-characters-error": "'#', '+' and '$' wildcards are not supported",
	"mqtt-gateway.variable-placeholder": "Add variable (optional)",
	"mqtt-property.uplink-topic": "MQTT uplink topic",
	"mqtt-property.uplink-topic.tooltip": "This uplink topic will be used to access the property value on MQTT. It is based on the format  defined in the gateway settings.",
	"mqtt-qos": "Quality of Service (QoS)",
	"mqtt-qos-0": "0 - At most once delivery",
	"mqtt-qos-1": "1 - At least once delivery",
	"mqtt-qos-2": "2 - Exactly once delivery",
	"mqtt-server-host-placeholder": "MQTT server address",
	"mqtt-server-host-tooltip": "Remote MQTT Server address. A fully qualified domain name (FQDN) or an IP address. Max length is 253.",
	"mqtt-server-port-tooltip": "The remote MQTT server port",
	"mqtt-slug-fields-must-be-unique": "Slug names must be unique for every property, please include a unique field like Property ID or Unique ID",
	"mqtt-slug-tooltip": "A slug that will be used as identifier of the property value on MQTT. If not set, the propertyId (that's automatically generated) will be used instead.",
	"mqtt-slug.property-description": "Property description (first 50 characters)",
	"mqtt-version": "MQTT version",
	"mqtt-version-tooltip": "The MQTT version to use",
	"my-profile": "My profile",
	"n-days": "{n} day | {n} days",
	"n-days-after": "{days} days after",
	"n-organization": "0 organization | {n} organization | {n} organizations",
	"n-property-saved": "{n} property saved | {n} properties saved",
	"name": "Name",
	"name-box-gateway-seen-in-bacnet-network": "Name of the @.lower:box or the gateway as it will be seen in the BACnet network. If empty the value of the \"Name\" field will be used.",
	"name-of-person": "Name of the person",
	"name-of-the-file": "Name of the file",
	"netmask": "Netmask",
	"network": "Network",
	"network-address": "Network address",
	"network-and-connector": "Network and Connector",
	"network-name": "Network's name",
	"network-number": "Network number",
	"network-protocol-modbusip-help-msg": "The physical connector will be automatically assigned when the configuration is sent to the device and when the Modbus TCP/IP network cable is plugged in.",
	"networks": "Networks",
	"neuron-id": "Neuron Id",
	"neuron-id-tooltip": "Example of a Neuron ID: 07:02:73:DA:FC:00",
	"never-connected": "Never connected",
	"new": "New",
	"new-alarm": "New alarm",
	"new-configuration": "New configuration",
	"new-configuration-not-applied-yet-to-box": "The new configuration was not applied yet to the @.lower:box",
	"new-configuration-will-overwrite-current-configuration-and-changes-wont-reflect-console": "The new configuration will overwrite the current configuration and the changes won't be reflected in the console",
	"new-dashboard": "New Dashboard",
	"new-equipment-added-to-network": "New equipment added to network",
	"new-gateway": "New gateway",
	"new-graph": "New graph",
	"new-group-name": "Name of new group",
	"new-password": "New password",
	"new-recipient": "New Recipient",
	"new-value-not-set": "New value didn't set",
	"new-value-not-set-yet": "New value didn't set yet",
	"new-value-set-to-property": "New value written to property {property}",
	"next": "Next",
	"next-day": "Next day",
	"next-period": "Next period",
	"no": "No",
	"no-aggregation": "Raw data",
	"no-alert": "No Alert",
	"no-authentication": "No authentication",
	"no-codec": "No codec",
	"no-data-for-specific-dates": "No data available in this date range",
	"no-data-received": "No data received",
	"no-data-to-show": "No data to show",
	"no-devices-found-on-network-check-configuration": "No devices were found on the network. Please check your configuration and request a new scan",
	"no-line": "No line",
	"no-perm-dashboard-tooltip": "You do not have permissions to add a Dashboard",
	"no-product-reference": "None",
	"no-properties": "No properties to display",
	"no-properties-click-to-add": "You don't have any properties yet. Click here to add it.",
	"no-properties-click-to-add-short": "You don't have any properties yet:",
	"no-redirections-message": "This properties isn't redirecting its values",
	"no-results": "No results",
	"no-selected-connector": "Connector not selected",
	"no-static-ip-set-to-usb-network": "There is not static IP set for the USB network adapter",
	"non-added": "non-added",
	"non-grouped": "Non grouped",
	"non-supported-object-type-and-instance": "Non-supported object type: {objectType}. <br />Instance: {objectInstance}",
	"none": "None",
	"not-allowed-column-in-file": "Column(s) not allowed: {column}",
	"not-available": "Not available",
	"not-configured": "not configured",
	"not-connected-box": "@.capitalize:box not connected to console",
	"not-defined": "Not defined",
	"not-in-box-send-configuration-to-save": "Not in the @.lower:box yet. Send the configuration to add it.",
	"not-in-box-send-configuration-to-save-connector": "This connector is not in the @.lower:box . Send the configuration to the @.lower:box to add it.",
	"not-in-box-send-configuration-to-save-equipment": "The equipment is not in the @.lower:box . Send the configuration to the @.lower:box to add it.",
	"not-in-box-send-configuration-to-save-gateway": "This gateway is not in the @.lower:box . Send the configuration to the @.lower:box to add it.",
	"not-in-box-send-configuration-to-save-network": "This network is not in the @.lower:box . Send the configuration to the @.lower:box to add it.",
	"not-in-box-send-configuration-to-save-property": "The property is not in the @.lower:box . Send the configuration to the @.lower:box to add it.",
	"not-in-box-send-configuration-to-save-schedule": "This schedule has not been loaded to the @.lower:{'box'}.",
	"not-specified": "Not specified",
	"notification": "Notification",
	"notification-enable-temporization": "Receive a notification when the alarm returns to normal",
	"notification-type": "Notification Type",
	"notifications": "Notifications",
	"notify-by": "Notify by",
	"number-of-items-to-read-in-array": "The number of items to read in an array",
	"nv-index": "NV Index",
	"object-index": "Object Index",
	"object-instance": "Object instance",
	"object-type": "Object type",
	"object-type-not-supported": "Object type not supported",
	"objects": "objects",
	"odd-months": "Odd Months",
	"offline": "Offline",
	"offline-box": "@.capitalize:box disconnected from console",
	"offline-connected-once": "Offline (connected at least once)",
	"offline-hub": "@.clientname:_hub disconnected from console",
	"offline-hub.modal.1": "Activate communication via the SIM card to connect the box to the console and send a new configuration.",
	"offline-hub.modal.2": "Without a connection, you can modify the configuration of the box in the console but not send it. The property values are not received either.",
	"ok": "OK",
	"on-hold": "On hold",
	"online": "Online",
	"only-present-value-displayed-click-to-see-all-properties": "By default, only the \"Average Value\", \"Present Value\", \"Priority For Writing\" and \"Program State\" properties are listed below.",
	"open": "Open",
	"open-alert": "Open",
	"optimiser": "Optimiser",
	"optional": "optional",
	"options": "Options",
	"options-for-endiannese-are": "Options for endianness are",
	"or": "OR",
	"organization": "Organization",
	"organization-prevent-rights-propagation": "Authorize admins of the parent organization to have access to this organization",
	"organization-prevent-rights-propagation-help": "For the permissions of a user to extend from {parentName} to this (child) organization this setting has to be activated AND the user has to have the admin permission on {parentName}",
	"organization-saved": "Organization saved",
	"organizations": "Organizations",
	"organizations-managed-by": "Organizations managed by {name}",
	"origin": "Origin",
	"other": "Other",
	"other-actions": "Other actions",
	"other-info": "Other Info",
	"other-organization": "other organization | other organizations",
	"other-organizations": "Add organizations",
	"other-properties": "other property | other properties",
	"other-value": "Other value",
	"owner-organization": "Owner organization",
	"pair": "Pair",
	"pair-a-physical-device": "Pair the license with a device",
	"pair-renewal-help-messages": {
		"first": "To renew, go directly to the device that is about to expire.",
		"second": "You can then associate the new license without having to enter the hardware ID and verification code."
	},
	"pair-the-device": "Pair the device",
	"pair-with-physical-device": "Pair with device",
	"pair-with-physical-device.tooltip": "Pair the license with a device",
	"paired": "Paired",
	"paired-at": "Paired at {date}",
	"panel-network.configure-network": "Configure network",
	"panel-network.error-lon-ip-same-port": "Another LON IP network is already using the port {port}",
	"panel-network.placeholder-protocol": "Select a protocol",
	"panel-property.property-id": "Property ID",
	"panel-property.property-id.tooltip": "Non editable, property unique system identifier",
	"panel-property.warning.changes-in-draft": "The configuration shown below is the one present in the box.",
	"panel-property.warning.changes-in-draft.send": "It is has been edited, the changes are visible in '{startLink}Configuration{endLink}' . To apply the changes and view them on this screen, please send them to the box.",
	"panel-property.warning.changes-in-draft.title": "Changes in progress not synchronised with the box",
	"parent-box": "Parent @.capitalize:{'box'}",
	"parent-box-label": "Parent @.capitalize:{'box'}:",
	"parent-organization": "Parent organization",
	"parity": "Parity",
	"password": "Password",
	"password-field.chars": "{chars} characters",
	"password-field.one-lowercase": "One lowercase",
	"password-field.one-specialchar": "One special character",
	"password-field.one-uppercase": "One uppercase",
	"password-field.password-generic-error": "The chosen password is in a list of generic passwords used in cyber attacks. Please choose a more specific password.",
	"password-field.password-must-contain-at-least": "Your password must contain at least:",
	"passwords-do-not-match": "Passwords do not match",
	"payload": "Payload",
	"payload-prefix": "Payload prefix",
	"payload-prefix-when-writing-to-property-mandatory-when-access-write": "The payload prefix when writing to this property. Mandatory when the access is in write.",
	"payment": "Payment",
	"period": "Period",
	"period-after-incident-seconds": "Period after the incident in seconds",
	"period-in-days": "Period in days",
	"period-in-minutes": "Period in minutes",
	"period-in-seconds": "Period in seconds",
	"permissions": "Access",
	"phone-number": "Phone number",
	"physical-connector": "Physical Connector",
	"physical-location-of-box": "The physical location of the @.lower:box",
	"please-wait-while-applying-configuration-hub": "Please wait while we are applying the configuration to your @.lower:hub",
	"plugin": "Plugin",
	"plugin-file": "Plugin file",
	"plugin-properties": "Plugin properties",
	"plugin.grant-access": "Grant access type",
	"plugin.grant-access-tooltip": "Indicate if the plugin has access to this property as an input (data will flow into the plugin) or as an output (data will flow out of the plugin)",
	"plugin.local-name": "Local name",
	"plugin.local-name-tooltip": "The name that the plugin will use as property identifier for this property.",
	"poor": "Poor",
	"port": "Port",
	"port-to-expose-server-unique-per-physical-connector": "The port to expose the server on. This is unique per physical connector",
	"position-of-bit": "Position of the bit",
	"position-of-properties": "Select where to display the properties",
	"predicted-time": "Predicted time",
	"press-enter-to-deselect": "Press enter to remove",
	"press-enter-to-select": "Press enter to select",
	"preview-example": "Preview example:",
	"previous": "Previous",
	"previous-period": "Previous period",
	"primary-address": "Primary address",
	"priority": "Priority",
	"priority-for-writing": "Priority for Writing",
	"private-key": "Private Key",
	"program": "Program",
	"program-id": "Program Id",
	"program-id-tooltip": "The id of the program",
	"properties": "Properties",
	"properties-added": "Properties added",
	"properties-duplicated-successfully": "Properties duplicated successfully",
	"properties-included": "Number of properties max",
	"properties-references": "Properties References",
	"properties-saved": "Properties saved",
	"properties-settings": "Properties Settings",
	"properties-targeted-by-the-schedule": "Properties targeted by the schedule",
	"properties-updated": "Properties updated",
	"properties-values": "Property values",
	"properties-values-in-an-hour": "Properties values in an hour",
	"properties-x-deleted": "{n} property deleted | {n} properties deleted",
	"properties-x-disabled": "{n} property disabled | {n} properties disabled",
	"properties-x-enabled": "{n} property enabled | {n} properties enabled",
	"properties-x-saved": "{n} saved property | {n} saved properties",
	"property": "Property",
	"property-already-saved": "Property already saved",
	"property-bacnet": "Property BACnet",
	"property-didnt-receive-any-value": "This property did not receive any value yet",
	"property-duplicated": "Property duplicated",
	"property-id": "Property ID",
	"property-index": "Property Index",
	"property-is-redirected-confirm-rename": "This property is redirected to a BACnet IP or MQTT gateway. These gateways may need to be updated to reflect your changes. Would you like to apply the changes to the gateways?",
	"property-kind": "Property kind",
	"property-must-be-configured": "Property {property} must be configured",
	"property-name": "Property Name",
	"property-name-by-default": "Property name by default",
	"property-not-available-for-scaling": "Property not available to be scaled",
	"property-not-saved-cant-be-empty": "{property} not saved: It can't be empty.",
	"property-plural": "Property | Properties",
	"property-redirecting-from": "This property receives values form the properties listed below",
	"property-saved": "Property saved | Properties saved",
	"property-scaling-applied.input-help-msg": "An \"ax + b\" type scaling (a={a};b={b}) is applied, this point raw value is {value}",
	"property-slug": "Property Slug",
	"property-slug-description": "Original equipment property slug",
	"property-value": "Value of a property",
	"protocol": "Protocol",
	"provide-description-to-easily-identify-new-licence": "Provide a description to quickly identify the new license",
	"qtt-equipments-were-created": "{qtt} equipment were created",
	"qtt-years": "1 year | {years} years",
	"qtt1-equipment-was-created": "1 equipment was created",
	"quality": "Quality",
	"quantity": "Quantity",
	"quit-without-saving": "Quit without saving",
	"rate-plan": "License",
	"rate-plan-deleted": "License deleted",
	"rate-plan-type": "License type",
	"rate-plan.delete": "Delete License",
	"rate-plan.delete.confirmation": "License \"{id}\" will be deleted.",
	"rate-plan.pairing.error.22": "A license is already associated with the device indicated. Check the hardware ID entered.",
	"rate-plan.pairing.error.23": "This device already has a license associated with it. If you wish to renew it, please go directly to the device that is about to expire.",
	"rate-plans": "Licenses",
	"raw-registers": "Raw registers",
	"reached-comfort-in": "Reached comfort in",
	"read": "Read",
	"read-and-write": "Read & Write",
	"read-and-write-desc": "Allow the values to be read & writen from the cloud (read & write)",
	"read-function": "Read function",
	"read-more": "Read more",
	"read-only": "Read Only",
	"read-only-desc": "Only allow the values to be read from the cloud (read only)",
	"read-write": "Read/Write",
	"reason": "Reason",
	"reasons": "Reasons",
	"received-at": "Received at",
	"received-at-time": "Received at",
	"received-value-on-date": "Receveid value on {date}",
	"received-value-x-minutes-ago": "Received value {when}",
	"recipient": "Recipient",
	"recipient-without-access": "Recipient without access to the console",
	"recipient.confirm": "Please confirm the recipient",
	"recipients": "Recipients",
	"reconfigure-connector": "Reconfigure connector",
	"recurrence": "Recurrence",
	"recurrence.none": "None",
	"recurrence.yearly": "Yearly",
	"redirect-to-property": "Redirect to property",
	"redirect-value-to": "Redirect value to: {to}",
	"redirected-properties": "Redirected properties",
	"redirected-properties.gateways": "Redirected properties (gateway)",
	"redirecting-from": "Redirecting from",
	"redirecting-to": "Redirecting to",
	"redirections": "Redirections",
	"reference": "Reference",
	"reference-plural": "Reference | References",
	"references": "References",
	"refresh": "Refresh",
	"refresh-scan": "Refresh scan",
	"refresh-value": "Refresh value",
	"region": "Region",
	"register-address": "Register address",
	"register-address-already-in-use": "Register Address already in use in this register type",
	"register-type": "Register type",
	"relation-between-physical-logical-state-with-image": "<div class='bacnet-polarity-tooltip-txt'>Relation between physical and logical state of the value. <br /> <img src='{imgsrc}' /></div>",
	"release-version": "Release {version}",
	"remaining-properties": "Remaining Properties",
	"remove-all-slots": "Delete all slots",
	"remove-custom-permissions": "Remove access",
	"renew": "Renew",
	"renew-rate-plan": "Renew license",
	"renew-rate-plan-pairing": "Renew the license by pairing a license already available",
	"renew.device.notification.content.1.expired": "Sort by end date the table below to identify expired subscriptions.",
	"renew.device.notification.content.1.expired.siemens": "Sort by end date the table below to identify expired licenses.",
	"renew.device.notification.content.1.expiring": "Sort by end date the table below to identify expiring subscriptions.",
	"renew.device.notification.content.1.expiring.siemens": "Sort by end date the table below to identify expiring licenses.",
	"renew.device.notification.content.2": "To know more about renewal, click on the “Renew” button, on the subscription row.",
	"renew.device.notification.content.2.siemens": "To know more about renewal, click on the “Renew” button, on the license row.",
	"renew.device.notification.title.expired": "One or several subscriptions have expired",
	"renew.device.notification.title.expired.siemens": "One or several licenses have expired",
	"renew.device.notification.title.expiring": "One or several subscriptions are expiring within {days}",
	"renew.device.notification.title.expiring.siemens": "One or several licenses are expiring within {days}",
	"renew.dialog.alert": "The admin(s) of the organization of your device were notified by email.",
	"renew.dialog.answer.1": "Interruption of cellular connection between your box and our servers ",
	"renew.dialog.answer.2.bridge": "Remote configuration of the box: possible if the box is connected to an open Ethernet/IP network",
	"renew.dialog.answer.2.tower": "Stop remote box configuration",
	"renew.dialog.answer.3.bridge": "Sending data from the box to our servers: possible on a one-hour slot if the box is connected to an open Ethernet/IP network",
	"renew.dialog.answer.3.tower": "Stop sending data from the box to our servers",
	"renew.dialog.answer.4": "Automatic updates of the box firmware: possible if the box is connected to an open Ethernet/IP network",
	"renew.dialog.answer.5": "No impact on redirects and other local operations",
	"renew.dialog.ask": "What happens if the subscription is not renewed?",
	"renew.dialog.ask.bridge": "What happens if the SIM card is not renewed?",
	"renew.dialog.ask.siemens": "What happens if the license is not renewed?",
	"renew.dialog.license": "License renewal",
	"renew.dialog.main-text.end": "If you do not renew your subscription before {endDate}, your {type} features will be restricted.",
	"renew.dialog.main-text.end.bridge": "If you do not renew your SIM card before {endDate}, your {type} features will be restricted.",
	"renew.dialog.main-text.end.expired": "There is currently no ongoing subscription, so the features of your {type} are restricted.",
	"renew.dialog.main-text.end.expired.bridge": "If your SIM card expires, the features of your {type} will be restricted.",
	"renew.dialog.main-text.end.expired.siemens": "There is currently no ongoing license, so the features of your {type} are restricted.",
	"renew.dialog.main-text.end.siemens": "If you do not renew your license before {endDate}, your {type} features will be restricted.",
	"renew.dialog.main-text.start": "To renew the subscription attached to the @.lower:box “{boxName}”, please contact your reseller.",
	"renew.dialog.main-text.start.bridge": "Your {type} “{boxName}” is equiped with a SIM card with data valid by default for {duration}. It enables a cellular connection to our servers. To renew your SIM card, please contact your reseller.",
	"renew.dialog.main-text.start.siemens": "To renew the license attached to the @.lower:box “{boxName}”, please contact your reseller.",
	"renew.dialog.note": "Note: if you have already renewed, this message will disappear on the start date of the new subscription.",
	"renew.dialog.note.siemens": "Note: if you have already renewed, this message will disappear on the start date of the new license.",
	"renew.dialog.renewal.siemens": "Once you have ordered the new licence, you will be able to select it to activate the renewal. If not, contact your reseller.",
	"renew.dialog.retrieve.admin": "The admin(s) of the organization of your device were notified by email.",
	"renew.dialog.retrieve.data": "How to retrieve your data?",
	"renew.dialog.retrieve.data.text": "Use the Archive feature or the API. Your data will be deleted for good on {date}.",
	"renew.dialog.sim": "SIM card renewal",
	"renew.dialog.subscription": "Subscription renewal",
	"renew.license": "Renew license",
	"renew.main.notification.expired": "One or several subscriptions have expired. Identify them on the {organization} organization {linkBoxes}{others}.",
	"renew.main.notification.expired.siemens": "One or several licenses have expired. Identify them on the {organization} organization {linkBoxes}{others}.",
	"renew.main.notification.expiring": "One or several subscriptions are expiring within {days}. Identify them on the {organization} organization {linkBoxes}{others}.",
	"renew.main.notification.expiring.siemens": "One or several licenses are expiring within {days}. Identify them on the {organization} organization {linkBoxes}{others}.",
	"renew.notification.content.1": "Sort by end date the table below to identify expiring licenses.",
	"renew.notification.content.2": "To know more about renewal, click on the “Renew” button, on the license row.",
	"renew.subscription": "Renew subscription",
	"renew.success": "Renewal successfully completed. Start and end dates will be updated on the 1st day of renewal.",
	"renew.success.description": "License details",
	"reopen-alert": "Reopen the alert",
	"repeat-every": "Repeat every",
	"repeat-new-password": "Repeat your new password",
	"request-autodiscovery-box": "Requesting scan to the @.lower:box",
	"request-download": "Request Download",
	"request-new-scan": "Request new scan",
	"requested-by": "Requested by",
	"requesting-scan": "Requesting Scan",
	"required": "Required",
	"required-when-communicating-lte-mode-if-device-supports-s-and-lte-modes-has-to-set": "Required only when communicating in LTE mode. If a device supports both S and LTE modes, this has to be set.",
	"reset-time": "Reset time",
	"resource-uri": "Resource URI",
	"resources": "Resources",
	"response-timeout": "Response timeout",
	"response-timeout-tooltip": "Request response timeout in microseconds",
	"restart": "Restart",
	"restart-app-error": "Please, restart the application. Something went wrong, sorry.",
	"restart-app-msg": "Hold on, please. We're trying to reconnect to Back-end service.",
	"restarting-server-failure-msg": "Please, close and open again the application",
	"restarting-server-please-wait": "Please wait... this can take some minutes.",
	"restarting-server-title": "We are applying your license and setting up the app.",
	"result": "Result",
	"results": "Results",
	"retry-number": "Retry number",
	"retry-number-tooltip": "The number of retries if the request was lost",
	"return-to-normal": "Return to normal",
	"right": "Right",
	"right-ethernet-port": "Right Eth port",
	"role": "Role",
	"roles.box-permissions": "@.capitalize:box permissions",
	"roles.custom-rights": "Custom rights",
	"roles.integrator": "Integrator",
	"roles.maintenance-technician": "Maintenance Technician",
	"roles.no-access": "No access",
	"roles.organization-admin": "Organization Admin",
	"roles.read-only-user": "Read only user",
	"roles.site-manager": "Site Manager",
	"roles.software-integrator": "Software Integrator",
	"route-deleted": "Route deleted",
	"route-saved": "Route saved",
	"route-valid-success-msg": "The new route is valid",
	"router.404.description": "Sorry, the page you are looking for does not exist.",
	"router.404.header": "404, Page not found",
	"routing": "Routing",
	"routing-metric-help": "Priority of the route in case of conflicts. The lower the value, the higher the priority",
	"routing-table-msg": "Your gateway contains a routing table with default routes to communicate with the console. If your network configuration requires specific routes to be defined, or if it requires routes to be diverted from their default routing, then you can add new routes. These will not affect the default table.",
	"routing-table-success-msg": "The routing table is valid",
	"run-mbus-scan": "Run M-Bus Scan",
	"run-optimiser-wizard": "Run Optimiser wizard",
	"rvl-OFF-mode": "REDUCED",
	"rvl-ON-mode": "NORMAL",
	"rvl-migration-click-to-update": "Click here to trigger the update process",
	"rvl-migration-needed-msg": "At least one equipment of type RVL is connected to your devices. A new feature has been released to make it easier to read and write schedules on such equipment. We can update your configuration on your behalf for you to benefit from it. When the update is done, you will no longer see this message.",
	"rvl-migration-success": "Your device has entered the update queue",
	"same-day": "Same day",
	"saturday": "Saturday",
	"save": "Save",
	"save-all-properties-qtt": "Save all properties | Save all {qtt} properties",
	"save-all-selected-properties": "Would you like to save all selected properties?",
	"save-all-selected-properties-or-selected-properties-from-current-equipment": "Would you like to save all selected properties or only the selected properties from {equipment}?",
	"save-and-close": "Save and close",
	"save-changes": "Save changes",
	"save-properties": "Save properties",
	"save-qtt-properties-from-equipment": "Save {qtt} properties from {equipment}",
	"save-selected-boxes": "Save selected @.lower:boxes",
	"save-selected-properties": "Save properties | Save {n} property | Save {n} properties",
	"saved": "saved",
	"saving": "Saving",
	"saving-status.failed.msg": "Changes are not saved",
	"saving-status.saved.msg": "All changes saved",
	"scaled-value": "Scaled value",
	"scaling": "Scaling",
	"scaling-explanation": "Apply scaling to transform the property value by multiplying it by a factor, a (example: 1, 10, 0.1) and/or adding a value, b (example: 1000, -50).",
	"scaling-explanation-gateway": "A scaling is applied on the equipment property. It is also applied on the redirected property. You can change the scaling formula in the equipement property configuration.",
	"scan": "Scan",
	"scan-bacnet-network": "Scan BACnet network",
	"scan-date": "Scan date: {date}",
	"scan-discovery": "Scan BACnet",
	"scan-mbus-network": "Scan M-Bus network",
	"scan-no-results-msg": "The Scan didn't get any results.",
	"scan-not-found": "Scan not found",
	"scan-not-found-please-request-one": "Scan not found. Please, request one.",
	"scan-options": "Scan options",
	"scan-progress": "Scan progress",
	"scan-progress-yet": "Scan still in progress",
	"scan-requested-on-timestamp-want-to-use": "You have a scan that was requested on {timestamp}. Do you want to use it?",
	"scan-still-in-progress-longer-than-x-minutes-stop-and-request-new-one": "The scan is in progress, but no updates have been detected in the past {minutes} minutes.",
	"scan-stop-or-restart": "Would you like to stop it and start a new scan?",
	"scan.detected": "Scan detected",
	"scanning-hub-please-wait": "Scanning @.lower:{'hub'}. Please wait...",
	"scatter-plot": "Scatter plot",
	"scenario": "Scenario",
	"scenario-name": "Scenario name",
	"schedule": "Schedule",
	"schedule-last-value-tooltip": "Expected value based on the schedule configuration",
	"schedule-management-encoder": "Schedule manager encoder",
	"schedule-name-by-default": "Schedule name by default",
	"schedule-occurrence-time-interval-tooltip": "The condition must repeat as many times as desired on the left during this period.<br />Remember that the interval between receiving two successive values ​​for the same property depends on the nature of the equipment. Check the “Live Data” screen if you have any doubts.<br />The counter is reset to zero if the conditions have been met during the period.<br />To be triggered again, the conditions must occur during a new period.",
	"schedules": "Schedules",
	"schedules.add-exception": "Add an exception",
	"schedules.add-schedule": "Add schedule",
	"schedules.application-period-saved-successfully": "Application period modified successfully",
	"schedules.calendar-view": "Calendar view",
	"schedules.create-first-schedule": "Create your first schedule",
	"schedules.create-schedule-step1.form-title-edit": "Define the weekly schedule",
	"schedules.create-schedule-step1.form-title-new": "New weekly schedule",
	"schedules.create-schedule-step1.title": "Weekly schedule",
	"schedules.create-schedule-step2.form-title": "Exceptions",
	"schedules.create-schedule-step2.title": "Exceptions",
	"schedules.create-schedule-step3.form-title": "Properties & setpoints",
	"schedules.create-schedule-step3.title": "Properties & setpoints",
	"schedules.daily-schedule-invalid-consecutive-time.error-msg": "Start times & end times are not coherent",
	"schedules.daily-schedule-invalid-overlap-time.error-msg": "The slots should not overlap",
	"schedules.default-schedule-state-label": "Time slot type in use the rest of the time:",
	"schedules.default-schedule-state.field-required": "Please select the time slot type in use the rest of the time.",
	"schedules.edit-exceptions": "Edit exceptions",
	"schedules.edit-period.label": "Application period",
	"schedules.edit-planning": "Edit planning",
	"schedules.edit-schedule": "Edit schedule",
	"schedules.edit-the-application-periods": "Edit the application periods",
	"schedules.edit-the-application-periods.tooltip-x-properties": "Edit the application period of the property | Edit the application period of the {x} properties",
	"schedules.edit-the-schedule": "Edit the schedule",
	"schedules.edit-the-setpoints-values": "Edit the setpoints values",
	"schedules.edit-the-setpoints-values.tooltip-x-properties": "Edit the setpoints values of the property | Edit the setpoints values of the {x} properties",
	"schedules.empty-state.control.title": "Write setpoints based on schedules",
	"schedules.empty-state.no-control.msg": "Fine-tune the triggering of your alarms using schedules",
	"schedules.empty-state.no-control.title": "Describe the use of your building with a schedule",
	"schedules.eod-label": "midnight",
	"schedules.exception-used-tooltip": "This schedule or another uses this exception, it can't be deleted. Please edit the schedule to stop using this exception before deleting it.",
	"schedules.exception.all-day-schedule-state.field-required": "Please select the time slot type that will apply during the exception.",
	"schedules.exception.condition-is-met-if-type-slot-is": "The condition is met if the type of slot is",
	"schedules.exception.repeats-every-year": "Repeats every year",
	"schedules.exception.slot-type": "Slot type",
	"schedules.exception.slot-type-desc": "The same type of slot will apply during the exception",
	"schedules.exception.state-outside-slot": "Outside this slot, the type of slot defined in the schedule as the default slot will apply. | Outside these slots, the type of slot defined in the schedule as the default slot will apply.",
	"schedules.exception.type-of-period.a-day": "A day",
	"schedules.exception.type-of-period.time-period": "Time period",
	"schedules.exceptions.create-exception": "Add exceptions",
	"schedules.exceptions.define-exceptions-msg": "List bank holidays, holidays or any other exceptional event likely to impact the schedule.",
	"schedules.exceptions.edit-existing-exceptions": "Edit the list",
	"schedules.exceptions.select-existing-exceptions": "List of exceptions",
	"schedules.exceptions.slot-type-personalized": "Personalized",
	"schedules.failed-deleting-exception": "Failed deleting exception",
	"schedules.failed-deleting-schedule": "Failed deleting schedule",
	"schedules.instruction-of-state": "Setpoint",
	"schedules.instructions-activity-period": "Application period",
	"schedules.no-setpoints": "No setpoints",
	"schedules.properties.add-properties": "Add properties",
	"schedules.properties.select-properties": "Select properties",
	"schedules.schedule-saved-successfully": "Weekly schedule saved. \n To send it to the box, click on the \"Save changes\" button",
	"schedules.schedule-state": "Slot type",
	"schedules.schedule-state.add-type": "Add type",
	"schedules.schedule-state.manage-type": "Manage type",
	"schedules.schedule-state.occupied": "Occupied",
	"schedules.schedule-state.type": "Type",
	"schedules.schedule-state.unoccupied": "Unoccupied",
	"schedules.see-the-properties": "See and edit properties",
	"schedules.select-exceptions": "Select the exceptions to add to the schedule",
	"schedules.select-slot-to-apply": "Select slot to apply",
	"schedules.setpoint-value": "Setpoint value",
	"schedules.setpoint-values": "Setpoint values",
	"schedules.setpoints-saved-successfully": "Setpoints modified successfully",
	"schedules.slots": "Slots",
	"schedules.slots.help-txt": "Fill in the slots of the day (e.g. \"occupied\"). You will set the slot that applies by default for the rest of the day after (e.g. \"unoccupied\").",
	"schedules.slots.tooltip": "During the “Properties & setpoints” step, you will associate a setpoint with each type of slot.",
	"schedules.specific-period": "Specific Period",
	"schedules.state-plus-name": "Slot {name}",
	"schedules.state-used-tooltip": "This schedule or another uses this slot type, it can't be deleted. Please edit the schedule to stop using this slot type before deleting it.",
	"schedules.time-period": "Time period",
	"schedules.time-period-recurring": "Repeat every year",
	"scheduling": "Scheduling",
	"schematic": "Schematic",
	"schematic-drag-image-here": "Schematic\n\nDrag & Drop an image \n\nPNG, JPEG",
	"scopes": "Scopes",
	"search": "Search",
	"search-for-a-box": "Search for a @.lower:box",
	"search-for-a-device": "Search for a device (name, device ID or hardware ID)",
	"search-for-a-property": "Search for a property",
	"search-for-a-recipient": "Search for a recipient",
	"search-for-alarms": "Search for Alarms",
	"search-for-an-equipment": "Search for an equipment",
	"search-for-archive-requests": "Search for data archive requests",
	"search-for-delegated-connections": "Search by first name, last name, email",
	"search-for-hub": "Search for a @.lower:hub (Name, Device Id or Hardware Id)",
	"search-for-organization-name": "Search for an organization's name",
	"second": "Second",
	"second-plural": "Second | Seconds",
	"secondary-address": "Secondary address",
	"secondary-address-mbus-tooltip": "Secondary address of the equipment. Format: 16 uppercase hexadecimal caracters<br />If both addresses are field and if its format is correct, the secondary address only will be taken into account",
	"seconds": "Seconds",
	"seconds-symbol": "s",
	"secret-key": "Secret key",
	"security": "Security",
	"security-key": "Security Key",
	"see-details": "See details",
	"see-last-values": "See last values",
	"see-more": "See more",
	"see-more-in-live-data": "See more in live data",
	"see-redirection-property": "See where the property is redirected to",
	"see-schedule": "See schedule",
	"see-the-former-scan": "See the former scan",
	"see-the-latest-values": "See the latest values",
	"see-the-schedule": "See the schedule",
	"see-this-scan": "See this scan",
	"segment-number": "Segment Number",
	"segment-number-description": "The segment number of the LPB equipment",
	"select": "Select",
	"select-a-connector": "Select a connector",
	"select-all-properties": "Select all properties",
	"select-an-alarm": "Select an alarm",
	"select-an-equipment": "Select an equipment",
	"select-and-configure-box-ethertnet-connector": "Select and configure the ethernet connector.",
	"select-at-least-one-property": "You have to select at least one property",
	"select-at-least-one-weekday": "You have to select at least one weekday",
	"select-box-or-hub-for-file": "Select the @.lower:box for the file",
	"select-date": "Select Date",
	"select-date-range": "Select date range",
	"select-device": "Select box",
	"select-equipment-left-column-list-properties": "Select an equipment on the left column to list all available properties",
	"select-file-format": "Select file format",
	"select-file-visibility": "Select the file visibility",
	"select-frequency-receive-notification": "Select frequency to receive notifications",
	"select-gateway": "Select the gateway:",
	"select-graph": "Select the graph",
	"select-hubs-to-export-configuration": "Select which @.lower:hubs you would like to export the configuration",
	"select-notification-type": "Select notification type",
	"select-organization-fot-file": "Select the organization for the file",
	"select-organization-to-see-connectors-or-to-create-new": "Select an organization to see its connectors or to create a new one",
	"select-product-reference": "Select a product reference",
	"select-properties": "Select properties",
	"select-properties-to-activate": "Select properties to activate",
	"select-properties-to-redirect-to-gateway": "Select the properties you want to redirect to your gateway, configure them and save it.",
	"select-properties-xlsx": "Select the properties with a file",
	"select-property": "Select property",
	"select-property-one-least": "Please add at least one property.",
	"select-property-to-apply-interval": "Select property to apply the interval",
	"select-region-and-frequency-for-sensors": "Select the region (if available) and the frequency for sensors.",
	"select-region-for-lorawan-equipment": "Select one of the supported regions for the LoRaWAN equipment",
	"select-region-frequency-equipment-is-installed": "Select the Region and Frequency where your equipment is installed",
	"select-rvl-equipment": "Select RVL equipment",
	"select-the-properties": "Select the properties",
	"select-the-region": "Select the region",
	"select-the-user-to-send-the-license-by-email": "Select the user to send the license by e-mail",
	"select-to-activate": "Select properties to enable actions",
	"select-which-address-run-scan": "Select on which address you want to run the scan",
	"selected": "Selected",
	"selected-properties": "Selected Properties",
	"send": "Send",
	"send-archive-to": "Send the archive to",
	"send-configuration-to-hub": "Send the configuration to the @.lower:hub",
	"send-configuration-to-the-box": "Send configuration to the @.lower:box",
	"send-license": "Send license",
	"send-license-by-email": "Send license by e-mail",
	"send-new-configuration-to-the-box": "Send new configuration to the @.lower:box",
	"send-the-configuration": "Send the configuration",
	"send-updates-to-device": "Check to send the changes to the box after saving",
	"send-updates-to-device-infos": "If you have several changes to make, tick this box before saving the last change.",
	"send-values": "Send values",
	"sending-frequency": "Sending frequency",
	"sending-notifications": "Sending notifications",
	"sent-configuration-to-box-msg": "Saving and applying configration to the @.lower:{'box'}. Wait, please.",
	"separate-values-with-semicolons": "Separate values with {comma}. Do not add the unit. Use {dot} for decimal numbers.",
	"separator": "Separator",
	"separator-space-or-comma": "Separator: space or comma",
	"serial-number": "Serial Number",
	"server-host": "Server host",
	"server-port": "Server port",
	"service-account": "Service account",
	"service-account-deleted": "Successfully deleted service account",
	"service-account-updated": "Successfully updated service account",
	"set-out-of-service": "Disable this holiday",
	"set-to-null": "Set to null",
	"set-value": "Set a value",
	"set-value-to-property": "Set a value to property",
	"settings": "Settings",
	"several-actions": "Actions on several items",
	"severity": "Severity",
	"severity-level-to-apply-to-alerts": "Severity level to apply to alerts",
	"severity-level-to-apply-to-alerts-when-created": "Severity level to apply to alerts created by the alarm",
	"show-advanced-properties": "Show advanced properties",
	"show-all-properties": "Show all properties",
	"show-hide-default-values-in-calendar": "Show/hide default values in calendar. For atlantic_navipass_weekly, the default value is OFF. For bacnet, you setup the value on configurations.",
	"show-more-info": "See details",
	"show-more-organization": "Show more organization",
	"show-side-panel": "Show side panel",
	"sidebar-menu-item.collapse-sidepanel": "Close side panel",
	"sidebar-menu-item.company": "Organization",
	"sidebar-menu-item.expand-sidepanel": "Open side panel",
	"sidebar-menu-item.home": "Home",
	"sidebar-menu-item.map": "Map",
	"signal": "Signal",
	"signal-strength": "Signal Strength",
	"sim-card.expired": "Expired SIM Card",
	"skip-this-step": "Skip this step",
	"slave-id": "Slave Id",
	"slave-id-modbus-gateway": "The slave id of this modbus gateway",
	"slot": "Slot",
	"slots": "Slots",
	"slug-name": "Slug name",
	"sms": "SMS",
	"sms-to": "SMS to",
	"snvt-type-index": "SNVT Type Index",
	"software": "Software",
	"some-fields-are-invalid": "Some fields are invalid",
	"some-fields-are-required": "Some fields are required",
	"something-went-wrong": "Something went wrong",
	"something-went-wrong-our-side-try-again": "Something went wrong in our side. Try again.",
	"something-went-wrong-try-again": "Something went wrong in our side. Try again.",
	"sort-by": "Sort by",
	"specific-mask-address": "Specific mask address",
	"specify-condition": "Specify condition",
	"spreading-factor": "Spreading Factor",
	"standard": "Standard",
	"start": "Start",
	"start-again": "Start again",
	"start-date": "Start date",
	"start-index": "Start index",
	"start-time": "Start Time",
	"started-at": "Started at",
	"starting-time": "Starting time",
	"state-schedule-object-click-see-full-json": "State of the Schedule object. Click here to see the full schedule in a JSON format",
	"status": "Status",
	"status-down": "Status: Down",
	"status-for-connector-not-available": "The status for this connector is not available",
	"status-missing": "Missing Data",
	"status-ok": "Status: OK",
	"stay": "Stay",
	"stay-at-this-page": "Stay",
	"stay-here": "Stay here",
	"step-line": "Steps",
	"stop-bits": "Stop bits",
	"stop-reception-property-data": "Stop the reception of property values",
	"strict-ranges": "Strict ranges",
	"sub-field": "Sub-field",
	"sub-field-tooltip": "The path to the field to extract from the structure. The path has to be in the form: first Level Structure.second Level Structure....subfield, this will extract the value of subfield from its parent structure, regardless of the depth of the structure.",
	"subscription": "Subscription",
	"subscription.expired": "Expired subscription",
	"subscription.expiring.soon": "Expiring subscription",
	"subscription.suspended": "Suspended subscription",
	"success": "Success",
	"success-creating-organization": "Success creating new organization",
	"success-editing-organization": "Success updating organization",
	"successfully-added-properties": "You have successfully added the properties",
	"successfully-dashboard": "You have successfully saved the dashboard",
	"successfully-saved-graph": "You have successfully saved the graph",
	"successfully-updated": "Successfully updated",
	"summary": "Summary",
	"sunday": "Sunday",
	"support-contact": "Contact the support team",
	"support-forum": "Help Center",
	"supported-frequencies": "Supported frequencies",
	"swap-boxes": {
		"command-timeout-msg": "Command timed out. Please go back and try again",
		"page-title": "Swap @.lower:box {'|'} {boxName}",
		"step1": {
			"breadcrumb": "Prerequisites",
			"msg1": "Make sure all of the following conditions are met before swapping the box.",
			"msg2": "1. The RMA (Return Merchandise Authorization) request has been approved and/or you received a new @.lower:{'box'}.{br}2. You are onsite with both boxes.{br}3. The faulty @.lower:box is powered on and is online (its status is green).{br}4. From now on, do not edit the configuration of the faulty @.lower:box",
			"next-btn": "I understand, continue",
			"title": "Before you begin",
			"warning": "If any prerequisite is not met, stop here and resolve it before continuing."
		},
		"step2": {
			"accordion-msg-eu": "If @.lower:box is located in Europe",
			"accordion-msg-na": "If @.lower:box is located in North America",
			"accordion-title": "Where to find the @.lower:box serial number?",
			"breadcrumb": "New @.lower:box",
			"current-box-serial-number": "Faulty @.lower:box serial number",
			"msg1": "Scan or type the serial number printed on the new @.lower:box label.",
			"new-box-serial-number": "New @.lower:box serial number",
			"next-btn": "Next",
			"siemens-serial-number-1": "New @.lower:box HardwareId",
			"siemens-serial-number-2": "Verification code",
			"siemens-serial-number-2-help-msg": "Last digits after -",
			"siemens-serial-number-fields-required": "HardwareId and verification code are required",
			"siemens-serial-number-no-access": "You don't have access to the @.lower:box",
			"siemens-serial-number-wrong-crc": "Invalid verification code (CRC). Please check the code and try again.",
			"siemens-serial-number-wrong-device-version": "These two devices can't be swapped because they're running different LoRaWAN software versions. Please make sure both devices use the same LoRaWAN software (both should have BSP >= 8.x OR BSP < 8.x), and try again.",
			"siemens-serial-number-wrong-hardware-id": "Invalid hardwareID. Please check the ID and try again.",
			"title": "Enter the replacement @.lower:box serial number"
		},
		"step3": {
			"breadcrumb": "Confirm",
			"configuration": "Configuration (Connectors, Networks, Routing, Equipment, Gateways...) ",
			"configuration-to-be-transferred": "Configuration to be transferred",
			"current-box-title": "Faulty @.lower:box (to be returned)",
			"lorawan-configuration": "LoRaWAN configuration",
			"msg": "The following settings will be transferred from the faulty @.lower:box to the new replacement @.lower:{'box'}.",
			"next-btn": "Confirm swap",
			"replacement-box-title": "Replacement @.lower:box",
			"title": "Review configuration transfer"
		},
		"step4": {
			"backup-done": "LoRaWAN configuration back up done",
			"backup-failed": "LoRaWAN configuration back up",
			"backup-in-progress": "LoRaWAN configuration back up",
			"breadcrumb": "LoRaWAN Backup",
			"error-message": "Error: LoRaWAN back up failed for device ID \"{deviceId}\". Please go back and try again",
			"msg": "Do not power off the faulty @.lower:box until the process is complete",
			"next-btn": "Next",
			"title": "LoRaWAN configuration backup"
		},
		"step5": {
			"breadcrumb": "Power off/on",
			"msg": "Wait till the Heartbeat LED and the GSM LED beats green. The new @.lower:box will update and connect. The whole process takes 10 minutes on average.",
			"new-box-outdated-and-no-auto-update": "The new @.lower:box is outdated and disabled automatic firmware updates. Please go back and update the new @.lower:box before continuing",
			"next-btn": "New @.lower:box is powered on, continue",
			"title": "Power off the faulty @.lower:box and power on the new @.lower:box"
		},
		"step6": {
			"breadcrumb": "New @.lower:box preparation",
			"error-msg": "Error: Impossible to transfer the configuration to the new @.lower:{'box'}. Please go back and try again",
			"error-msg-lora-import": "Error: Error while importing the LoRaWAN configuration backup. Please use the button on the right to try it again. If it fails again reach out to your support team.",
			"error-msg-publish": "Error: Error while exporting/importing the configuration to the new @.lower:{'box'}. Please use the button on the right to try it again. If it fails again reach out to your support team.",
			"export-import-msg": "Export/Import faulty @.lower:box configuration",
			"lorawan-import-msg": "Import faulty @.lower:box LoRaWAN configuration back up",
			"msg": "Do not power off the current @.lower:box until the process is complete",
			"next-btn": "Go to new @.lower:box",
			"retry-msg": "Retry",
			"success-msg": "The replacement @.lower:box is now active. The old @.lower:box is ready to be returned.{br}{br}Recommended next steps:{br}1. Verify sensor data is flowing correctly in the console.{br}2. Ship the old box back using the RMA label.",
			"success-title": "@.capitalize:box swap complete!",
			"title": "New @.lower:box preparation"
		},
		"swap-btn": "Swap @.lower:box"
	},
	"sync": "Sync.",
	"synchronized": "Synchronized",
	"synco-exception-day": "Schedule set in the 8th day (exception schedule)",
	"synco-exception-disable-text": "Disable the exception",
	"synco-exception-disable-text-help": "If you disable the exception the equipment will reset the exception details to null",
	"synco-exception-end-day-label": "End on (included)",
	"synco-exception-help-msg": "Because the equipment is of type Synco, please be careful when editing exceptions. If an exception is disabled, this exception might be alocated to another exception property. Therefore, please read the different exceptions before editing any of them",
	"synco-exception-invalid-range": "The start and end days must be coherent",
	"synco-exception-period": "REDUCED mode or PROTECTION mode (eco mode)",
	"synco-exception-start-day-label": "Start on",
	"synco-exception-type": "Schedule to apply during the exception",
	"system-lorawan-property-tooltip": "This property is not counted among the properties available in your subscription",
	"table": "Table",
	"table-block-label-a": "Header column A",
	"table-block-label-b": "Header column B",
	"table-block-label-c": "Header column C",
	"table-block-nb-of-columns": "Number of columns (A, B, C...)",
	"table-block-nb-of-rows": "Number of rows (1, 2, 3...)",
	"table-block-title-1": "Label line 1",
	"table-block-title-2": "Label line 2",
	"table-block-title-3": "Label line 3",
	"tabs.organization.devices": "Devices",
	"tag-can-start-with-ws": "The key of a tag can't start with ws_",
	"tag-key-cant-be-empty": "The key of a tag can't be empty",
	"tags": "Tags",
	"target": "Target",
	"tcp-port": "TCP Port",
	"technical-contact": "Technical Contact",
	"telephone": "Phone",
	"telephone-number": "Telephone number",
	"test-in-progress": "Test in progress",
	"test-route": "Test the route",
	"test-routing-table": "Test the routing table",
	"the-certificate-has-to-be-of-type-MQTT_CA_CERTIFICATE": "The certificate has to be of type MQTT_CA_CERTIFICATE",
	"the-certificate-has-to-be-type-MQTT_CLIENT_CERTIFICATE": "The certificate has to be of type MQTT_CLIENT_CERTIFICATE",
	"the-certificate-has-type-MQTT_PRIVATE_KEY": "The certificate has to be of type MQTT_PRIVATE_KEY",
	"the-end-customer": "The end customer",
	"the-max-cpu-usage-percent": "The max CPU usage in percent",
	"the-new-scan-in-progress-while-is-completed-do-you-want-see-former-scan-new-scan-results-will-shown-when-over": "The new scan is in progress. Till the scan is over, do you want to see the former scan outputs? The new scan results will be shown as soon as it is completed.",
	"the-new-scan-is-over-do-you-want-to-load-its-results": "The new scan is over. Do you want to load its results?",
	"the-number-of-registers-to-read-write": "The number of registers to read/write",
	"the-port-network-will-list": "The port on which this network will listen.",
	"the-trigger-will-execute-only-for-boxes-listed-below": "The trigger will execute only for the @.lower:boxes listed below",
	"the-type-of-the-register-to-use": "The type of register to use",
	"the-value-is-not-a-valid-URL-address": "The value is not a valid URL address",
	"then": "Then",
	"this-connector-doesnt-have-any-trigger": "This connector doesn't have any trigger",
	"this-device-does-not-have-access-to-heating-optimizer": "This @.lower:box does not have access to Heating Optimizer. Contact support, please.",
	"this-property-isnt-receiving-any-redirections": "This property isn't receiving any redirections",
	"this-property-isnt-redirecting-its-values": "This property isn't redirecting its values",
	"this-property-receives-values-from-properties-listed-below": "This property receives values from the properties listed below",
	"this-property-will-redirect-all-values-to-properties-listed-below": "This property will redirect all values to the properties listed below",
	"this-will-archive-connecor-and-triggers-attached-you-will-no-longer-receive-data-through-the-connector": "This will archive \"{connector}\" as well as the triggers attached to it, if any. You will no longer receive data through the connector.",
	"this-will-delete-x-properties-from-gateway": "This will delete 1 property from the gateway | This will delete {x} properties from the gateway",
	"this-will-delete-x-properties-past-values-will-be-deleted": "This will delete 1 property. All the past values of the property will be deleted. | This will delete {x} properties. All the past values of the properties will be deleted.",
	"thursday": "Thursday",
	"tile-alone": "Single value",
	"tile-configuration-link": "Configure the property",
	"tile-history-link": "See the latest values",
	"time": "Time",
	"time-to-reach": "Time to reach comfort",
	"times": "times",
	"title": "Title",
	"tls-certificate": "TLS certificate",
	"to": "To",
	"to-create-data-stream-have-at-least-one-connector-one-trigger-connectors-specify-link-infrastructures": "To create a data stream, such as a webhook or a cloud to cloud MQTT connection, you need to declare at least one connector and one trigger. Connectors specify the link to your infrastructure.",
	"to-list-equipment-properties-available-select-box-connector": "To list all equipment's available properties, select the @.lower:box connector.",
	"toast.alarm-saved": "Alarm saved",
	"toast.hub-received-command": "@.capitalize:client-name-hub received the command",
	"toast.scan-bacnet-devices-in-progress-percentage": "Scan of BACnet devices in progress ({percentage}%)",
	"toast.waiting-for-hardware-connection": "Trying to connect the @.capitalize:client-name-hub to our server, please wait",
	"toast.weekly-schedule.days-copied-successfully": "Successfully applied the schedule to selected days",
	"today": "Today",
	"token-validity-period": "Token validity period",
	"tooltip-alarm-status": "<strong class='has-text-white'>Acknowledge</strong>: indicate the alarm as \"seen\". No new notification will be sent unless the alarm is triggered again after 24 hours <br /><br /> <strong class='has-text-white'>Reopen</strong>: the alarm will be opened again. Does not change the status of alerts associated with the alarm",
	"tooltip-wmbus-device-type": "2 characters hex string found on the device label or documentation",
	"tooltip-wmbus-dib": "Concatenate both DIFs and DIFEs in hexadecimal. Example: with DIF=01 DIF=02 DIFE=03 DIFE=04, use 01020304",
	"tooltip-wmbus-encryption": "Whether the device uses encryption (A profile)",
	"tooltip-wmbus-id-number": "Also called \"Serial Number\", 8 digits number found on the device label",
	"tooltip-wmbus-mode": "Listening to wM-Bus sensors of this mode, use \"T & C\" if you have both T and C sensors",
	"tooltip-wmbus-physical-connector": "wM-Bus and LoRaWAN use the same physical connector",
	"tooltip-wmbus-version-number": "Also called \"Protocol Version\", 2 characters hex string found on the device label or documentation",
	"tooltip-wmbus-vib": "Concatenate both VIFs and VIFEs in hexadecimal. Example: with VIF=01 VIF=02 VIFE=03 VIFE=04, use 01020304",
	"tooltip.advanced-config-error": "To create equipment, edit the configuration.",
	"tooltip.bacnetscan.select-device-to-add-properties": "Select the device to see the available properties",
	"tooltip.bacnetscan.total-raw-properties": "Total properties scanned",
	"tooltip.bacnetscan.total-selectable-properties": "Properties selectable",
	"tooltip.bacnetscan.total-selected-properties": "Currently selected properties",
	"tooltip.box-timezone": "The schedule will run according to the local time defined in the @.lower:{'box'}.",
	"tooltip.edit-advanced-config": "Edit advanced configuration",
	"tooltip.last-read-value-data-time": "Last value read: {value} {unit}{asterisk} on {dateTime}",
	"tooltip.last-written-value-data-time": "Last value written via the console by a user: {value} {unit}{asterisk} on {dateTime}",
	"tooltip.lorawan-codec.manufacturer-and-product-reference": "Select your equipment reference to enable automatic decoding of the LoRaWAN frames",
	"tooltip.satellite-rate-plan.parent-box": "You are activating a @.lower:box with a Satellite license. You must define a parent @.lower:box with a Medium or Large license, located on the same site, and activated. Your satellite @.lower:box will be attached to the parent @.lower:{'box'}.",
	"tooltip.schedules-exceptions.edit": "Edit exception",
	"tooltip.schedules-exceptions.move-down": "Move down",
	"tooltip.schedules-exceptions.move-up": "Move up",
	"tooltip.schedules-exceptions.remove": "Remove from the selection",
	"tooltip.schedules-properties.remove": "Remove from the selection",
	"tooltip.schedules-properties.remove-property": "Remove from schedule",
	"tooltip.schedules.live-data-calendar-icon": "This property is controlled by the schedule {schedules}. | This property is controlled by the schedules: {schedules}.",
	"tooltip.schedules.setpoint-scaling": "If an \"ax + b\" like scaling is applied in the property configuration, it will be visible in this column. Also:<br />- The value is only scaled when it is read from the console<br />- Scaling is not taken into account when the value is written<br />- Inside the box (redirection), scaling is not taken into account",
	"total-properties": "Total properties:",
	"trigger-alert-based-on": "Trigger",
	"trigger-saved": "Trigger saved",
	"trigger-type": "Type of trigger",
	"triggers-define-required-call-connector-and-what-values-send": "Triggers define what is required to call the connector and what values to send.",
	"try-again": "Try again",
	"tuesday": "Tuesday",
	"type": "Type",
	"type-licence-to-attach-to-device": "Type of license to attach to the box",
	"type-of-trigger": "Type of trigger",
	"tz.local": "Local Time",
	"tz.utc": "UTC Time",
	"udp-port": "UDP Port",
	"udp-port-custom": "Custom UDP Port",
	"udp-port-custom-help": "Port number (e.g. 50808)",
	"unique-id": "Unique ID",
	"unit": "Unit",
	"unknown": "Unknown",
	"unknown-status": "No connection status available",
	"unpair": "Unpair",
	"update": "Update",
	"update-archive-request": "Update Data Archive Request {name}",
	"update-hub": "Update @.lower:hub",
	"update-name": "Apply the changes to the gateways",
	"update-name-equipment-in-gateway": "Use the new name in the gateways",
	"update-properties": "Update properties",
	"update-property-changes-in-gateway": "Apply the property changes to the gateways",
	"update-the-scan": "Update the scan",
	"update-the-trigger": "Update the trigger",
	"update-your-password": "Update your password",
	"updated": "Updated",
	"uplink-topic": "Uplink topic",
	"uplink-topic-for-alarms": "Uplink topic for alarms",
	"uplink-topic-for-events": "Uplink topic for events",
	"uplink-topic-for-values": "Uplink topic for values",
	"upload-configuration": "Upload configuration",
	"upload-configuration-will-delete-current-after-send-hub": "Uploading a new configuration to {deviceName} will delete and replace its current configuration after it is sent to the @.lower:hub",
	"url": "URL",
	"use-mask-identification-number": "Use a mask on the identification number",
	"use-old-scan": "Use old scan",
	"use-previous-scan": "Use this scan",
	"use-single-bit": "Use a single bit",
	"user": "User",
	"user-information": "User information",
	"user-management": "User management",
	"user-profile": "User profile",
	"user-profile-updated-with-success": "Successfully updated user profile",
	"user-saved": "User saved",
	"username": "Username",
	"username-used-in-the-authentication": "The username used in the authentication",
	"validate": "Validate",
	"validate-recipient": "Validate recipient",
	"validations.value.required": "Value is required",
	"validator.check-your-email-address": "Check your email address",
	"value": "Value",
	"value-before-last-value": "Previous value received on:",
	"value-from-property-at-scan-time": "Value of the property at the moment of the scan {time}",
	"value-most-not-have-more-than-characters": "Value must not have more than {length} characters",
	"value-must-be-a-decimal": "Value must be a decimal",
	"value-must-be-an-integer": "Value must be an integer",
	"value-must-be-between": "Value must be between {min} and {max}",
	"value-must-be-numeric": "Value must be numeric",
	"value-must-have-at-least-characters": "Value must have at least {length} characters",
	"value-must-have-x-characters": "Value must have {characters} characters",
	"value-not-accepted": "Value not accepted",
	"value-of-nv-index": "The value of NV Index",
	"value-of-snvt-type-index": "The value of SNVT Type Index",
	"value-should-be": "Value should be {value}",
	"value-type-function": "Value type (function)",
	"values": "Values",
	"values-route": "Values route",
	"values-url": "Values url",
	"vendor-specific-apn-link": "The vendor specific APN link",
	"verifiation-code": "Verification code",
	"verification-code": "Verification code",
	"version": "Version",
	"version-history": "Version history",
	"version-number": "Version Number",
	"views.account-settings.views.service-accounts.service-accounts.add-service-account": "Create service account",
	"views.account-settings.views.service-accounts.views.service-account.description": "Description",
	"views.account-settings.views.service-accounts.views.service-account.username": "Username",
	"views.account-settings.views.users.users.failed-get-users": "Failed getting list of users.",
	"views.auth.activation.backlogin": "Log in here",
	"views.auth.activation.backlogin.question": "Do you already have an account ?",
	"views.auth.activation.confidential": "By activating my account, I accept ",
	"views.auth.activation.confidential-underline": "the privacy policy and the terms of use.",
	"views.auth.activation.failed-account": "If your account already exists,",
	"views.auth.activation.failed-account-backLogin": "login here",
	"views.auth.activation.failed-username-point1": "Check your email address",
	"views.auth.activation.failed-username-point2": "Check with your organization's administrator that your access has been initialised",
	"views.auth.activation.introduction": "It is the first time you want to access to the console? Begin to activate your account.",
	"views.auth.activation.log-to-proceed": "Activate your account",
	"views.auth.activation.opt-in-newsletter": "Receive information about new features via email (1 per quarter).",
	"views.auth.activation.optin": "Receive information about new features via email (1 per quarter).",
	"views.auth.email-sent-with-link-reset-password": "We have e-mailed your password reset link!",
	"views.auth.inform-valid-email": "Enter a valid e-mail address",
	"views.auth.login.failed-account": "If this is your first visit,",
	"views.auth.login.failed-account-backActivation": "activate your account here",
	"views.auth.login.failed-login": "Ops! Log in failed! Check your credentials!",
	"views.auth.login.failed-username-point1": "Correct your email address or password",
	"views.auth.login.log-to-proceed": "Log in to your account",
	"views.auth.login.password": "Password",
	"views.auth.login.password-confirm": "Confirm password",
	"views.auth.login.password-min-8-chars": "Your password is too short, please use at least 8 characters",
	"views.auth.login.passwords-dont-match": "Passwords must be the same",
	"views.auth.request-new-password.backlogin": "Back to Login",
	"views.auth.request-new-password.password": "Reset password",
	"views.auth.request-new-password.reset-password-email-sent-p1": "The password reset link has been sent to your email address.",
	"views.auth.request-new-password.reset-password-email-sent-p2": "You will receive it within 5 minutes. Remember to check your spam folder.",
	"views.auth.request-new-password.subtitle": "Enter your email address and we’ll send you a link to reset your password.",
	"views.auth.request-new-password.title": "Forgot your password ?",
	"views.auth.reset-password.backlogin": "Back to Login",
	"views.auth.reset-password.loginsystem": "Log In into system",
	"views.auth.reset-password.reset": "Reset password",
	"views.auth.reset-password.success": "Password reset successfully!",
	"views.auth.reset-password.title": "Reset password",
	"views.auth.setup.account-configured-ready-to-use": "You can now log into the console.",
	"views.auth.setup.add-users-to-organization": "Add users to your Organization",
	"views.auth.setup.back": "Back to Log in",
	"views.auth.setup.click-to-go-user-console": "Login",
	"views.auth.setup.code": "Enter the Code you've received by Email",
	"views.auth.setup.code-sent-to-email": "New code was sent to {email}",
	"views.auth.setup.code.check-email": "Check your email",
	"views.auth.setup.code.failed": "The code is incorrect. Check it or ",
	"views.auth.setup.code.failed.new-code": "request a new code.",
	"views.auth.setup.code.get-new-code": "Request new code",
	"views.auth.setup.code.introduction": "A confirmation code has been sent to {email}.",
	"views.auth.setup.code.introduction-to-enter": "Please enter it below to confirm your email address.",
	"views.auth.setup.code.introduction.without-email": "We sent you a confirmation code.",
	"views.auth.setup.contacts": "Select your Organization Contacts",
	"views.auth.setup.continue": "Continue",
	"views.auth.setup.create-password": "Create a password to secure login",
	"views.auth.setup.failed-requesting-new-code": "We couldn't send the code to {email}. Contact us at contact{'@'}wattsense.com",
	"views.auth.setup.failed-saving-user": "Failed saving {user}",
	"views.auth.setup.finish.title": "Account activated",
	"views.auth.setup.inform-valid-email": "Enter a valid e-mail address",
	"views.auth.setup.inform-valid-name": "Enter a name",
	"views.auth.setup.is-user-admin": "Is Organization Admin?",
	"views.auth.setup.organization": "Tell us more about your Organization",
	"views.auth.setup.organization-name": "Organization Name",
	"views.auth.setup.request-new-code": "Didn't receive the code or is it expired? Click here to get a new one!",
	"views.auth.setup.set-your-password-below": "Please set your password now.",
	"views.auth.setup.skip": "Skip",
	"views.auth.setup.try-again": "Oops! Please try again",
	"views.auth.setup.user-name": "Full Name",
	"views.auth.setup.user-remove": "Remove",
	"views.auth.setup.users-saved": "Users created",
	"views.auth.username.password.failed-title": "An error occurred",
	"views.box-list-map.box-list-map.failed-getting-devices": "Failed getting list of @.lower:boxes",
	"views.box-list-map.components.map.location": "Set/Change location",
	"views.box-list-map.components.map.zoom": "Focus",
	"views.box-list-map.components.search-address.address-not-found": "Address not found",
	"views.box-list.box-list.failed-get-box-list": "Failed to get @.lower:boxes list.",
	"views.box-list.box-list.failed-get-box-location": "Failed to get @.lower:box location.",
	"views.box-list.box-list.failed-get-search-location": "Failed to get search localisation.",
	"views.box-list.box-list.search": "Search a location...",
	"views.box-list.box-list.search-for-box": "Search for a @.lower:box (Name, Device Id or Hardware Id)",
	"views.box-list.components.dialog-active-box.box-plan-addonsmax": "Addons: ",
	"views.box-list.components.dialog-active-box.box-plan-datapoints": "Max data points: ",
	"views.box-list.components.dialog-active-box.box-plan-properties": "Data points included: ",
	"views.box-list.components.inactive-device.inactive-box": "Inactive @.lower:box",
	"views.box.box.failed-get-box-info": "Failed getting @.lower:box information",
	"views.box.components.box-nav.box-nav.configuration": "Configuration",
	"views.box.components.box-nav.box-nav.graph": "Graph",
	"views.box.components.box-nav.box-nav.logs": "Logs",
	"views.box.components.dialog-edit-box-geolocation.dialog-edit-box-geolocation.box-geolocation-changed": "@.capitalize:box geographic location changed",
	"views.box.components.dialog-edit-box-geolocation.dialog-edit-box-geolocation.failed-saving-new-geolocation": "Failed saving new geographic location",
	"views.box.components.dialog-edit-box-name.dialog-edit-box-name.box-name-changed": "@.capitalize:box name changed",
	"views.box.old-config": "Looks like your @.lower:box is outdated. Please, get in touch with our team to upgrade your @.lower:{'box'}.",
	"views.box.views.configuration.components.footer-buttons.cancel-sent-changes": "Revert sent changes",
	"views.box.views.configuration.components.footer-buttons.cant-send-configuration-box-not-online": "Not allowed to send configuration to the @.lower:box because it's not online",
	"views.box.views.configuration.components.footer-buttons.failed-getting-command-details": "Failed getting command details",
	"views.box.views.configuration.components.footer-buttons.failed-getting-device-information": "Failed getting @.lower:box status",
	"views.box.views.configuration.components.footer-buttons.failed-reverting-changes": "Failed reverting changes",
	"views.box.views.configuration.components.footer-buttons.failed-saving-configuration": "Failed sending the configuration to the @.lower:box",
	"views.box.views.configuration.components.footer-buttons.message-revert-sent-changes": "Cancel sent changes (they were not applied to the @.lower:box yet)?",
	"views.box.views.configuration.components.footer-buttons.new-configuration-in-box": "The new configuration is in the @.lower:{'box'}!",
	"views.box.views.configuration.components.modal-publish-draft.comment": "Write a comment about this new setting being sent to the @.lower:box",
	"views.box.views.configuration.components.modal-publish-draft.placehoder": "A description of this revision. Useful for listing the changes that was made in this revision.",
	"views.box.views.configuration.components.modal-publish-draft.send-to-box": "Send to the @.lower:box",
	"views.box.views.configuration.components.modal-publish-draft.title": "Send configuration to @.lower:box",
	"views.box.views.configuration.components.tabs.connectors": "Connectors",
	"views.box.views.configuration.components.tabs.equipment": "Equipment",
	"views.box.views.configuration.components.tabs.gateways": "Gateways",
	"views.box.views.configuration.components.tabs.networks": "Networks",
	"views.box.views.configuration.views.connectors.components.panel-connector.tooltip-ipv4-method": "The type of IP configuration: manual for manually specifying the IP, or DHCP",
	"views.box.views.configuration.views.connectors.connectors-list.failed-adding-new-connector-to-draft": "Failed saving connector {connector} to Draft configuration",
	"views.box.views.configuration.views.connectors.connectors-list.failed-get-draft-current-config": "Failed getting connector from Current/Draft configuration",
	"views.box.views.configuration.views.equipment.components.modal-duplicate-equipment.duplicate-to-box": "Duplicate to @.lower:box",
	"views.box.views.configuration.views.equipment.components.modal-duplicate-equipment.select-box-to-duplicate": "Select the @.lower:box you want to duplicate this equipment",
	"views.box.views.configuration.views.equipment.components.modal-duplicate-equipment.to-which-box-duplicate": "To which @.lower:box would you like to duplicate?",
	"views.box.views.configuration.views.equipment.components.modal-duplicate-equipment.to-which-network-add-box": "To which network would you like to add the duplicated @.lower:{'box'}?",
	"views.box.views.configuration.views.equipment.components.panel-equipment.device-identifier": "Unique Device Identifier provided by manufactuter",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups": "Equipment groups",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.add": "Add group",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.all": "All equipment",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.group-name": "Group name",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.group-name-mandatory": "Group name is mandatory.",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.hint": "To move equipment to a group, click the dropdown menu on the right",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.no-equipment": "No equipment here",
	"views.box.views.configuration.views.equipment.components.panel-equipment.equipment-groups.ungrouped": "No group",
	"views.box.views.configuration.views.equipment.equipment-list.ask-delete-this-equipment": "Are you sure you want to delete this equipment?",
	"views.box.views.configuration.views.equipment.equipment-list.equipment-network-updated": "Equipment's network updated",
	"views.box.views.configuration.views.equipment.equipment-list.equipment-saved": "Equipment saved",
	"views.box.views.configuration.views.equipment.equipment-list.failed-get-draft-current-config": "Failed getting equipment from Current/Draft configuration",
	"views.box.views.configuration.views.equipment.equipment-list.failed-updating-equipment": "Failed updating equipment",
	"views.box.views.configuration.views.equipment.equipment-list.failed-updating-network": "Failed updating Equipment's Network",
	"views.box.views.configuration.views.equipment.equipment-list.remember-send-to-box": "Remember to send to the @.lower:box",
	"views.box.views.configuration.views.equipment.equipment-list.scan-save-configuration": "In order to use this network in the Scan, you have to send the configuration to the @.lower:box",
	"views.box.views.configuration.views.gateways.failed-get-draft-current-config": "Failed getting current/draft configuration for Gateways",
	"views.box.views.configuration.views.gateways.gateway-deleted": "Gateway deleted",
	"views.box.views.configuration.views.networks.components.connector.baudrate": "Baudrate",
	"views.box.views.configuration.views.networks.components.connector.data-bits": "Data bits",
	"views.box.views.configuration.views.networks.components.connector.failed-getting-infos-from-connector": "Failed getting information from connector",
	"views.box.views.configuration.views.networks.components.connector.parity": "Parity",
	"views.box.views.configuration.views.networks.components.connector.stop-bits": "Stop bits",
	"views.box.views.configuration.views.networks.components.connector.you-have-to-select-field": "You have to select a {field}",
	"views.box.views.configuration.views.networks.components.network-row.device-number": "Device number",
	"views.box.views.configuration.views.networks.components.network-row.segment-number": "Segment number",
	"views.box.views.configuration.views.networks.components.panel-network.device-instance": "@.capitalize:box device instance",
	"views.box.views.configuration.views.networks.components.panel-network.domain": "Domain",
	"views.box.views.configuration.views.networks.components.panel-network.failed-saving-network": "Failed saving network",
	"views.box.views.configuration.views.networks.components.panel-network.mode": "Mode",
	"views.box.views.configuration.views.networks.components.panel-network.mode-placeholder": "Select which mode this network will run in",
	"views.box.views.configuration.views.networks.components.panel-network.network-saved": "Network saved",
	"views.box.views.configuration.views.networks.components.panel-network.node": "Node",
	"views.box.views.configuration.views.networks.components.panel-network.placeholder-device-instance": "A device instance for this network. This device instance has to be unique on the @.lower:{'box'}.",
	"views.box.views.configuration.views.networks.components.panel-network.placeholder-frequency": "Select the frequency",
	"views.box.views.configuration.views.networks.components.panel-network.subnet": "Subnet",
	"views.box.views.configuration.views.networks.components.panel-network.timeout": "Timeout",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-device-number": "The device number of the @.lower:box itself",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-domain": "The domain of the @.lower:box on the LON IP network",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-individual-address": "The individual address of the @.lower:{'box'}. In the format A.L.D, ex: 1.2.3",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-internal-address": "The addresses used internally on the @.lower:{'box'}. In the format A.L.D; ex: 1.2.3",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-node": "The node of the @.lower:box on the LON IP network",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-placeholder-frequency": "Select the frequency the LoRa equipment will be installed.",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-placeholder-region": "Select the region the LoRa equipment will be installed.",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-port": "The port on which this network will listen",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-segment-number": "The segment number of the @.lower:box itself",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-subnet": "The sub-net of the @.lower:box on the LON IP network",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-timeout": "Maximum time for the request for processing in ms",
	"views.box.views.configuration.views.networks.components.panel-network.tooltip-udp-port": "Expected UDP port. This value is unique for a specific physical connector.",
	"views.box.views.configuration.views.networks.network-list.failed-deleting-network": "Failed deleting network",
	"views.box.views.configuration.views.networks.network-list.failed-get-draft-current-config": "Failed getting equipment from Current/Draft configuration",
	"views.box.views.configuration.views.networks.network-list.network-deleted": "Network deleted",
	"views.box.views.configuration.views.networks.network-list.search-network": "Search for a network",
	"views.box.views.configuration.views.notifications.alarm-deleted": "Event notification deleted",
	"views.box.views.configuration.views.notifications.components.form-recipient.recipient-type": "Recipient type",
	"views.box.views.configuration.views.notifications.components.form-recipient.recipient-type-tooltip": "Where the recipient will receive the alarm? By E-mail or in a Slack channel?",
	"views.box.views.configuration.views.notifications.components.panel-alarm.failed-saving": "Failed saving event notification",
	"views.box.views.configuration.views.notifications.components.panel-alarm.recipient": "Recipient",
	"views.box.views.configuration.views.notifications.components.panel-alarm.recipient-tooltip": "Where/to who the alarm will be sent to?",
	"views.box.views.configuration.views.notifications.components.panel-alarm.saved": "Event notification saved with success",
	"views.box.views.configuration.views.notifications.components.panel-alarm.title": "Configure Event Notification",
	"views.box.views.configuration.views.notifications.components.panel-alarm.type": "Event type",
	"views.box.views.configuration.views.notifications.components.panel-alarm.type-tooltip": "Type of event: when @.lower:box connects or disconnects",
	"views.box.views.configuration.views.notifications.create-new-recipient": "Create new recipient",
	"views.box.views.configuration.views.notifications.failed-deleting-alarm": "Failed deleting event notification",
	"views.box.views.configuration.views.notifications.failed-getting-recipients": "Failed getting recipients",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-data-point-type": "The KNX datapoint type identifier in the format \"xx.yyyy\", where: xx: The main number; yyyy: The subnumber",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-group-address": "The 3-level group address where to access to this property. Format \"xxx/yyy/zzz\", where: xxx: the main group; yyy: the middle group; zzz: the subgroup",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-object-index": "The object index of the property to read",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-property-index": "The property index of the property to read",
	"views.box.views.configuration.views.properties.components.panel-knx.tooltip-start-index": "The start index of the property to read",
	"views.box.views.configuration.views.properties.components.panels.failed-slug": "Failed creating slug. Try changing the name of the property (removing special characters) or contact us.",
	"views.box.views.configuration.views.properties.components.panels.timer_error": "Interval should be bigger than {seconds} seconds",
	"views.box.views.configuration.views.properties.components.panels.title": "Property {title}",
	"views.box.views.configuration.views.properties.components.panels.tooltip-unit": "The engineering unit of this property.",
	"views.box.views.configuration.views.properties.failed-information-equipment": "Failed getting information from the Equipment",
	"views.box.views.configuration.views.properties.properties.alert-send-configuration.send-configuration": "Send the configuration to the @.lower:box to apply the changes in properties",
	"views.box.views.configuration.views.properties.properties.alert-send-configuration.show-less": "Click to show less",
	"views.box.views.configuration.views.properties.properties.alert-send-configuration.show-more": "Click to show more",
	"views.box.views.configuration.views.properties.properties.list-properties": "List of properties for {equipment}",
	"views.box.views.configuration.views.properties.properties.slug-duplicated-error": "The slug for the property is already being used. Change it, please (you'll find it in Advanced)",
	"views.box.views.graph.graph.export": "Export",
	"views.box.views.graph.graph.select-least-one-property": "Select at least one property from the list below",
	"views.box.views.graph.graph.select-range": "Select date range",
	"views.box.views.logs.components.tabs.campaigns": "Campaigns",
	"views.box.views.logs.components.tabs.commands": "Commands",
	"views.box.views.logs.components.tabs.events": "Events",
	"views.box.views.logs.modal-commands-details.body": "Body",
	"views.box.views.logs.modal-commands-details.commandid": "Command ID",
	"views.box.views.logs.modal-commands-details.commandtype": "Type",
	"views.box.views.logs.modal-commands-details.createdby": "Created By",
	"views.box.views.logs.modal-commands-details.date": "Date",
	"views.box.views.logs.modal-commands-details.deviceid": "Device ID",
	"views.box.views.logs.modal-commands-details.last": "Last Update",
	"views.box.views.logs.modal-commands-details.retry": "Retry Count",
	"views.box.views.logs.modal-commands-details.status": "Status",
	"views.box.views.logs.modal-events-details.code": "Code",
	"views.box.views.properties.views.properties.components.panel-set-value-to-property.last-value": "Last set value",
	"views.box.views.properties.views.properties.components.panel-set-value-to-property.new-value": "New Value",
	"views.box.views.properties.views.properties.components.panel-set-value-to-property.title": "Set value to property",
	"views.box.views.properties.views.properties.components.property-graph.no-available-properties": "No property values to display",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.info-equipment": "I would like to request the equipment {equipment} to be added in the list.\tOther information:",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.inform-equipment-connect": "Please, inform us what's the equipment (brand, model and other useful information) you want to connect to the @.lower:box",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.placeholder": "Brand, model and other useful information from equipment",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.problem-submiting-request": "There was a problem submitting the request. Try again later.",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.request": "Request",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.request-add-equipment": "Request to add an equipment",
	"views.box.views.wizard-configuration.components.dialog-request-equipment.specify-equipment": "You have to specify which equipment you want us to add",
	"views.box.views.wizard-configuration.components.dialog-saving.add-another": "Add another equipment",
	"views.box.views.wizard-configuration.components.dialog-saving.check-configuration": "Check configuration",
	"views.box.views.wizard-configuration.components.dialog-saving.hold-on": "Updating configuration",
	"views.box.views.wizard-configuration.components.dialog-saving.problem-saving": "There was a problem saving! What do you want to do?",
	"views.box.views.wizard-configuration.components.dialog-saving.remaining": "Remind to save these changes to the box.",
	"views.box.views.wizard-configuration.components.dialog-saving.save": "Saved!",
	"views.box.views.wizard-configuration.components.dialog-saving.wait": "Please wait for the update",
	"views.box.views.wizard-configuration.components.filters.all": "All",
	"views.box.views.wizard-configuration.components.filters.equipment": "Equipment",
	"views.box.views.wizard-configuration.components.properties-filters.read": "Read",
	"views.box.views.wizard-configuration.components.properties-filters.search-for-properties-or-equipment": "Search for properties or equipment",
	"views.box.views.wizard-configuration.components.properties-filters.write": "Write",
	"views.box.views.wizard-configuration.steps.configure-connector-ethernet.failed-get-network-config": "Failed getting network configuration",
	"views.box.views.wizard-configuration.steps.configure-connector-ethernet.went-wrong": "Something went wrong in our side. Try again.",
	"views.box.views.wizard-configuration.steps.configure-connector-ethernet.which-connector-plugged": "Which connector is your equipment plugged?",
	"views.box.views.wizard-configuration.steps.configure-connector-serial.connector-warning-message": "Be aware that changing this configuration will affect all other equipment plugged in this connector.",
	"views.box.views.wizard-configuration.steps.configure-network-knx.title": "Configure KNX addresses in the @.lower:box - KNX Network Configuration",
	"views.box.views.wizard-configuration.steps.select-equipment.ask-request-equipment": "We do not have this equipment yet. Would you like to request it?",
	"views.box.views.wizard-configuration.steps.select-equipment.field-required": "Field {fieldName} is required",
	"views.box.views.wizard-configuration.steps.select-equipment.field-validation": "Field {fieldName} should be between {validationmin} and {validationmax}",
	"views.box.views.wizard-configuration.steps.select-equipment.number-required": "Field {fieldName} must be a number",
	"views.box.views.wizard-configuration.steps.select-equipment.request-it": "Request it",
	"views.box.views.wizard-configuration.steps.select-equipment.search-brand-model": "You can search for the equipment's brand and/or model",
	"views.box.views.wizard-configuration.steps.select-equipment.select-protocol": "What is the communication protocol for the equipment?",
	"views.box.views.wizard-configuration.wizard-configuration.send-to-box": "Send to the @.lower:box",
	"views.file-resources-management.edit-file": "Edit file",
	"views.file-resources-management.failed-getting-files": "Failed getting files list",
	"views.file-resources-management.failed-uploading-file": "Failed uploading file",
	"views.file-resources-management.last-modified": "Last modified",
	"views.file-resources-management.title": "File management",
	"views.file-resources-management.upload-new-file": "Upload new file",
	"views.organization.access-management.boxes-privileges.boxes-permissions": "Access by box",
	"views.organization.access-management.boxes-privileges.description-boxes-permissions": "Set the access type by box for more granular rights management.",
	"views.organization.access-management.panel-user.description-organizations-permissions": "Set the access type to organizations. Rights automatically apply to the boxes of the organization and its child organizations.",
	"views.organization.access-management.panel-user.organizations-permissions": "Access by organization",
	"views.organization.access-management.roles.administrative": "Administrative management",
	"views.organization.access-management.roles.administrative-description": "Manage organizations, sub-organizations",
	"views.organization.access-management.roles.alarm-access": "Alerts management",
	"views.organization.access-management.roles.boxes-access": "@.capitalize:boxes access",
	"views.organization.access-management.roles.boxes-access-description": "Data, Tags, Connector, Alarms",
	"views.organization.access-management.roles.boxes-management": "@.capitalize:boxes management",
	"views.organization.access-management.roles.boxes-management-description": "@.capitalize:boxes activation and configuration",
	"views.organization.access-management.roles.connectors-configuration": "Connectors configuration",
	"views.organization.access-management.roles.connectors-configuration-description": "MQTT, Webhooks, Slack Channels, Service Accounts (API Keys)",
	"views.organization.access-management.roles.metadata-configuration": "Metadata management",
	"views.organization.access-management.roles.metadata-configuration-description": "Sites, Device Groups",
	"views.organization.access-management.roles.users-management": "Users management",
	"views.organization.components.notifications.form-email.email": "E-mail",
	"views.organization.components.notifications.form-slack.channel": "Channel",
	"views.organization.components.notifications.form-slack.url": "Slack API URL",
	"views.organization.components.notifications.form-slack.username": "Username",
	"views.organization.components.service-accounts.list-api-keys.add-a-p-i-key": "Add API Key",
	"views.organization.components.service-accounts.list-api-keys.api-key-deleted": "API Key deleted",
	"views.organization.components.service-accounts.list-api-keys.api-keys": "API Keys",
	"views.organization.components.service-accounts.list-api-keys.failed-deleting-a-p-i-key": "Failed deleting API Key",
	"views.organization.components.service-accounts.list-api-keys.key": "Key",
	"views.organization.components.service-accounts.list-api-keys.secret": "Secret",
	"views.organization.components.service-accounts.panel-create-api-key.advanced-options": "Advanced options",
	"views.organization.components.service-accounts.panel-create-api-key.api-key-created": "API Key created",
	"views.organization.components.service-accounts.panel-create-api-key.create-api-key": "Create API Key",
	"views.organization.components.service-accounts.panel-create-api-key.description": "Description",
	"views.organization.components.service-accounts.panel-create-api-key.download-a-p-i-key": "Download API Key",
	"views.organization.components.service-accounts.panel-create-api-key.expire-date": "Expire date",
	"views.organization.components.service-accounts.panel-create-api-key.expire-in-hours": "Expire in hours",
	"views.organization.components.service-accounts.panel-create-api-key.failed-creating-a-new-api-key": "Failed creating a new API key",
	"views.organization.components.service-accounts.panel-create-api-key.field-expire-in-hours-must-be-a-number->-1": "Field Expire In Hours must be a number > 1",
	"views.organization.components.service-accounts.panel-create-api-key.key": "Key",
	"views.organization.components.service-accounts.panel-create-api-key.save-key-message": "Please, save in a secure place the SECRET. If you lost it, you can't recuperate it!",
	"views.organization.components.service-accounts.panel-create-api-key.secret": "Secret",
	"views.organization.components.service-accounts.panel-create-api-key.tooltip-expire-hours": "In how many hours after creation should this API key expire?",
	"views.organization.components.service-accounts.panel-create-service-account.create-service-account": "Create Service Account",
	"views.organization.components.service-accounts.panel-create-service-account.error-prefix": "Field Prefix should contain only alphanumeric characters with optional dashes",
	"views.organization.components.service-accounts.panel-create-service-account.failed-creating-service-account": "Failed creating a new service account",
	"views.organization.components.service-accounts.panel-create-service-account.password": "Password",
	"views.organization.components.service-accounts.panel-create-service-account.prefix": "Prefix",
	"views.organization.components.service-accounts.panel-create-service-account.service-account-created": "Service account created",
	"views.organization.components.service-accounts.panel-create-service-account.tooltip-password": "The password to log in with this service account",
	"views.organization.components.service-accounts.panel-create-service-account.tooltip-prefix": "A prefix used in the beginning of the username of the service account. This prefix has to be unique. The resulting service account username is in the form prefix{'@'}organizationId.svc.acct.wattsense.com",
	"views.organization.components.service-accounts.service-accounts-list.prefix": "Prefix",
	"views.organization.components.service-accounts.service-accounts-list.qtt-apikeys": "API Keys",
	"views.user-profile.profile.language": "Language",
	"views.user-profile.profile.name": "Name",
	"views.user-profile.profile.newpassword": "New password",
	"virtual-properties.calculate-consumption": "Calculation of consumption",
	"virtual-properties.calculate-consumption.description": "Value difference over a period of time.",
	"virtual-properties.calculate-multiple": "Calculation combining multiple properties",
	"virtual-properties.calculate-multiple.description": "Arithmetic operations between multiple properties.",
	"virtual-properties.checkbox-create-another-property-after-save": "Create another virtual property after this one",
	"virtual-properties.consumption-interval": "What is the consumption interval?",
	"virtual-properties.consumption-interval-tooltip": "Consumption is calculated for each interval using this formula: difference between the last known property value during the interval and the first known value during the same interval.",
	"virtual-properties.create-virtual-property": "Create a virtual property",
	"virtual-properties.data-transmition-frequency-interval-label": "Data transmission frequency or interval:",
	"virtual-properties.edit-virtual-property": "Edit virtual property",
	"virtual-properties.failed-deleting-property": "Failed deleting virtual property",
	"virtual-properties.failed-saving": "Failed saving virtual property",
	"virtual-properties.failed-saving-property": "Failed creating virtual property",
	"virtual-properties.failed-updating-property": "Failed updating virtual property",
	"virtual-properties.last-value-label": "Last Value:",
	"virtual-properties.other-calculation": "Other calculation",
	"virtual-properties.property-created": "Virtual property created",
	"virtual-properties.property-deleted": "Virtual property deleted",
	"virtual-properties.property-updated": "Virtual property updated",
	"virtual-properties.property-value": "Property value",
	"virtual-properties.received-at-label": "Received at:",
	"virtual-properties.search-by-name": "Search by name",
	"virtual-properties.select-properties-tooltip": "The consumption will be calculated based on the property selected.",
	"virtual-properties.text-empty-state": "Create new properties calculated from existing properties. Currently only available for metering calculations.",
	"virtual-properties.virtual-properties": "Virtual properties",
	"virtual-properties.what-would-you-like-to-do": "What would you like to do?",
	"virtual-property-cant-refresh": "Virtual property values are updated automatically. They cannot be refreshed manually.",
	"virtual-property-created-but-not-activated-yet-go-to-configuration-and-save": "The virtual property is created, but it is not activated yet. Go to the “Configuration” screen and click on “Save changes” to apply it.",
	"virtual-property.error.missing-value": "The calculation cannot be performed because at least one of the properties has not received a value.",
	"virtual-property.error.technical-issue": "The calculation failed due to a technical issue. <br> Technical details: {errorMessage}",
	"virtual-property.error.uncalculable": "The calculation cannot be performed. <br> Technical details: {errorMessage}",
	"virtual-property.error.wrong-type": "The calculation cannot be performed because the value of at least one of the properties is not a number.",
	"virtual-property.scaling-message-property-with-scaling": "The scaling applied to this property is not taken into account when calculating the virtual property. | Selected property scaling is not taken into account when calculating the virtual property.",
	"virtual-property.warn.scaling": "Take into account the scaling of selected properties.",
	"virtual-property.warn.scaling.no-properties.1": "Currently, no scaling is applied to the selected properties.",
	"virtual-property.warn.scaling.no-properties.2": "If this option is enabled, any future scaling will be taken into account.",
	"virtual-property.warn.scaling.properties": "Properties with scaling (ax+b):",
	"wait": "Wait",
	"wait-last-value": "Waiting for last value",
	"wait-until-receive-last-scan": "Wait until receives latest scan",
	"waiting-for-data-received": "Waiting for data",
	"waiting-for-pairing": "Waiting for pairing",
	"waiting-for-scan": "Waiting for scan",
	"waiting-for-the-hub": "Waiting for the @.lower:hub",
	"warning-message-gms-provider": "Our GSM provider is experiencing some issues. There might be some loss or delay when communicating with the cloud.",
	"was-not-received-by-box": "was not received by @.lower:box",
	"wattsense-headquarter": "Wattsense Headquarter",
	"we-will-try-for-another": "We will try for another",
	"webhooks": "Webhooks",
	"wednesday": "Wednesday",
	"week": "Week",
	"weekday": "Weekday",
	"weekly": "Weekly",
	"welcome": "Welcome",
	"what-configuration-from-equipment-for-box-communicate-with-it": "What is the configuration from the equipment so the @.lower:box can communicate with it?",
	"what-do-you-want-to-do-next": "What do you want to do next?",
	"what-would-like-to-do-next": "What would you like to do next?",
	"when-it-ends": "When it ends?",
	"which-connector-equipment-is-plugged": "Which connector is your equipment plugged?",
	"windows-instructions": "Windows instructions",
	"wmbus-dib": "Concatenated DIFs & DIFEs",
	"wmbus-physical-connector": "LoRaWAN radio antenna",
	"wmbus-vib": "Concatenated VIFs & VIFEs",
	"write": "Write",
	"write-function": "Write function",
	"write-only": "Write Only",
	"write-only-desc": "Only allow the values to be writen from the cloud (write only)",
	"wrong-file-extension": "Invalid file extension. Only .{format} files are accepted.",
	"wrong-file-format": "Your file format is not allowed.",
	"wrong-file-header": "File header in wrong format",
	"ws-data-table.no-records-to-display": "No records to display",
	"ws-data-table.rows-of-page-are-selected": "1 row is selected in total. | {qtt} rows are selected in total.",
	"ws-data-table.select-all-available-rows": "Select all available rows. | Select all available rows ({qtt})",
	"ws-form-treeselect.no-results": "No results",
	"ws-recipient.without-access.help-msg": "Enter recipient's e-mail address",
	"ws-recipient.without-access.placeholder": "ex: firstname.lastname{'@'}company.com",
	"x-days": "day | days",
	"x-equipments": "{n} equipment | {n} equipment",
	"x-equipments-added": "{n} equipment added | {n} equipment added",
	"x-other-equipments": "{count} other equipement",
	"x-other-properties": "{count} other properties",
	"x-properties-added": "{n} properties added | {n} properties added",
	"x-property-selected": "No property selected | {n} property selected | {n} properties selected",
	"x-years": "years | year | years",
	"xlsx-file-format": "Allowed format: .xlsx",
	"y-axis": "Y Axis",
	"year": "Year",
	"yearly": "Yearly",
	"yes": "Yes",
	"you-can-upload-a-file-clicking-here": "You can upload a file {0}",
	"you-dont-have-access-to-organization": "You don't have access to organization",
	"you-dont-have-tags": "You don't have any tags.",
	"your-email": "Your email",
	"your-email.placeholder": "john{'@'}doe.com",
	"your-equipment": "Your equipment",
	"your-phone": "Your phone number {optional}",
	"zero-organizations-found-with-term": "0 organization found with term {term}"
}